(() => {
  // src/neon-text-designer-reference/catalog.js?v=20261018-launch1
  var catalog = {
    "fonts": [
      {
        "name": "Alexa",
        "file": "assets/fonts/Alexa.ttf",
        "lineHeight": 0.94,
        "desktopSize": 80,
        "mobileSize": 75,
        "category": 2,
        "id": 10
      },
      {
        "name": "Barcelona",
        "file": "assets/fonts/Barcelona.ttf",
        "lineHeight": 1.6,
        "desktopSize": 70,
        "mobileSize": 55,
        "category": 1,
        "id": 15
      },
      {
        "name": "Bayview",
        "file": "assets/fonts/Bayview.ttf",
        "lineHeight": 0.9,
        "desktopSize": 105,
        "mobileSize": 90,
        "category": 1,
        "id": 11
      },
      {
        "name": "Amsterdam",
        "file": "assets/fonts/Amsterdam.ttf",
        "lineHeight": 1.05,
        "desktopSize": 88,
        "mobileSize": 65,
        "category": 2,
        "id": 12
      },
      {
        "name": "Florence",
        "file": "assets/fonts/Florence.ttf",
        "lineHeight": 1.1,
        "desktopSize": 83,
        "mobileSize": 76,
        "category": 1,
        "id": 52
      },
      {
        "name": "Greenworld",
        "file": "assets/fonts/Greenworld.ttf",
        "lineHeight": 0.84,
        "desktopSize": 100,
        "mobileSize": 93,
        "category": 1,
        "id": 13
      },
      {
        "name": "LazySunday",
        "file": "assets/fonts/LazySunday.ttf",
        "lineHeight": 1.65,
        "desktopSize": 64,
        "mobileSize": 54,
        "category": 1,
        "id": 53
      },
      {
        "name": "NewCursive",
        "file": "assets/fonts/NewCursive.ttf",
        "lineHeight": 0.87,
        "desktopSize": 100,
        "mobileSize": 91,
        "category": 1,
        "id": 14
      },
      {
        "name": "NottingHill",
        "file": "assets/fonts/NottingHill.ttf",
        "lineHeight": 1.15,
        "desktopSize": 75,
        "mobileSize": 71,
        "category": 1,
        "id": 58
      },
      {
        "name": "Olivia",
        "file": "assets/fonts/Olivia.ttf",
        "lineHeight": 1.27,
        "desktopSize": 80,
        "mobileSize": 65,
        "category": 1,
        "id": 59
      },
      {
        "name": "Vintage",
        "file": "assets/fonts/Vintage.ttf",
        "lineHeight": 1.1,
        "desktopSize": 75,
        "mobileSize": 72,
        "category": 1,
        "id": 16
      },
      {
        "name": "Venetian",
        "file": "assets/fonts/Venetian.ttf",
        "lineHeight": 1.2,
        "desktopSize": 88,
        "mobileSize": 80,
        "category": 1,
        "id": 46
      },
      {
        "name": "Weekender",
        "file": "assets/fonts/Weekender.ttf",
        "lineHeight": 1.56,
        "desktopSize": 60,
        "mobileSize": 56,
        "category": 1,
        "id": 65
      },
      {
        "name": "Amanda",
        "file": "assets/fonts/Amanda.ttf",
        "lineHeight": 1.25,
        "desktopSize": 82,
        "mobileSize": 75,
        "category": 1,
        "id": 17
      },
      {
        "name": "Austin",
        "file": "assets/fonts/Austin.ttf",
        "lineHeight": 0.83,
        "desktopSize": 120,
        "mobileSize": 116,
        "category": 2,
        "id": 21
      },
      {
        "name": "Beachfront",
        "file": "assets/fonts/Beachfront.ttf",
        "lineHeight": 1.2,
        "desktopSize": 73,
        "mobileSize": 65,
        "category": 0,
        "id": 26
      },
      {
        "name": "Chelsea",
        "file": "assets/fonts/Chelsea.ttf",
        "lineHeight": 1,
        "desktopSize": 110,
        "mobileSize": 98,
        "category": 2,
        "id": 19
      },
      {
        "name": "Freehand",
        "file": "assets/fonts/Freehand.ttf",
        "lineHeight": 0.97,
        "desktopSize": 97,
        "mobileSize": 89,
        "category": 2,
        "id": 23
      },
      {
        "name": "Freespirit",
        "file": "assets/fonts/Freespirit.ttf",
        "lineHeight": 1.8,
        "desktopSize": 52,
        "mobileSize": 50,
        "category": 2,
        "id": 18
      },
      {
        "name": "LoveNote",
        "file": "assets/fonts/LoveNote.ttf",
        "lineHeight": 1,
        "desktopSize": 80,
        "mobileSize": 80,
        "category": 1,
        "id": 24
      },
      {
        "name": "Manchester",
        "file": "assets/fonts/Manchester.ttf",
        "lineHeight": 0.92,
        "desktopSize": 101,
        "mobileSize": 98,
        "category": 2,
        "id": 55
      },
      {
        "name": "Neonscript",
        "file": "assets/fonts/Neonscript.ttf",
        "lineHeight": 1.15,
        "desktopSize": 95,
        "mobileSize": 85,
        "category": 2,
        "id": 22
      },
      {
        "name": "Northshore",
        "file": "assets/fonts/Northshore.ttf",
        "lineHeight": 1.25,
        "desktopSize": 102,
        "mobileSize": 110,
        "category": 2,
        "id": 25
      },
      {
        "name": "Photogenic",
        "file": "assets/fonts/Photogenic.ttf",
        "lineHeight": 1.2,
        "desktopSize": 93,
        "mobileSize": 78,
        "category": 2,
        "id": 47
      },
      {
        "name": "Royalty",
        "file": "assets/fonts/Royalty.ttf",
        "lineHeight": 1.3,
        "desktopSize": 68,
        "mobileSize": 56,
        "category": 2,
        "id": 27
      },
      {
        "name": "Rocket",
        "file": "assets/fonts/Rocket.ttf",
        "lineHeight": 1.6,
        "desktopSize": 50,
        "mobileSize": 45,
        "category": 2,
        "id": 28
      },
      {
        "name": "Signature",
        "file": "assets/fonts/Signature.ttf",
        "lineHeight": 0.95,
        "desktopSize": 100,
        "mobileSize": 85,
        "category": 1,
        "id": 49
      },
      {
        "name": "Sorrento",
        "file": "assets/fonts/Sorrento.ttf",
        "lineHeight": 1.5,
        "desktopSize": 68,
        "mobileSize": 59,
        "category": 2,
        "id": 20
      },
      {
        "name": "WildScript",
        "file": "assets/fonts/WildScript.ttf",
        "lineHeight": 1.05,
        "desktopSize": 115,
        "mobileSize": 110,
        "category": 2,
        "id": 29
      },
      {
        "name": "Avante",
        "file": "assets/fonts/Avante.ttf",
        "lineHeight": 1,
        "desktopSize": 68,
        "mobileSize": 58,
        "category": 0,
        "id": 30
      },
      {
        "name": "Buttercup",
        "file": "assets/fonts/Buttercup.ttf",
        "lineHeight": 0.9,
        "desktopSize": 125,
        "mobileSize": 96,
        "category": 0,
        "id": 35
      },
      {
        "name": "ClassicType",
        "file": "assets/fonts/ClassicType.ttf",
        "lineHeight": 1,
        "desktopSize": 62,
        "mobileSize": 55,
        "category": 0,
        "id": 33
      },
      {
        "name": "LosAngeles",
        "file": "assets/fonts/LosAngeles.ttf",
        "lineHeight": 1,
        "desktopSize": 90,
        "mobileSize": 75,
        "category": 0,
        "id": 51
      },
      {
        "name": "Melbourne",
        "file": "assets/fonts/Melbourne.ttf",
        "lineHeight": 1,
        "desktopSize": 70,
        "mobileSize": 62,
        "category": 0,
        "id": 36
      },
      {
        "name": "NeoTokyo",
        "file": "assets/fonts/NeoTokyo.ttf",
        "lineHeight": 1.05,
        "desktopSize": 73,
        "mobileSize": 61,
        "category": 1,
        "id": 37
      },
      {
        "name": "Monaco",
        "file": "assets/fonts/Monaco.ttf",
        "lineHeight": 0.92,
        "desktopSize": 70,
        "mobileSize": 58,
        "category": 0,
        "id": 31
      },
      {
        "name": "SanDiego",
        "file": "assets/fonts/SanDiego.ttf",
        "lineHeight": 1.05,
        "desktopSize": 70,
        "mobileSize": 61,
        "category": 2,
        "id": 61
      },
      {
        "name": "Simplicity",
        "file": "assets/fonts/Simplicity.ttf",
        "lineHeight": 1,
        "desktopSize": 115,
        "mobileSize": 110,
        "category": 0,
        "id": 62
      },
      {
        "name": "Typewriter",
        "file": "assets/fonts/Typewriter.ttf",
        "lineHeight": 0.92,
        "desktopSize": 66,
        "mobileSize": 60,
        "category": 0,
        "id": 34
      },
      {
        "name": "Waikiki",
        "file": "assets/fonts/Waikiki.ttf",
        "lineHeight": 0.87,
        "desktopSize": 64,
        "mobileSize": 50,
        "category": 0,
        "id": 32
      },
      {
        "name": "Bellview",
        "file": "assets/fonts/Bellview.ttf",
        "lineHeight": 0.88,
        "desktopSize": 100,
        "mobileSize": 88,
        "category": 3,
        "id": 50
      },
      {
        "name": "Loveneon",
        "file": "assets/fonts/Loveneon.ttf",
        "lineHeight": 0.95,
        "desktopSize": 60,
        "mobileSize": 54,
        "category": 3,
        "id": 38
      },
      {
        "name": "Majorca",
        "file": "assets/fonts/Majorca.ttf",
        "lineHeight": 1.13,
        "desktopSize": 62,
        "mobileSize": 57,
        "category": 3,
        "id": 54
      },
      {
        "name": "Manhattan",
        "file": "assets/fonts/Manhattan.ttf",
        "lineHeight": 1.05,
        "desktopSize": 80,
        "mobileSize": 79,
        "category": 3,
        "id": 56
      },
      {
        "name": "Marquee",
        "file": "assets/fonts/Marquee.ttf",
        "lineHeight": 1.1,
        "desktopSize": 90,
        "mobileSize": 72,
        "category": 3,
        "id": 39
      },
      {
        "name": "Mayfair",
        "file": "assets/fonts/Mayfair.ttf",
        "lineHeight": 0.95,
        "desktopSize": 76,
        "mobileSize": 66,
        "category": 3,
        "id": 40
      },
      {
        "name": "Milan",
        "file": "assets/fonts/Milan.ttf",
        "lineHeight": 1.05,
        "desktopSize": 70,
        "mobileSize": 65,
        "category": 2,
        "id": 57
      },
      {
        "name": "NeonGlow",
        "file": "assets/fonts/NeonGlow.ttf",
        "lineHeight": 1,
        "desktopSize": 75,
        "mobileSize": 60,
        "category": 3,
        "id": 41
      },
      {
        "name": "NeonLite",
        "file": "assets/fonts/NeonLite.ttf",
        "lineHeight": 0.98,
        "desktopSize": 66,
        "mobileSize": 60,
        "category": 1,
        "id": 42
      },
      {
        "name": "Neontrace",
        "file": "assets/fonts/Neontrace.ttf",
        "lineHeight": 1.05,
        "desktopSize": 62,
        "mobileSize": 50,
        "category": 2,
        "id": 43
      },
      {
        "name": "Nevada",
        "file": "assets/fonts/Nevada.ttf",
        "lineHeight": 0.93,
        "desktopSize": 95,
        "mobileSize": 84,
        "category": 3,
        "id": 44
      },
      {
        "name": "SciFi",
        "file": "assets/fonts/SciFi.ttf",
        "lineHeight": 1.16,
        "desktopSize": 53,
        "mobileSize": 52,
        "category": 3,
        "id": 45
      },
      {
        "name": "Rockstar",
        "file": "assets/fonts/Rockstar.ttf",
        "lineHeight": 1.16,
        "desktopSize": 58,
        "mobileSize": 52,
        "category": 3,
        "id": 60
      },
      {
        "name": "Submarine",
        "file": "assets/fonts/Submarine.ttf",
        "lineHeight": 1.03,
        "desktopSize": 95,
        "mobileSize": 88,
        "category": 3,
        "id": 63
      },
      {
        "name": "Vancouver",
        "file": "assets/fonts/Vancouver.ttf",
        "lineHeight": 1,
        "desktopSize": 80,
        "mobileSize": 73,
        "category": 3,
        "id": 64
      },
      {
        "name": "Westcoast",
        "file": "assets/fonts/Westcoast.ttf",
        "lineHeight": 1.27,
        "desktopSize": 80,
        "mobileSize": 71,
        "category": 3,
        "id": 66
      }
    ],
    "colors": [
      {
        "name": "Warm White",
        "id": "10",
        "hex": "#fffdcf",
        "offHex": "#f4f4f4",
        "coreHex": "#fefff5",
        "glowHex": "#fffdde",
        "shadowColors": [
          "#d9d95c",
          "#fffdde"
        ],
        "cssShadow": "#d9d95c  0px 0px 3px, \n    rgba(0, 0, 0,0.1) 1px 1px 1px,  \n    #fffdde 0px 0px 6px,\n    #fffdde 0px 0px 10px, \n    #fffdde  0px 0px 13px, \n    #fffdde 0px 0px 16px, \n    #fffdde 0px 0px 20px, \n    #fffdde 0px 0px 24px, \n    #fffdde 0px 0px 28px, \n    #fffdde 0px 0px 32px,  \n    #fffdde 0px 0px 40px",
        "description": "Warm white is a very popular natural-feeling white. The tube is white when off."
      },
      {
        "name": "White",
        "id": "20",
        "hex": "#e1e3e6",
        "offHex": "#f4f4f4",
        "coreHex": "#FFFFFF",
        "glowHex": "#FFFFFF",
        "shadowColors": [
          "#a2b6e7",
          "#FFFFFF"
        ],
        "cssShadow": "#a2b6e7  0px 0px 3px, \n    rgba(0, 0, 0,0.1) 1px 1px 1px,  \n    #FFFFFF 0px 0px 6px,\n    #FFFFFF 0px 0px 10px, \n    #FFFFFF 0px 0px 13px, \n    #FFFFFF 0px 0px 16px, \n    #FFFFFF 0px 0px 20px, \n    #FFFFFF 0px 0px 24px, \n    #FFFFFF 0px 0px 28px, \n    #FFFFFF 0px 0px 32px,  \n    #FFFFFF 0px 0px 40px",
        "description": "White is a cooler, brighter white. The tube is white when off."
      },
      {
        "name": "Lemon Yellow",
        "id": "30",
        "hex": "#fff97c",
        "offHex": "#fff97c",
        "coreHex": "#fffee1",
        "glowHex": "#fffb87",
        "shadowColors": [
          "#caca00",
          "#fffb87"
        ],
        "cssShadow": "#caca00  0px 0px 3px,  			\n    rgba(0, 0, 0,0.2) 1px 1px 1px, 		        \n    #fffb87 0px 0px 6px, \n    #fffb87 0px 0px 10px, \n    #fffb87 0px 0px 13px, \n    #fffb87 0px 0px 16px, \n    #fffb87  0px 0px 20px, \n    #fffb87 0px 0px 24px, \n    #fffb87 0px 0px 28px, \n    #fffb87 0px 0px 32px,\n    #fffb87 0px 0px 40px",
        "description": "Lemon Yellow is a very bright, eye-catching yellow. The tube is yellow when off."
      },
      {
        "name": "Golden Yellow",
        "id": "40",
        "hex": "#ffca1c",
        "offHex": "#ffca1c",
        "coreHex": "#fff5d6",
        "glowHex": "#ffca1c",
        "shadowColors": [
          "#ce9e00",
          "#ffca1c"
        ],
        "cssShadow": "#ce9e00  0px 0px 3px,      \n    rgba(0, 0, 0,0.3) 1px 1px 1px, 			       \n    #ffca1c 0px 0px 6px, \n    #ffca1c 0px 0px 10px, \n    #ffca1c 0px 0px 13px, \n    #ffca1c 0px 0px 16px, \n    #ffca1c 0px 0px 20px, \n    #ffca1c 0px 0px 24px, \n    #ffca1c 0px 0px 28px, \n    #ffca1c 0px 0px 32px,\n    #ffca1c 0px 0px 40px",
        "description": "Golden Yellow is a bold, rich yellow. The tube is yellow when off."
      },
      {
        "name": "Orange",
        "id": "50",
        "hex": "#ff8d02",
        "offHex": "#ff8d02",
        "coreHex": "#ffdcb2",
        "glowHex": "#ff981a",
        "shadowColors": [
          "#c16a01",
          "#ff981a"
        ],
        "cssShadow": "#c16a01  0px 0px 3px,   \n    rgba(0, 0, 0,0.3) 1px 1px 1px,		 \n    #ff981a 0px 0px 6px, \n    #ff981a 0px 0px 10px, \n    #ff981a 0px 0px 13px, \n    #ff981a 0px 0px 16px, \n    #ff981a 0px 0px 20px, \n    #ff981a 0px 0px 24px, \n    #ff981a 0px 0px 28px, \n    #ff981a 0px 0px 32px,\n    #ff981a 0px 0px 40px",
        "description": "A bright, eye-catching orange. The tube is orange when off."
      },
      {
        "name": "Light Red",
        "id": "60",
        "hex": "#ff7575",
        "offHex": "#f4f4f4",
        "coreHex": "#ffd1d1",
        "glowHex": "#ff7a7a",
        "shadowColors": [
          "#cf0000",
          "#ff7a7a"
        ],
        "cssShadow": "#cf0000  0px 0px 3px,  \n    rgba(0, 0, 0,0.3) 1px 1px 1px,					\n    #ff7a7a 0px 0px 6px, \n    #ff7a7a 0px 0px 10px, \n    #ff7a7a 0px 0px 13px, \n    #ff7a7a 0px 0px 16px, \n    #ff7a7a 0px 0px 20px, \n    #ff7a7a 0px 0px 24px, \n    #ff7a7a 0px 0px 28px, \n    #ff7a7a 0px 0px 32px,\n    #ff7a7a 0px 0px 40px",
        "description": "Light Red is a vivid and sophisticated brighter shade of red. The tube is white when off."
      },
      {
        "name": "Red",
        "id": "70",
        "hex": "#ff2a4d",
        "offHex": "#ff2a4d",
        "coreHex": "#ffb7b7",
        "glowHex": "#ff2a4d",
        "shadowColors": [
          "#bb0000",
          "#ff2a4d"
        ],
        "cssShadow": "#bb0000  0px 0px 3px,    \n    rgba(0, 0, 0,0.4) 1px 1px 1px,				\n    #ff2a4d 0px 0px 6px, \n    #ff2a4d 0px 0px 10px, \n    #ff2a4d 0px 0px 13px, \n    #ff2a4d 0px 0px 16px, \n    #ff2a4d 0px 0px 20px, \n    #ff2a4d 0px 0px 24px, \n    #ff2a4d 0px 0px 28px, \n    #ff2a4d 0px 0px 32px,\n    #ff2a4d 0px 0px 40px",
        "description": "A gorgeous 'Candy Apple' red. The tube is red when off."
      },
      {
        "name": "Pink",
        "id": "90",
        "hex": "#ff90ff",
        "offHex": "#f4f4f4",
        "coreHex": "#ffe9ff",
        "glowHex": "#ffa0f7",
        "shadowColors": [
          "#da2ada",
          "#ffa0f7"
        ],
        "cssShadow": "#da2ada  0px 0px 3px,  \n    rgba(0, 0, 0,0.3) 1px 1px 1px,		 				\n    #ffa0f7 0px 0px 6px, \n    #ffa0f7 0px 0px 10px, \n    #ffa0f7 0px 0px 13px, \n    #ffa0f7 0px 0px 16px, \n    #ffa0f7 0px 0px 20px, \n    #ffa0f7 0px 0px 24px, \n    #ffa0f7 0px 0px 28px, \n    #ffa0f7 0px 0px 32px,\n    #ffa0f7 0px 0px 40px",
        "description": "Bright, eye-catching neon Pink remains an extremely popular choice. The tube is white when off."
      },
      {
        "name": "Cotton Candy",
        "id": "80",
        "hex": "#ff80bf",
        "offHex": "#ff80bf",
        "coreHex": "#ffe0ef",
        "glowHex": "#ff80bf",
        "shadowColors": [
          "#d93084",
          "#ff80bf"
        ],
        "cssShadow": "#d93084  0px 0px 3px,  \n    rgba(0, 0, 0,0.3) 1px 1px 1px,			       \n    #ff80bf 0px 0px 6px, \n    #ff80bf 0px 0px 10px, \n    #ff80bf 0px 0px 13px, \n    #ff80bf 0px 0px 16px, \n    #ff80bf 0px 0px 20px, \n    #ff80bf 0px 0px 24px, \n    #ff80bf 0px 0px 28px, \n    #ff80bf 0px 0px 32px,\n    #ff80bf 0px 0px 40px",
        "description": "Soft and pink as Cotton Candy. The tube is light pink when off."
      },
      {
        "name": "Deep Pink",
        "id": "100",
        "hex": "#ff5ce8",
        "offHex": "#ff5ce8",
        "coreHex": "#ffa3f7",
        "glowHex": "#ff5ad2",
        "shadowColors": [
          "#d6009c",
          "#ff5ad2"
        ],
        "cssShadow": "#d6009c 0px 0px 3px,\n    rgba(0, 0, 0,0.3) 1px 1px 1px,					\n    #ff5ad2 0px 0px 6px, \n    #ff5ad2 0px 0px 10px, \n    #ff5ad2 0px 0px 13px, \n    #ff5ad2 0px 0px 16px, \n    #ff5ad2 0px 0px 20px, \n    #ff5ad2 0px 0px 24px, \n    #ff5ad2 0px 0px 28px, \n    #ff5ad2 0px 0px 32px,\n    #ff5ad2 0px 0px 40px",
        "description": "A popular stunning deep pink with a vivid glow. The tube is pink when off."
      },
      {
        "name": "Purple",
        "id": "110",
        "hex": "#8c59ff",
        "offHex": "#f4f4f4",
        "coreHex": "#f0e3ff",
        "glowHex": "#c392ff",
        "shadowColors": [
          "#5d00cf",
          "#c392ff"
        ],
        "cssShadow": "#5d00cf  0px 0px 3px, \n    rgba(0, 0, 0,0.2) 1px 1px 1px,					\n    #c392ff 0px 0px 6px, \n    #c392ff 0px 0px 10px, \n    #c392ff 0px 0px 13px, \n    #c392ff 0px 0px 16px, \n    #c392ff 0px 0px 20px, \n    #c392ff 0px 0px 24px, \n    #c392ff 0px 0px 28px, \n    #c392ff 0px 0px 32px,\n    #c392ff 0px 0px 40px",
        "description": "A popular stylish purple. The tube is white when off."
      },
      {
        "name": "Deep Blue",
        "id": "120",
        "hex": "#0274fc",
        "offHex": "#0274fc",
        "coreHex": "#8aaeff",
        "glowHex": "#4b4bff",
        "shadowColors": [
          "#0000bd",
          "#4b4bff"
        ],
        "cssShadow": "#0000bd  0px 0px 3px,	\n    rgba(0, 0, 0,0.4) 1px 1px 1px,					\n    #4b4bff 0px 0px 6px, \n    #4b4bff 0px 0px 10px, \n    #4b4bff 0px 0px 13px, \n    #4b4bff 0px 0px 16px, \n    #4b4bff 0px 0px 20px, \n    #4b4bff 0px 0px 24px, \n    #4b4bff 0px 0px 28px, \n    #4b4bff 0px 0px 32px,\n    #4b4bff 0px 0px 40px",
        "description": "A bold, darker blue. The tube is Blue when off"
      },
      {
        "name": "Electric Blue",
        "id": "130",
        "hex": "#63aaff",
        "offHex": "#f4f4f4",
        "coreHex": "#c9eaff",
        "glowHex": "#54bdff",
        "shadowColors": [
          "#0064dd",
          "#54bdff"
        ],
        "cssShadow": "#0064dd  0px 0px 3px, 		\n    rgba(0, 0, 0,0.2) 1px 1px 1px,	\n    #54bdff 0px 0px 6px, \n    #54bdff 0px 0px 10px, \n    #54bdff 0px 0px 13px, \n    #54bdff 0px 0px 16px, \n    #54bdff 0px 0px 20px, \n    #54bdff 0px 0px 24px, \n    #54bdff 0px 0px 28px, \n    #54bdff 0px 0px 32px,\n    #54bdff 0px 0px 40px",
        "description": "A fantastic bright blue. The tube is White when off"
      },
      {
        "name": "Ice Blue",
        "id": "150",
        "hex": "#90dcff",
        "offHex": "#f4f4f4",
        "coreHex": "#e9fcff",
        "glowHex": "#72e0ff",
        "shadowColors": [
          "#00a9d9",
          "#72e0ff"
        ],
        "cssShadow": "#00a9d9  0px 0px 3px,  				\n    rgba(0, 0, 0,0.2) 1px 1px 1px,\n    #72e0ff 0px 0px 6px, \n    #72e0ff 0px 0px 10px, \n    #72e0ff 0px 0px 13px, \n    #72e0ff 0px 0px 16px, \n    #72e0ff 0px 0px 20px, \n    #72e0ff 0px 0px 24px, \n    #72e0ff 0px 0px 28px, \n    #72e0ff 0px 0px 32px,\n    #72e0ff 0px 0px 40px",
        "description": "A very bright, eye-catching blue. The tube is white when off."
      },
      {
        "name": "Tropical Blue",
        "id": "140",
        "hex": "#24b7de",
        "offHex": "#24b7de",
        "coreHex": "#ccfaff",
        "glowHex": "#39c9ef",
        "shadowColors": [
          "#00a7d3",
          "#39c9ef"
        ],
        "cssShadow": "#00a7d3  0px 0px 3px,  		\n    rgba(0, 0, 0,0.2) 1px 1px 1px,				\n    #39c9ef 0px 0px 6px, \n    #39c9ef 0px 0px 10px, \n    #39c9ef 0px 0px 13px, \n    #39c9ef 0px 0px 16px, \n    #39c9ef 0px 0px 20px, \n    #39c9ef 0px 0px 24px, \n    #39c9ef 0px 0px 28px, \n    #39c9ef 0px 0px 32px,\n    #39c9ef 0px 0px 40px",
        "description": "A gorgeous blue that glows like a tropical lagoon. The tube is light blue when off."
      },
      {
        "name": "Mint",
        "id": "160",
        "hex": "#80ffd9",
        "offHex": "#80ffd9",
        "coreHex": "#edfffa",
        "glowHex": "#d5fff1",
        "shadowColors": [
          "#40d1a1",
          "#d5fff1"
        ],
        "cssShadow": "#40d1a1  0px 0px 3px, \n    rgba(0, 0, 0,0.1) 1px 1px 1px,				\n    #d5fff1 0px 0px 6px, \n    #d5fff1 0px 0px 10px, \n    #d5fff1 0px 0px 13px, \n    #d5fff1 0px 0px 16px, \n    #d5fff1 0px 0px 20px, \n    #d5fff1 0px 0px 24px, \n    #d5fff1 0px 0px 28px, \n    #d5fff1 0px 0px 32px,\n    #d5fff1 0px 0px 40px",
        "description": "A fresh, minty green. The tube is mint when off."
      },
      {
        "name": "Green",
        "id": "170",
        "hex": "#85ffaa",
        "offHex": "#f4f4f4",
        "coreHex": "#ccffdb",
        "glowHex": "#44ff7c",
        "shadowColors": [
          "#00a531",
          "#44ff7c"
        ],
        "cssShadow": "#00a531  0px 0px 3px,    				\n    rgba(0, 0, 0,0.2) 1px 1px 1px,\n    #44ff7c 0px 0px 6px, \n    #44ff7c 0px 0px 10px, \n    #44ff7c 0px 0px 13px, \n    #44ff7c 0px 0px 16px, \n    #44ff7c 0px 0px 20px, \n    #44ff7c 0px 0px 24px, \n    #44ff7c 0px 0px 28px, \n    #44ff7c 0px 0px 32px,\n    #44ff7c 0px 0px 40px",
        "description": "A great-looking, very bright green. The tube is white when off."
      },
      {
        "name": "Deep Green",
        "id": "180",
        "hex": "#0bd748",
        "offHex": "#0bd748",
        "coreHex": "#5ffd5f",
        "glowHex": "#3cd65b",
        "shadowColors": [
          "#007004",
          "#3cd65b"
        ],
        "cssShadow": "#007004  0px 0px 3px, 				\n    rgba(0, 0, 0,0.3) 1px 1px 1px,  \n    #3cd65b 0px 0px 6px, \n    #3cd65b 0px 0px 10px, \n    #3cd65b 0px 0px 13px, \n    #3cd65b 0px 0px 16px, \n    #3cd65b 0px 0px 20px, \n    #3cd65b 0px 0px 24px, \n    #3cd65b 0px 0px 28px, \n    #3cd65b 0px 0px 32px,\n    #3cd65b 0px 0px 40px",
        "description": "A darker green that is still very eye-catching. The tube is green when off."
      }
    ],
    "backgrounds": [
      {
        "id": 1,
        "name": "Home",
        "file": "assets/backgrounds/ens-home.webp",
        "thumbnail": "assets/background-thumbnails/ens-home.webp"
      },
      {
        "id": 2,
        "name": "Office",
        "file": "assets/backgrounds/ens-office.webp",
        "thumbnail": "assets/background-thumbnails/ens-office.webp"
      },
      {
        "id": 3,
        "name": "Shop",
        "file": "assets/backgrounds/ens-shop.webp",
        "thumbnail": "assets/background-thumbnails/ens-shop.webp"
      },
      {
        "id": 4,
        "name": "Event",
        "file": "assets/backgrounds/ens-event.webp",
        "thumbnail": "assets/background-thumbnails/ens-event.webp"
      }
    ],
    "dynamicEffects": [
      {
        "id": "62",
        "name": "Rainbow Flow",
        "category": "Flow Effects",
        "desc": "Smooth rainbow colors flow continuously across the sign",
        "type": "flow",
        "palette": [
          "#ff2a4d",
          "#ff8d02",
          "#fff97c",
          "#85ffaa",
          "#00ffff",
          "#0274fc",
          "#8c59ff"
        ]
      },
      {
        "id": "55",
        "name": "Twilight Flow",
        "category": "Flow Effects",
        "desc": "Dreamy blue, purple, and yellow colors drift smoothly",
        "type": "flow",
        "palette": [
          "#0274fc",
          "#8c59ff",
          "#fff97c"
        ]
      },
      {
        "id": "56",
        "name": "Festive Flow",
        "category": "Flow Effects",
        "desc": "Red, green, and white colors flow for a festive look",
        "type": "flow",
        "palette": [
          "#ff2a4d",
          "#85ffaa",
          "#f2f5f8"
        ]
      },
      {
        "id": "57",
        "name": "Lava Flow",
        "category": "Flow Effects",
        "desc": "Warm orange and yellow colors flow like molten lava",
        "type": "flow",
        "palette": [
          "#ff8d02",
          "#fff97c",
          "#ff2a4d"
        ]
      },
      {
        "id": "58",
        "name": "Valentine Flow",
        "category": "Flow Effects",
        "desc": "Romantic red and pink colors drift smoothly",
        "type": "flow",
        "palette": [
          "#ff2a4d",
          "#ff90ff"
        ]
      },
      {
        "id": "59",
        "name": "Candy Flow",
        "category": "Flow Effects",
        "desc": "Sweet red and white colors wave smoothly",
        "type": "flow",
        "palette": [
          "#ff2a4d",
          "#f2f5f8"
        ]
      },
      {
        "id": "60",
        "name": "Ocean Flow",
        "category": "Flow Effects",
        "desc": "Calm blue and white waves flow gently",
        "type": "flow",
        "palette": [
          "#0274fc",
          "#f2f5f8"
        ]
      },
      {
        "id": "61",
        "name": "Forest Flow",
        "category": "Flow Effects",
        "desc": "Natural green and white colors drift peacefully",
        "type": "flow",
        "palette": [
          "#85ffaa",
          "#f2f5f8"
        ]
      },
      {
        "id": "109",
        "name": "Vivid Rainbow",
        "category": "Flow Effects",
        "desc": "Bright rainbow colors with distinct transitions",
        "type": "flow",
        "palette": [
          "#fff97c",
          "#ff90ff",
          "#00ffff",
          "#f2f5f8",
          "#ff2a4d",
          "#85ffaa",
          "#0274fc"
        ]
      },
      {
        "id": "11",
        "name": "Smooth Color Change",
        "category": "Color Cycling",
        "desc": "All letters smoothly fade between colors including pink and orange",
        "type": "smooth-cycle"
      },
      {
        "id": "9",
        "name": "7-Color Jump",
        "category": "Color Cycling",
        "desc": "Sign snaps crisply between all seven vibrant colors",
        "type": "color-jump",
        "palette": [
          "#ff2a4d",
          "#fff97c",
          "#85ffaa",
          "#00ffff",
          "#0274fc",
          "#8c59ff",
          "#f2f5f8"
        ]
      },
      {
        "id": "8",
        "name": "3-Color Jump",
        "category": "Color Cycling",
        "desc": "Sign alternates between blue, green, and red",
        "type": "color-jump",
        "palette": [
          "#0274fc",
          "#85ffaa",
          "#ff2a4d"
        ]
      },
      {
        "id": "10",
        "name": "7-Color Flash",
        "category": "Color Cycling",
        "desc": "Rapid strobe through all colors with off between",
        "type": "color-flash"
      },
      {
        "id": "47",
        "name": "Christmas Chase",
        "category": "Chase Effects",
        "desc": "Festive red and green colors chase across the sign",
        "type": "chase",
        "palette": [
          "#ff2a4d",
          "#85ffaa"
        ]
      },
      {
        "id": "45",
        "name": "Red & Blue Chase",
        "category": "Chase Effects",
        "desc": "Classic red and blue colors chase across the sign",
        "type": "chase",
        "palette": [
          "#ff2a4d",
          "#0274fc"
        ]
      },
      {
        "id": "42",
        "name": "Ice Chase",
        "category": "Chase Effects",
        "desc": "Cool blue and white colors chase across the sign",
        "type": "chase",
        "palette": [
          "#0274fc",
          "#f2f5f8"
        ]
      },
      {
        "id": "117",
        "name": "Rainbow Double Trail",
        "category": "Special Effects",
        "desc": "Two colors flow together, changing pairs every few seconds",
        "type": "double-trail"
      },
      {
        "id": "118",
        "name": "Opening Brush Stroke",
        "category": "Special Effects",
        "desc": "Colors paint across from the edges toward center",
        "type": "brush-open"
      },
      {
        "id": "119",
        "name": "Closing Brush Stroke",
        "category": "Special Effects",
        "desc": "Colors paint from center outward to the edges",
        "type": "brush-close"
      },
      {
        "id": "1",
        "name": "Static Red",
        "category": "Static Colors",
        "desc": "Solid red glow",
        "type": "static",
        "color": "#ff2a4d"
      },
      {
        "id": "2",
        "name": "Static Green",
        "category": "Static Colors",
        "desc": "Solid green glow",
        "type": "static",
        "color": "#85ffaa"
      },
      {
        "id": "3",
        "name": "Static Blue",
        "category": "Static Colors",
        "desc": "Solid blue glow",
        "type": "static",
        "color": "#0274fc"
      },
      {
        "id": "4",
        "name": "Static Yellow",
        "category": "Static Colors",
        "desc": "Solid yellow glow",
        "type": "static",
        "color": "#fff97c"
      },
      {
        "id": "5",
        "name": "Static Purple",
        "category": "Static Colors",
        "desc": "Solid purple glow",
        "type": "static",
        "color": "#8c59ff"
      },
      {
        "id": "6",
        "name": "Static Cyan",
        "category": "Static Colors",
        "desc": "Solid cyan glow",
        "type": "static",
        "color": "#00ffff"
      },
      {
        "id": "7",
        "name": "Static White",
        "category": "Static Colors",
        "desc": "Solid white glow",
        "type": "static",
        "color": "#f2f5f8"
      }
    ],
    "rgbEffects": [
      {
        "id": "color-change-mode",
        "name": "Color Change Mode",
        "type": "smooth-cycle",
        "palette": [
          "#f2f5f8",
          "#fff97c",
          "#ff8d02",
          "#ff2a4d",
          "#ff90ff",
          "#8c59ff",
          "#0274fc",
          "#63aaff",
          "#90dcff",
          "#24b7de",
          "#80ffd9"
        ]
      },
      {
        "id": "0",
        "name": "White",
        "hex": "#f2f5f8",
        "type": "static"
      },
      {
        "id": "1",
        "name": "Lemon Yellow",
        "hex": "#fff97c",
        "type": "static"
      },
      {
        "id": "2",
        "name": "Orange",
        "hex": "#ff8d02",
        "type": "static"
      },
      {
        "id": "3",
        "name": "Red",
        "hex": "#ff2a4d",
        "type": "static"
      },
      {
        "id": "4",
        "name": "Pink",
        "hex": "#ff90ff",
        "type": "static"
      },
      {
        "id": "5",
        "name": "Purple",
        "hex": "#8c59ff",
        "type": "static"
      },
      {
        "id": "6",
        "name": "Deep Blue",
        "hex": "#0274fc",
        "type": "static"
      },
      {
        "id": "7",
        "name": "Electric Blue",
        "hex": "#63aaff",
        "type": "static"
      },
      {
        "id": "8",
        "name": "Ice Blue",
        "hex": "#90dcff",
        "type": "static"
      },
      {
        "id": "9",
        "name": "Tropical Blue",
        "hex": "#24b7de",
        "type": "static"
      },
      {
        "id": "10",
        "name": "Mint",
        "hex": "#80ffd9",
        "type": "static"
      }
    ],
    "sizes": [
      {
        "id": "xxs",
        "name": "Mini",
        "merchantId": 8,
        "exampleWidthCm": 42,
        "exampleWidthIn": 16.5,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "xs",
        "name": "Extra Small",
        "merchantId": 7,
        "exampleWidthCm": 50,
        "exampleWidthIn": 20,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "s",
        "name": "Small",
        "merchantId": 1,
        "exampleWidthCm": 62,
        "exampleWidthIn": 25,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "m",
        "name": "Medium",
        "merchantId": 2,
        "exampleWidthCm": 76,
        "exampleWidthIn": 30,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "l",
        "name": "Large",
        "merchantId": 3,
        "exampleWidthCm": 96,
        "exampleWidthIn": 38,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "xl",
        "name": "X Large",
        "merchantId": 4,
        "exampleWidthCm": 120,
        "exampleWidthIn": 48,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "xxl",
        "name": "XX Large",
        "merchantId": 5,
        "exampleWidthCm": 162,
        "exampleWidthIn": 64,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      },
      {
        "id": "su",
        "name": "Supersized",
        "merchantId": 6,
        "exampleWidthCm": 216,
        "exampleWidthIn": 85,
        "note": "Widths shown in capture for Your Text, Barcelona; computeQuote supplies design-dependent values"
      }
    ],
    "backboards": [
      {
        "id": "1",
        "name": "Cut Around",
        "image": "assets/examples/backboardaround.png"
      },
      {
        "id": "2",
        "name": "Rectangle",
        "image": "assets/examples/backboardrectangle.png"
      },
      {
        "id": "3",
        "name": "Cut-To-Letter",
        "image": "assets/examples/backboardletter.png"
      },
      {
        "id": "9",
        "name": "Naked Neon",
        "image": "assets/examples/backboardnaked.png"
      },
      {
        "id": "4",
        "name": "Acrylic Stand",
        "image": "assets/examples/backboardfreestand.png"
      },
      {
        "id": "6",
        "name": "Open Box",
        "image": "assets/examples/backboardopenbox.png"
      }
    ],
    "backboardColors": [
      {
        "id": "clear",
        "name": "Clear",
        "hex": "transparent"
      },
      {
        "id": "white",
        "name": "Glossy White",
        "hex": "#f5f4f1"
      },
      {
        "id": "black",
        "name": "Glossy Black",
        "hex": "#181819"
      },
      {
        "id": "silver",
        "name": "Silver",
        "hex": "#c5c7cb"
      },
      {
        "id": "gold",
        "name": "Gold",
        "hex": "#c6a855"
      }
    ],
    "mounting": [
      {
        "id": "silver",
        "name": "Silver Wall Mounting Kit",
        "finish": "silver"
      },
      {
        "id": "gold",
        "name": "Gold Wall Mounting Kit",
        "finish": "gold"
      },
      {
        "id": "black",
        "name": "Black Wall Mounting Kit",
        "finish": "black"
      },
      {
        "id": "hanging",
        "name": "Sign Hanging Kit"
      }
    ],
    "adapters": [
      {
        "id": "2",
        "name": "UK / IRELAND 230V"
      },
      {
        "id": "4",
        "name": "EUROPE 230V"
      },
      {
        "id": "1",
        "name": "USA / CANADA 120V"
      },
      {
        "id": "3",
        "name": "AUSTRALIA / NZ 230V"
      },
      {
        "id": "5",
        "name": "JAPAN 100V"
      },
      {
        "id": "6",
        "name": "OTHER: Ask at Checkout"
      }
    ],
    "modes": [
      {
        "id": "single-color",
        "name": "Single Color"
      },
      {
        "id": "multi-color",
        "name": "Multi Color"
      },
      {
        "id": "rgb-color-changing",
        "name": "RGB Color Changing"
      },
      {
        "id": "dynamic-effects-pack",
        "name": "Dynamic Neon"
      }
    ],
    "usage": [
      {
        "id": "indoor",
        "name": "Indoor"
      },
      {
        "id": "outdoor",
        "name": "IP67 Waterproof"
      }
    ],
    "exactSize": {
      "step": 0.5,
      "unit": "cm",
      "bounds": "Font and effect dependent; computeQuote supplies range"
    },
    "proofOptions": [
      {
        "id": "No",
        "name": "Straight to production"
      },
      {
        "id": "Yes",
        "name": "Approve design proof first",
        "extraDays": "1\u20133"
      }
    ],
    "examples": [
      {
        "name": "red",
        "file": "assets/examples/red.jpg"
      },
      {
        "name": "non-latin-backboard-color-image",
        "file": "assets/examples/clearus.jpg"
      },
      {
        "name": "non-latin-backboard-color-image",
        "file": "assets/examples/whiteus.jpg"
      },
      {
        "name": "non-latin-backboard-color-image",
        "file": "assets/examples/blackus.jpg"
      },
      {
        "name": "non-latin-backboard-color-image",
        "file": "assets/examples/silverus.jpg"
      },
      {
        "name": "non-latin-backboard-color-image",
        "file": "assets/examples/goldus.jpg"
      },
      {
        "name": "ip67-waterproof-image",
        "file": "assets/examples/ip67us.jpg"
      },
      {
        "name": "wall-mounting-kit-image",
        "file": "assets/examples/silverkitus.jpg"
      },
      {
        "name": "wall-mounting-kit-image",
        "file": "assets/examples/goldkitus.jpg"
      },
      {
        "name": "wall-mounting-kit-image",
        "file": "assets/examples/blackkitus.jpg"
      },
      {
        "name": "sign-hanging-kit",
        "file": "assets/examples/hangingkitus.jpg"
      },
      {
        "name": "buyremotedimmer",
        "file": "assets/examples/remotedimmerus.png"
      }
    ],
    "colorPhotos": [
      {
        "name": "Warm White",
        "file": "assets/examples/warmwhite.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "White",
        "file": "assets/examples/white.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Lemon Yellow",
        "file": "assets/examples/lemonyellow.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Golden Yellow",
        "file": "assets/examples/goldenyellow.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Orange",
        "file": "assets/examples/orange.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Light Red",
        "file": "assets/examples/lightred.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Red",
        "file": "assets/examples/red.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Pink",
        "file": "assets/examples/pink.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Cotton Candy",
        "file": "assets/examples/cottoncandy.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Deep Pink",
        "file": "assets/examples/deeppink.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Purple",
        "file": "assets/examples/purple.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Deep Blue",
        "file": "assets/examples/deepblue.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Electric Blue",
        "file": "assets/examples/electricblue.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Ice Blue",
        "file": "assets/examples/iceblue.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Tropical Blue",
        "file": "assets/examples/tropicalblue.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Mint",
        "file": "assets/examples/mint.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Green",
        "file": "assets/examples/green.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      },
      {
        "name": "Deep Green",
        "file": "assets/examples/deepgreen.jpg",
        "status": "path generated by shipped _0x28E0D; validate response before using"
      }
    ]
  };

  // src/neon-text-designer-reference/i18n.js
  var frenchCopy = Object.freeze({
    "Email my design": "Envoyer ma cr\xE9ation",
    "Email sent": "Courriel envoy\xE9",
    "Sending\u2026": "Envoi\u2026",
    "Sending your design\u2026": "Envoi de votre cr\xE9ation\u2026",
    "Check email status": "V\xE9rifier l\u2019\xE9tat du courriel",
    "Contact us for help": "Contactez-nous",
    "Your design email is on its way. Check your inbox and spam folder. This is not an order.": "Votre cr\xE9ation est en route. V\xE9rifiez votre bo\xEEte de r\xE9ception et vos pourriels. Ceci n\u2019est pas une commande.",
    "The email was not sent. Please try again, or contact us for help.": "Le courriel n\u2019a pas \xE9t\xE9 envoy\xE9. R\xE9essayez ou contactez-nous.",
    "We could not confirm the email status. Please contact us before trying again so we do not send a duplicate.": "Nous n\u2019avons pas pu confirmer l\u2019envoi. Contactez-nous avant de r\xE9essayer pour \xE9viter un doublon.",
    "Your email is still being processed. Check its status in a moment.": "Votre courriel est en cours de traitement. V\xE9rifiez son \xE9tat dans un instant.",
    "Please confirm you can receive this design email.": "Veuillez confirmer que vous pouvez recevoir ce courriel.",
    "Enter your sign text before sending the design.": "Saisissez le texte de votre enseigne avant d\u2019envoyer la cr\xE9ation.",
    "Complete the security check, then try again.": "Terminez la v\xE9rification de s\xE9curit\xE9, puis r\xE9essayez.",
    "The security check expired. Please try again.": "La v\xE9rification de s\xE9curit\xE9 a expir\xE9. Veuillez r\xE9essayer.",
    "Please wait before sending another design.": "Veuillez patienter avant d\u2019envoyer une autre cr\xE9ation.",
    "Refresh your design price, then try again.": "Actualisez le prix de votre cr\xE9ation, puis r\xE9essayez.",
    "The email request was not received. Please try again.": "La demande d\u2019envoi n\u2019a pas \xE9t\xE9 re\xE7ue. Veuillez r\xE9essayer.",
    "The connection was interrupted. Check the email status before trying again.": "La connexion a \xE9t\xE9 interrompue. V\xE9rifiez l\u2019\xE9tat du courriel avant de r\xE9essayer.",
    "Email is temporarily unavailable. You can still copy the design link or download a backup.": "L\u2019envoi est temporairement indisponible. Vous pouvez copier le lien de la cr\xE9ation ou t\xE9l\xE9charger une copie.",
    // Catalogue display names. IDs, geometry and asset paths remain unchanged.
    "Single Color": "Couleur unique",
    "Multi Color": "Multicolore",
    "RGB Color Changing": "RGB \xE0 couleurs changeantes",
    "RGB color changing": "RGB \xE0 couleurs changeantes",
    "Dynamic Neon": "N\xE9on dynamique",
    "Warm White": "Blanc chaud",
    White: "Blanc",
    "Lemon Yellow": "Jaune citron",
    "Golden Yellow": "Jaune dor\xE9",
    Orange: "Orange",
    "Light Red": "Rouge clair",
    Red: "Rouge",
    Pink: "Rose",
    "Cotton Candy": "Barbe \xE0 papa",
    "Deep Pink": "Rose fonc\xE9",
    Purple: "Violet",
    "Deep Blue": "Bleu fonc\xE9",
    "Electric Blue": "Bleu \xE9lectrique",
    "Ice Blue": "Bleu glacier",
    "Tropical Blue": "Bleu tropical",
    Mint: "Menthe",
    Green: "Vert",
    "Deep Green": "Vert fonc\xE9",
    Lounge: "Salon",
    Home: "Maison",
    Office: "Bureau",
    Event: "\xC9v\xE9nement",
    Bedroom: "Chambre",
    Wedding: "Mariage",
    Shop: "Boutique",
    Bathroom: "Salle de bain",
    Kids: "Chambre d\u2019enfant",
    Bar: "Bar",
    Barber: "Salon de barbier",
    Building: "Immeuble",
    Games: "Espace jeux",
    Gym: "Salle d\u2019entra\xEEnement",
    Outdoor: "Ext\xE9rieur",
    "Outdoor Business": "Commerce ext\xE9rieur",
    Party: "F\xEAte",
    Restaurant: "Restaurant",
    Salon: "Salon de coiffure",
    Store: "Magasin",
    "Teen Bedroom": "Chambre d\u2019ado",
    Kitchen: "Cuisine",
    Arch: "Arche",
    Flowers: "Fleurs",
    Mini: "Mini",
    "Extra Small": "Tr\xE8s petit",
    Small: "Petit",
    Medium: "Moyen",
    Large: "Grand",
    "X Large": "Tr\xE8s grand",
    "XX Large": "Extra grand",
    Supersized: "Tr\xE8s grand format",
    "Cut Around": "D\xE9coup\xE9 \xE0 la forme",
    Rectangle: "Rectangle",
    "Cut-To-Letter": "D\xE9coup\xE9 \xE0 la lettre",
    "Naked Neon": "Sans support",
    "Acrylic Stand": "Support \xE0 poser",
    "Open Box": "Bo\xEEtier ouvert",
    Clear: "Transparent",
    "Glossy White": "Blanc brillant",
    "Glossy Black": "Noir brillant",
    Silver: "Argent\xE9",
    Gold: "Dor\xE9",
    Black: "Noir",
    "Silver Wall Mounting Kit": "Fixations murales argent\xE9es",
    "Gold Wall Mounting Kit": "Fixations murales dor\xE9es",
    "Black Wall Mounting Kit": "Fixations murales noires",
    "Sign Hanging Kit": "Ensemble de suspension",
    "UK / IRELAND 230V": "ROYAUME-UNI / IRLANDE 230 V",
    "EUROPE 230V": "EUROPE 230 V",
    "USA / CANADA 120V": "\xC9TATS-UNIS / CANADA 120 V",
    "AUSTRALIA / NZ 230V": "AUSTRALIE / NOUVELLE-Z\xC9LANDE 230 V",
    "JAPAN 100V": "JAPON 100 V",
    "OTHER: Ask at Checkout": "AUTRE : pr\xE9ciser lors de la commande",
    "Color Change Mode": "Changement de couleur",
    "Rainbow Flow": "Flux arc-en-ciel",
    "Twilight Flow": "Flux cr\xE9pusculaire",
    "Festive Flow": "Flux festif",
    "Lava Flow": "Flux de lave",
    "Valentine Flow": "Flux romantique",
    "Candy Flow": "Flux bonbon",
    "Ocean Flow": "Flux oc\xE9anique",
    "Forest Flow": "Flux forestier",
    "Vivid Rainbow": "Arc-en-ciel vif",
    "Smooth Color Change": "Transition douce des couleurs",
    "7-Color Jump": "Alternance de 7 couleurs",
    "3-Color Jump": "Alternance de 3 couleurs",
    "7-Color Flash": "Clignotement de 7 couleurs",
    "Christmas Chase": "D\xE9filement de No\xEBl",
    "Red & Blue Chase": "D\xE9filement rouge et bleu",
    "Ice Chase": "D\xE9filement glac\xE9",
    "Rainbow Double Trail": "Double tra\xEEn\xE9e arc-en-ciel",
    "Opening Brush Stroke": "Balayage vers le centre",
    "Closing Brush Stroke": "Balayage vers les bords",
    "Static Red": "Rouge fixe",
    "Static Green": "Vert fixe",
    "Static Blue": "Bleu fixe",
    "Static Yellow": "Jaune fixe",
    "Static Purple": "Violet fixe",
    "Static Cyan": "Cyan fixe",
    "Static White": "Blanc fixe",
    "Flow Effects": "Effets fluides",
    "Color Cycling": "Cycles de couleurs",
    "Chase Effects": "Effets de d\xE9filement",
    "Special Effects": "Effets sp\xE9ciaux",
    "Static Colors": "Couleurs fixes",
    "Smooth rainbow colors flow continuously across the sign": "Les couleurs de l\u2019arc-en-ciel d\xE9filent en continu sur l\u2019enseigne.",
    "Dreamy blue, purple, and yellow colors drift smoothly": "Le bleu, le violet et le jaune se succ\xE8dent doucement.",
    "Red, green, and white colors flow for a festive look": "Le rouge, le vert et le blanc d\xE9filent pour un effet festif.",
    "Warm orange and yellow colors flow like molten lava": "Des tons chauds orange et jaunes d\xE9filent comme de la lave.",
    "Romantic red and pink colors drift smoothly": "Le rouge et le rose se succ\xE8dent doucement.",
    "Sweet red and white colors wave smoothly": "Le rouge et le blanc ondulent doucement.",
    "Calm blue and white waves flow gently": "Des vagues bleues et blanches d\xE9filent doucement.",
    "Natural green and white colors drift peacefully": "Le vert et le blanc se succ\xE8dent paisiblement.",
    "Bright rainbow colors with distinct transitions": "Les couleurs vives de l\u2019arc-en-ciel se succ\xE8dent par transitions nettes.",
    "All letters smoothly fade between colors including pink and orange": "Toutes les lettres changent doucement de couleur, notamment vers le rose et l\u2019orange.",
    "Sign snaps crisply between all seven vibrant colors": "L\u2019enseigne alterne rapidement entre sept couleurs vives.",
    "Sign alternates between blue, green, and red": "L\u2019enseigne alterne entre le bleu, le vert et le rouge.",
    "Rapid strobe through all colors with off between": "Toutes les couleurs clignotent rapidement avec une pause sombre entre chaque couleur.",
    "Festive red and green colors chase across the sign": "Le rouge et le vert d\xE9filent sur l\u2019enseigne.",
    "Classic red and blue colors chase across the sign": "Le rouge et le bleu d\xE9filent sur l\u2019enseigne.",
    "Cool blue and white colors chase across the sign": "Le bleu et le blanc d\xE9filent sur l\u2019enseigne.",
    "Two colors flow together, changing pairs every few seconds": "Deux couleurs d\xE9filent ensemble et changent toutes les quelques secondes.",
    "Colors paint across from the edges toward center": "Les couleurs progressent des bords vers le centre.",
    "Colors paint from center outward to the edges": "Les couleurs progressent du centre vers les bords.",
    "Solid red glow": "\xC9clairage rouge fixe.",
    "Solid green glow": "\xC9clairage vert fixe.",
    "Solid blue glow": "\xC9clairage bleu fixe.",
    "Solid yellow glow": "\xC9clairage jaune fixe.",
    "Solid purple glow": "\xC9clairage violet fixe.",
    "Solid cyan glow": "\xC9clairage cyan fixe.",
    "Solid white glow": "\xC9clairage blanc fixe.",
    // Colour descriptions are display copy, not manufacturing specifications.
    "Warm white is a very popular natural-feeling white. The tube is white when off.": "Un blanc chaud et naturel. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "White is a cooler, brighter white. The tube is white when off.": "Un blanc plus froid et lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "Lemon Yellow is a very bright, eye-catching yellow. The tube is yellow when off.": "Un jaune citron tr\xE8s lumineux. Le tube est jaune lorsqu\u2019il est \xE9teint.",
    "Golden Yellow is a bold, rich yellow. The tube is yellow when off.": "Un jaune dor\xE9 soutenu. Le tube est jaune lorsqu\u2019il est \xE9teint.",
    "A bright, eye-catching orange. The tube is orange when off.": "Un orange lumineux. Le tube est orange lorsqu\u2019il est \xE9teint.",
    "Light Red is a vivid and sophisticated brighter shade of red. The tube is white when off.": "Une nuance de rouge clair et vif. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "A gorgeous 'Candy Apple' red. The tube is red when off.": "Un rouge pomme d\u2019amour. Le tube est rouge lorsqu\u2019il est \xE9teint.",
    "Bright, eye-catching neon Pink remains an extremely popular choice. The tube is white when off.": "Un rose n\xE9on lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "Soft and pink as Cotton Candy. The tube is light pink when off.": "Un rose doux, comme la barbe \xE0 papa. Le tube est rose p\xE2le lorsqu\u2019il est \xE9teint.",
    "A popular stunning deep pink with a vivid glow. The tube is pink when off.": "Un rose fonc\xE9 \xE0 l\u2019\xE9clat vif. Le tube est rose lorsqu\u2019il est \xE9teint.",
    "A popular stylish purple. The tube is white when off.": "Un violet lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "A bold, darker blue. The tube is Blue when off": "Un bleu fonc\xE9 soutenu. Le tube est bleu lorsqu\u2019il est \xE9teint.",
    "A fantastic bright blue. The tube is White when off": "Un bleu \xE9lectrique lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "A very bright, eye-catching blue. The tube is white when off.": "Un bleu glacier tr\xE8s lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "A gorgeous blue that glows like a tropical lagoon. The tube is light blue when off.": "Un bleu qui rappelle un lagon tropical. Le tube est bleu p\xE2le lorsqu\u2019il est \xE9teint.",
    "A fresh, minty green. The tube is mint when off.": "Un vert menthe frais. Le tube est menthe lorsqu\u2019il est \xE9teint.",
    "A great-looking, very bright green. The tube is white when off.": "Un vert tr\xE8s lumineux. Le tube est blanc lorsqu\u2019il est \xE9teint.",
    "A darker green that is still very eye-catching. The tube is green when off.": "Un vert fonc\xE9 soutenu. Le tube est vert lorsqu\u2019il est \xE9teint.",
    // Summary labels and fixed values; never translate the adjacent sign wording.
    Text: "Texte",
    Font: "Police",
    Light: "\xC9clairage",
    Color: "Couleur",
    Size: "Dimensions",
    Location: "Installation",
    Backing: "Support",
    "Backing color": "Couleur du support",
    Mounting: "Fixation",
    "Hanging kit": "Ensemble de suspension",
    Adapter: "Adaptateur",
    "Final proof": "Maquette finale",
    "Production and delivery": "Production et livraison",
    Indoor: "Int\xE9rieur",
    Yes: "Oui",
    No: "Non",
    "No wall kit": "Sans fixations murales",
    "Custom per-letter / word colors": "Couleurs personnalis\xE9es par lettre ou mot",
    "Approval required before production": "Approbation requise avant production",
    "Price breakdown": "D\xE9tail du prix",
    "Sign and selected construction \xB7 CAD": "Enseigne et fabrication choisie \xB7 CAD",
    "Discount code": "Code de r\xE9duction",
    "separate quote": "devis s\xE9par\xE9",
    "silver wall kit": "fixations murales argent\xE9es",
    "gold wall kit": "fixations murales dor\xE9es",
    "black wall kit": "fixations murales noires",
    "Add silver wall mounting kit": "Ajouter les fixations murales argent\xE9es",
    "Add gold wall mounting kit": "Ajouter les fixations murales dor\xE9es",
    "Add black wall mounting kit": "Ajouter les fixations murales noires",
    "Remove wall mounting kit": "Retirer les fixations murales",
    "Add wall mounting kit": "Ajouter les fixations murales",
    // Common control/status literals and explicitly separated UI prefixes.
    "Quote needed": "Devis requis",
    "Light on": "Allum\xE9",
    "Light off": "\xC9teint",
    Pause: "Suspendre",
    Resume: "Reprendre",
    "Pause animation": "Suspendre l\u2019animation",
    "Resume animation": "Reprendre l\u2019animation",
    "Use the speed control to try this effect.": "R\xE9glez la vitesse pour essayer cet effet.",
    "One color \xB7 dimmer included": "Une couleur \xB7 gradateur inclus",
    "Color each letter or word": "Une couleur par lettre ou mot",
    "Change the whole sign\u2019s color": "Changez la couleur de toute l\u2019enseigne",
    "Flows, chases and moving light": "Flux, d\xE9filements et lumi\xE8re anim\xE9e",
    "Hanging kits are unavailable for this backing.": "Les ensembles de suspension ne sont pas offerts avec ce support.",
    "Choose this effect to switch the sign to Indoor": "Choisissez cet effet pour une utilisation \xE0 l\u2019int\xE9rieur",
    "Switched to Indoor: RGB and Dynamic Neon are not available with IP67 outdoor signs.": "Utilisation int\xE9rieure s\xE9lectionn\xE9e : les modes RGB et n\xE9on dynamique ne sont pas disponibles pour les enseignes d\u2019ext\xE9rieur IP67.",
    "IP67 adds a waterproof upgrade. RGB and Dynamic Neon are available for indoor signs only.": "La construction ext\xE9rieure ajoute une protection contre l\u2019eau. Les modes RGB et n\xE9on dynamique sont r\xE9serv\xE9s \xE0 l\u2019int\xE9rieur.",
    "Indoor signs should stay dry.": "Les enseignes d\u2019int\xE9rieur doivent rester au sec.",
    "Select a letter or word first.": "S\xE9lectionnez d\u2019abord une lettre ou un mot.",
    "Enter your text first.": "Saisissez d\u2019abord votre texte.",
    "For signs over 50 letters, request a custom quote.": "Pour une enseigne de plus de 50 lettres, demandez un devis personnalis\xE9.",
    "This script needs a custom font and production quote. You can still save your design.": "Cette \xE9criture n\xE9cessite une police adapt\xE9e et un devis personnalis\xE9. Vous pouvez tout de m\xEAme enregistrer votre cr\xE9ation.",
    "Enter your own text before reviewing the design.": "Saisissez votre propre texte avant de v\xE9rifier la cr\xE9ation.",
    "Review the updated price before confirming.": "V\xE9rifiez le prix actualis\xE9 avant de confirmer.",
    "Your text is too long. Request a custom quote.": "Votre texte est trop long. Demandez un devis personnalis\xE9.",
    "Choose a room image smaller than 8 MB.": "Choisissez une photo de pi\xE8ce de moins de 8 Mo.",
    "Choose a file smaller than 8 MB.": "Choisissez un fichier de moins de 8 Mo.",
    "That background could not load.": "Ce d\xE9cor n\u2019a pas pu \xEAtre charg\xE9.",
    "The shared design link could not be read.": "Le lien de la cr\xE9ation partag\xE9e n\u2019a pas pu \xEAtre lu.",
    "The editor could not start: ": "L\u2019outil n\u2019a pas pu d\xE9marrer : ",
    "SVG export failed: ": "L\u2019export SVG a \xE9chou\xE9 : ",
    "Selected: ": "S\xE9lection : ",
    "Selected word: ": "Mot s\xE9lectionn\xE9 : ",
    "Selected letter: ": "Lettre s\xE9lectionn\xE9e : ",
    "Available width: ": "Largeur offerte : ",
    "Height follows your text proportions.": "La hauteur suit les proportions de votre texte.",
    "Backing: ": "Support : ",
    "Attached: ": "Pi\xE8ce jointe : ",
    " in real life": " en photo",
    "Wall mounting kit": "Ensemble de fixation murale",
    "Sign hanging kit": "Ensemble de suspension",
    "Remote and dimmer": "T\xE9l\xE9commande et gradateur",
    "IP67 waterproof technology": "Construction ext\xE9rieure prot\xE9g\xE9e contre l\u2019eau",
    "Uploaded artwork": "Dessin import\xE9",
    "Saved sign preview": "Aper\xE7u de l\u2019enseigne enregistr\xE9e",
    "No saved designs yet.": "Aucune cr\xE9ation enregistr\xE9e pour le moment.",
    "Save your current design above to keep it here.": "Enregistrez votre cr\xE9ation ci-dessus pour la retrouver ici.",
    "Saved design loaded.": "Cr\xE9ation enregistr\xE9e charg\xE9e.",
    "Saved in this browser.": "Enregistr\xE9e dans ce navigateur.",
    "Browser storage is full. Download the JSON instead.": "Le stockage du navigateur est plein. T\xE9l\xE9chargez plut\xF4t le fichier JSON.",
    "Browser storage is full. Download a design file instead.": "Le stockage du navigateur est plein. T\xE9l\xE9chargez plut\xF4t le fichier de votre cr\xE9ation.",
    "Browser storage is full. Download an order packet instead.": "Le stockage du navigateur est plein. T\xE9l\xE9chargez plut\xF4t les d\xE9tails de la commande.",
    "This file does not contain a sign design.": "Ce fichier ne contient pas de cr\xE9ation d\u2019enseigne.",
    "Design imported.": "Cr\xE9ation import\xE9e.",
    "Share link copied. Uploaded room images are excluded.": "Lien de partage copi\xE9. Les photos de pi\xE8ce import\xE9es ne sont pas incluses.",
    "Clipboard unavailable. Download your design JSON instead.": "Le presse-papiers est indisponible. T\xE9l\xE9chargez plut\xF4t le fichier JSON de votre cr\xE9ation.",
    "Clipboard unavailable. Download a design file instead.": "Le presse-papiers est indisponible. T\xE9l\xE9chargez plut\xF4t le fichier de votre cr\xE9ation.",
    "Choose a design file smaller than 12 MB.": "Choisissez un fichier de cr\xE9ation de moins de 12 Mo.",
    "That file could not be read. Choose a saved EasyNeonSigns design file.": "Ce fichier est illisible. Choisissez un fichier de cr\xE9ation enregistr\xE9 avec EasyNeonSigns.",
    "Enter a valid recipient email.": "Saisissez une adresse courriel valide pour le destinataire.",
    "Email draft opened. You decide whether to send it.": "Le brouillon du courriel est ouvert. Vous d\xE9cidez de l\u2019envoyer ou non.",
    "My neon sign": "Mon enseigne n\xE9on",
    "My neon design": "Ma cr\xE9ation n\xE9on",
    "Here is my neon design:\n": "Voici ma cr\xE9ation n\xE9on :\n",
    "Quote packet downloaded. Share it with your supplier; nothing was sent.": "La demande de devis a \xE9t\xE9 t\xE9l\xE9charg\xE9e. Joignez-la \xE0 votre message \xE0 notre \xE9quipe; rien n\u2019a \xE9t\xE9 envoy\xE9.",
    "Offer code copied.": "Code de r\xE9duction copi\xE9.",
    "Select the offer code to copy it.": "S\xE9lectionnez le code de r\xE9duction pour le copier.",
    "Discounts require a backend quote.": "Le code de r\xE9duction doit \xEAtre valid\xE9 avec votre devis.",
    "Needs live repricing": "Prix \xE0 recalculer",
    "Saved estimate": "Estimation enregistr\xE9e",
    "Repriced before checkout.": "Prix recalcul\xE9 avant le paiement.",
    each: "l\u2019unit\xE9",
    Quantity: "Quantit\xE9",
    "Quantity for ": "Quantit\xE9 pour ",
    "Edit / reprice": "Modifier / recalculer",
    Remove: "Retirer",
    Load: "Charger",
    "Your bag is empty. Review a design to add it.": "Aucune cr\xE9ation enregistr\xE9e. V\xE9rifiez une cr\xE9ation pour l\u2019ajouter.",
    "Review the design and correct the highlighted requirements first.": "V\xE9rifiez votre cr\xE9ation et corrigez d\u2019abord les \xE9l\xE9ments signal\xE9s.",
    "Check the design approval box before downloading an order packet.": "Cochez la case de v\xE9rification avant de t\xE9l\xE9charger les d\xE9tails de la commande.",
    "A current complete backend quote is required before downloading an order request.": "Un devis complet et \xE0 jour est requis pour t\xE9l\xE9charger la demande de commande.",
    "Live quote refreshed. Approve the design before adding the updated item.": "Le prix a \xE9t\xE9 recalcul\xE9. V\xE9rifiez la cr\xE9ation avant d\u2019enregistrer la version mise \xE0 jour.",
    "Updating price\u2026": "Calcul du prix\u2026",
    "Fetching current price\u2026": "Calcul du prix\u2026",
    "Price confirmed \xB7 CAD": "Prix confirm\xE9 \xB7 CAD",
    "Pricing unavailable \u2014 retry": "Prix indisponible \u2014 r\xE9essayez",
    "Custom quote required": "Devis personnalis\xE9 requis",
    "Measurement is confirmed with your quote.": "La mesure sera confirm\xE9e avec le devis.",
    "Calculated strip length: ": "Longueur calcul\xE9e : ",
    // Customer-safe contract and compatibility messages from the public bridge.
    "This font needs a custom quote. You can still preview, save and share it.": "Cette police n\xE9cessite un devis personnalis\xE9. Vous pouvez tout de m\xEAme l\u2019essayer, l\u2019enregistrer et la partager.",
    "Dynamic Neon needs a custom quote. Animation is a preview of the effect.": "Le n\xE9on dynamique n\xE9cessite un devis personnalis\xE9. L\u2019animation est une simulation de l\u2019effet.",
    "RGB and Dynamic Neon are indoor-only. Choose indoor use or a single/multicolour light.": "Les modes RGB et n\xE9on dynamique sont r\xE9serv\xE9s \xE0 l\u2019int\xE9rieur. Choisissez une utilisation int\xE9rieure ou un \xE9clairage \xE0 couleur unique ou multicolore.",
    "This backing style needs a custom quote.": "Cette forme de support n\xE9cessite un devis personnalis\xE9.",
    "This power adapter needs a custom quote.": "Cet adaptateur secteur n\xE9cessite un devis personnalis\xE9.",
    "Select one mounting method for online checkout, or request a quote for both kits.": "Choisissez une seule m\xE9thode de fixation pour commander en ligne, ou demandez un devis pour les deux ensembles.",
    "This mounting finish needs a custom quote.": "Ce fini de fixation n\xE9cessite un devis personnalis\xE9.",
    "The remote and dimmer are included. Contact us for a build without them.": "La t\xE9l\xE9commande et le gradateur sont inclus. Contactez-nous pour une fabrication sans ces accessoires.",
    "Rush production must be confirmed by our team. Request a quote with your required date.": "Notre \xE9quipe doit confirmer la production acc\xE9l\xE9r\xE9e. Indiquez votre date limite dans votre demande de devis.",
    "Online checkout covers widths from 18 to 120 inches. Request a quote for this size.": "La commande en ligne couvre les largeurs de 18 \xE0 120 pouces. Demandez un devis pour cette dimension.",
    "This script needs a custom font and production quote.": "Cette \xE9criture n\xE9cessite une police adapt\xE9e et un devis personnalis\xE9.",
    "Enter text to configure a sign.": "Saisissez du texte pour cr\xE9er votre enseigne.",
    "Signs over 50 letters require a custom quote.": "Les enseignes de plus de 50 lettres n\xE9cessitent un devis personnalis\xE9.",
    "Waterproof signs are not available with RGB or Dynamic Neon.": "La construction ext\xE9rieure n\u2019est pas offerte avec les modes RGB et n\xE9on dynamique.",
    "This size is unavailable for the selected font, effect, or waterproof option.": "Ces dimensions ne sont pas offertes avec la police, l\u2019effet ou la construction ext\xE9rieure s\xE9lectionn\xE9s.",
    "This sign requires two backboards.": "Cette enseigne n\xE9cessite deux supports.",
    "Height is pending preview measurement.": "La hauteur sera confirm\xE9e apr\xE8s le calcul de l\u2019aper\xE7u.",
    "This backboard style is incompatible with a hanging kit.": "Cette forme de support n\u2019est pas compatible avec un ensemble de suspension.",
    "Naked Neon does not use a colored backboard.": "La version sans support ne comprend pas de panneau color\xE9.",
    "Rush fulfilment requires merchant confirmation; no rush surcharge was recovered.": "Les d\xE9lais et les frais du service acc\xE9l\xE9r\xE9 doivent \xEAtre confirm\xE9s par notre \xE9quipe.",
    "Pricing connection unavailable. Please retry.": "La connexion au service de prix est indisponible. R\xE9essayez.",
    "Pricing timed out. Please retry.": "Le calcul du prix a pris trop de temps. R\xE9essayez.",
    "Pricing unavailable. Please retry.": "Le prix est indisponible. R\xE9essayez.",
    "This design needs a custom quote.": "Cette cr\xE9ation n\xE9cessite un devis personnalis\xE9.",
    "This design needs a confirmed quote. Please retry or contact us.": "Cette cr\xE9ation n\xE9cessite un devis confirm\xE9. R\xE9essayez ou contactez-nous.",
    "Your quote has expired. Refresh the price before continuing.": "Votre devis a expir\xE9. Recalculez le prix avant de continuer.",
    "Product variant is unavailable.": "Cette option de produit est indisponible.",
    "Preview could not be prepared.": "L\u2019aper\xE7u n\u2019a pas pu \xEAtre pr\xE9par\xE9."
  });
  function translate(text, french2 = false) {
    if (!french2 || typeof text !== "string") return text;
    const heightMinimum = text.match(/^This font and wording need at least (\d+(?:\.\d+)?) inches wide to meet the minimum production height\. Increase the width or choose another font\.$/);
    if (heightMinimum) return `Cette police et ce texte n\xE9cessitent une largeur minimale de ${heightMinimum[1]} po pour respecter la hauteur minimale de fabrication. Augmentez la largeur ou choisissez une autre police.`;
    if (text === "This font and wording need more than 120 inches to meet the minimum production height. Choose another font, split the wording into lines, or request a custom quote.")
      return "Cette police et ce texte n\xE9cessitent plus de 120 po pour respecter la hauteur minimale de fabrication. Choisissez une autre police, r\xE9partissez le texte sur plusieurs lignes ou demandez un devis personnalis\xE9.";
    const width = text.match(/^This wording needs at least (\d+(?:\.\d+)?) inches wide \((1\.8|2\.2) inches per character, including spaces, on the longest line\)\. Increase the width or request a custom quote\.$/);
    if (width) return `Ce texte n\xE9cessite une largeur minimale de ${width[1]} po (${width[2].replace(".", ",")} po par caract\xE8re, espaces compris, sur la ligne la plus longue). Augmentez la largeur ou demandez un devis personnalis\xE9.`;
    const over = text.match(/^This wording needs more than 120 inches under our (1\.8|2\.2)-inch-per-character sizing rule\. Shorten the lines or request a custom quote\.$/);
    if (over) return `Ce texte n\xE9cessite plus de 120 po selon notre r\xE8gle de ${over[1].replace(".", ",")} po par caract\xE8re. Raccourcissez les lignes ou demandez un devis personnalis\xE9.`;
    return Object.hasOwn(frenchCopy, text) ? frenchCopy[text] : text;
  }
  var originals = /* @__PURE__ */ new WeakMap();
  var displayCollections = Object.freeze([
    "modes",
    "colors",
    "colorPhotos",
    "backgrounds",
    "backboards",
    "backboardColors",
    "mounting",
    "adapters",
    "sizes",
    "rgbEffects",
    "dynamicEffects"
  ]);
  var displayFields = Object.freeze(["name", "desc", "description", "category"]);
  function localizeCatalog(catalog2, french2 = false) {
    if (!catalog2 || typeof catalog2 !== "object") return catalog2;
    for (const key of displayCollections) {
      if (!Array.isArray(catalog2[key])) continue;
      for (const item of catalog2[key]) {
        if (!item || typeof item !== "object") continue;
        if (!originals.has(item)) {
          const values = {};
          for (const field of displayFields) {
            if (typeof item[field] === "string") values[field] = item[field];
          }
          originals.set(item, values);
        }
        for (const [field, original] of Object.entries(originals.get(item))) {
          item[field] = translate(original, french2);
        }
      }
    }
    return catalog2;
  }

  // src/neon-text-designer-reference/design-email.js
  var API = "https://apiv2.easyneonsigns.ca";
  var FIELDS = ["text", "font", "fontSize", "lineHeight", "align", "color", "colorName", "effectMode", "letterColors", "wordColors", "widthCm", "usage", "backboardShape", "backboardColor", "wallMounting", "wallFinish", "hangingKit", "dimmer", "adapter", "unit", "specialOutline", "showDimensions", "background", "position", "on", "brightness", "effectPreset", "effectSpeed"];
  var HOME = "//easyneonsigns.ca/cdn/shop/t/44/assets/ens-designer-scene-home.webp";
  function emailDesignState(state2) {
    const result = Object.fromEntries(FIELDS.filter((key) => state2[key] !== void 0).map((key) => [key, state2[key]]));
    if (String(result.background).startsWith("data:")) result.background = HOME;
    return JSON.parse(JSON.stringify(result));
  }
  async function jsonRequest(path, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2e4);
    try {
      const response = await fetch(API + path, { ...options, signal: controller.signal, cache: "no-store" });
      const text = await response.text();
      if (text.length > 2e4) throw Error("Invalid email service response");
      const data = JSON.parse(text);
      return { response, data };
    } finally {
      clearTimeout(timer);
    }
  }
  var scriptReady;
  function loadChallenge() {
    if (window.turnstile) return Promise.resolve();
    if (!scriptReady) scriptReady = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        scriptReady = null;
        reject(Error("Security check unavailable"));
      };
      document.head.append(script);
    });
    return scriptReady;
  }
  function createDesignEmail({ element, getDesign, getPreview, getQuote: getQuote2, getLanguage, ui: ui2 }) {
    let runtime, widget, challengeToken = "", session2, pending, initializing, busy = false;
    const operations = /* @__PURE__ */ new Map();
    const $2 = (id) => element.querySelector("#" + id);
    const button = $2("emailDesign"), email = $2("shareEmail"), consent = $2("shareEmailConsent"), status2 = $2("saveStatus");
    const challenge = $2("designEmailChallenge");
    const show = (text) => {
      status2.textContent = ui2(text);
    };
    const label = (text) => {
      button.querySelector("[data-email-label]").textContent = ui2(text);
    };
    const resetChallenge = () => {
      challengeToken = "";
      if (widget !== void 0 && window.turnstile) window.turnstile.reset(widget);
    };
    const key = () => JSON.stringify({ email: email.value.trim(), design: emailDesignState(getDesign()), name: $2("designName").value, language: getLanguage() });
    const restore = () => {
      if (busy) return;
      pending = operations.get(key()) || null;
      if (pending && pending.status !== "new") receipt({ requestId: pending.payload.requestId, status: pending.status });
      else {
        button.disabled = false;
        label("Email my design");
      }
    };
    email.addEventListener("input", restore);
    $2("designName").addEventListener("input", restore);
    consent.addEventListener("change", () => consent.removeAttribute("aria-invalid"));
    async function prepare() {
      if (initializing) return initializing;
      initializing = (async () => {
        runtime = (await jsonRequest("/designer/email/health")).data;
        if (!runtime.enabled || !/^0x[A-Za-z0-9_-]+$/.test(runtime.sitekey || "")) throw Error("Email unavailable");
        await loadChallenge();
        if (!window.turnstile) throw Error("Security check unavailable");
        if (widget === void 0) widget = window.turnstile.render(challenge, { sitekey: runtime.sitekey, action: "design-email", theme: "light", size: "flexible", callback: (token) => {
          challengeToken = token;
        }, "expired-callback": () => {
          challengeToken = "";
        }, "error-callback": () => {
          challengeToken = "";
        } });
        restore();
      })();
      try {
        await initializing;
      } finally {
        initializing = null;
      }
    }
    async function authorize() {
      if (session2 && session2.expires > Date.now() + 15e3) return session2.token;
      if (!challengeToken) throw Object.assign(Error("Complete the security check, then try again."), { safeMessage: true });
      const token = challengeToken;
      challengeToken = "";
      const { response, data } = await jsonRequest("/designer/email/session", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_nonce: crypto.randomUUID(), turnstile_token: token }) });
      if (!response.ok || data.token_type !== "Bearer" || !data.scopes?.includes("share:email") || !/^[A-Za-z0-9_.-]{32,4096}$/.test(data.access_token || "") || !(data.expires_in > 0 && data.expires_in <= 300)) {
        resetChallenge();
        throw Object.assign(Error("The security check expired. Please try again."), { safeMessage: true });
      }
      session2 = { token: data.access_token, expires: Date.now() + data.expires_in * 1e3 };
      return session2.token;
    }
    function receipt(data) {
      if (data.requestId !== pending?.payload.requestId) throw Error("Mismatched email receipt");
      if (data.status === "accepted") {
        pending.status = "accepted";
        button.disabled = true;
        label("Email sent");
        show("Your design email is on its way. Check your inbox and spam folder. This is not an order.");
      } else if (data.status === "failed") {
        operations.delete(pending.key);
        pending = null;
        button.disabled = false;
        label("Email my design");
        show("The email was not sent. Please try again, or contact us for help.");
      } else if (data.status === "unknown") {
        pending.status = "unknown";
        button.disabled = true;
        label("Contact us for help");
        show("We could not confirm the email status. Please contact us before trying again so we do not send a duplicate.");
      } else if (["sending", "queued"].includes(data.status)) {
        pending.status = "sending";
        button.disabled = false;
        label("Check email status");
        show("Your email is still being processed. Check its status in a moment.");
      } else throw Error("Invalid email receipt");
    }
    async function send(event) {
      event?.preventDefault();
      if (busy) return;
      if (!email.value.trim() || !email.checkValidity()) {
        email.setAttribute("aria-invalid", "true");
        email.focus();
        show("Enter a valid recipient email.");
        return;
      }
      if (!consent.checked) {
        consent.setAttribute("aria-invalid", "true");
        consent.focus();
        show("Please confirm you can receive this design email.");
        return;
      }
      if (!String(getDesign().text || "").trim()) {
        show("Enter your sign text before sending the design.");
        return;
      }
      pending = operations.get(key()) || null;
      if (pending?.status === "accepted" || pending?.status === "unknown") return;
      busy = true;
      button.disabled = true;
      label("Sending\u2026");
      show("Sending your design\u2026");
      try {
        await prepare();
        const token = await authorize();
        const headers = { "Content-Type": "application/json", Authorization: "Bearer " + token };
        if (pending?.status === "sending") {
          const { response: response2, data: data2 } = await jsonRequest("/designer/email/" + pending.payload.requestId, { headers });
          if ([401, 403].includes(response2.status)) {
            session2 = null;
            resetChallenge();
            throw Object.assign(Error("The security check expired. Please try again."), { safeMessage: true });
          }
          if (response2.status === 404) {
            pending.status = "new";
            throw Object.assign(Error("The email request was not received. Please try again."), { safeMessage: true });
          }
          if (!response2.ok) throw Error("Email receipt unavailable");
          receipt(data2);
          return;
        }
        if (!pending) {
          const priced = getQuote2();
          pending = { key: key(), status: "new", payload: { requestId: crypto.randomUUID(), email: email.value.trim(), designName: $2("designName").value.trim() || ui2("My neon sign"), language: getLanguage(), design: emailDesignState(getDesign()), previewPng: getPreview(), quoteId: priced?.quoteId || null, consent: true, website: $2("designEmailWebsite").value } };
          operations.set(pending.key, pending);
        }
        pending.status = "sending";
        const { response, data } = await jsonRequest("/designer/email", { method: "POST", headers, body: JSON.stringify(pending.payload) });
        if ([401, 403, 422, 429, 503].includes(response.status) || response.status === 409 && !data.status) {
          operations.delete(pending.key);
          pending = null;
          if ([401, 403].includes(response.status)) {
            session2 = null;
            resetChallenge();
          }
          throw Object.assign(Error(response.status === 429 ? "Please wait before sending another design." : response.status === 409 ? "Refresh your design price, then try again." : "The email was not sent. Please try again, or contact us for help."), { safeMessage: true });
        }
        if (data.status) receipt(data);
        else throw Error("Email service unavailable");
      } catch (error) {
        button.disabled = false;
        label(pending?.status === "sending" ? "Check email status" : "Email my design");
        show(error.safeMessage ? error.message : pending?.status === "sending" ? "The connection was interrupted. Check the email status before trying again." : "Email is temporarily unavailable. You can still copy the design link or download a backup.");
      } finally {
        busy = false;
      }
    }
    return { prepare, send, restore };
  }

  // src/neon-text-designer-reference/color-selection.js
  function colorSelection(state2, selected2, target, hex) {
    if (target === "word") {
      return {
        letterColors: Object.fromEntries(
          Object.entries(state2.letterColors || {}).filter(
            ([index]) => Number(index) < selected2.start || Number(index) >= selected2.end
          )
        ),
        wordColors: { ...state2.wordColors, [selected2.wordIndex]: hex }
      };
    }
    return { letterColors: { ...state2.letterColors, [selected2.index]: hex } };
  }

  // src/neon-text-designer-reference/step-preview.js
  function stepPreviewNeedsRecovery({
    compact,
    keyboardOpen,
    canvasRect,
    canvasSize,
    ink,
    viewport,
    inset = 0
  }) {
    if (!compact || keyboardOpen || !canvasRect || !canvasSize || !ink || !viewport)
      return false;
    const values = [
      canvasRect.top,
      canvasRect.height,
      canvasSize.height,
      ink.top,
      ink.height,
      viewport.top,
      viewport.bottom,
      inset
    ];
    if (!values.every(Number.isFinite) || canvasRect.height <= 0 || canvasSize.height <= 0 || ink.height <= 0) return false;
    const scale = canvasRect.height / canvasSize.height;
    const top = canvasRect.top + ink.top * scale;
    const bottom = top + ink.height * scale;
    const visibleTop = viewport.top + inset;
    return top < visibleTop - 3 || bottom > viewport.bottom + 3;
  }

  // src/neon-text-designer-reference/bag.js
  function savedQuoteAmount(quote2) {
    return quote2?.currency === "CAD" && typeof quote2.total === "number" && Number.isFinite(quote2.total) && quote2.total > 0 ? quote2.total : null;
  }

  // src/neon-text-designer-reference/quote-handoff.js
  var QUOTE_CONTEXT_KEY = "ens-designer-quote-v1";
  function quoteContext(state2, rows, now = Date.now()) {
    const clean = (value) => String(value ?? "").slice(0, 1e3);
    return {
      version: 1,
      createdAt: now,
      id: `${now.toString(36)}-${Math.random().toString(36).slice(2)}`,
      text: clean(state2.text),
      width: Number(state2.widthCm) > 0 ? Math.round(Number(state2.widthCm) * 10) / 10 : "",
      usage: state2.usage === "outdoor" ? "Outdoor" : "Indoor",
      mounting: state2.hangingKit ? "Hanging with chains" : state2.wallMounting ? "Wall mounted" : "Not sure",
      notes: [
        ...rows.slice(0, 30).map(([key, value]) => `${clean(key)}: ${clean(value)}`),
        `Remote and dimmer: ${state2.dimmer ? "Yes" : "No"}`,
        `Colour selections: ${clean(JSON.stringify({ color: state2.color, letterColors: state2.letterColors, wordColors: state2.wordColors }))}`
      ].join("\n").slice(0, 12e3)
    };
  }
  function canAutoEnterDesigner(hash, restored) {
    return !hash || hash.startsWith("#design=") && restored;
  }

  // src/neon-text-designer-reference/lettering-policy.json
  var lettering_policy_default = {
    version: "ens-lettering-minimum-2026-10-29-v2",
    singleInchesPerCharacter: 1.8,
    doubleInchesPerCharacter: 2.2,
    doubleStrokeFonts: [
      "Bellview",
      "LoveNeon",
      "Majorca",
      "Manhattan",
      "Marquee",
      "Mayfair",
      "NeonGlow",
      "Nevada",
      "SciFi",
      "Rockstar",
      "Submarine",
      "Vancouver",
      "Westcoast"
    ]
  };

  // src/neon-text-designer-reference/production-width-metrics.json
  var production_width_metrics_default = { version: "ens-font-geometry-2026-10-29-v2", sourceSha256: "a9afd1c187d3bed497cb9ff7b7e0e34f221160b95522b36b261454f2628ef68e", minimumHeightInches: 4, fonts: { Alexa: { lineHeight: 0.885417, advances: { "0": 0.625, "1": 0.489583, "2": 0.692708, "3": 0.694987, "4": 0.666667, "5": 0.838542, "6": 0.611979, "7": 0.588542, "8": 0.703125, "9": 0.53125, " ": 0.197998, "!": 0.338542, '"': 0.218994, "#": 0.760986, $: 0.537028, "%": 0.701009, "&": 0.662028, "'": 0.129964, "(": 0.619792, ")": 0.65096, "*": 0.351969, "+": 0.406006, ",": 0.19401, "-": 0.316976, ".": 0.201009, "/": 0.604004, ":": 0.225993, ";": 0.225993, "<": 0.318034, "=": 0.40625, ">": 0.318034, "?": 0.40096, "@": 0.84196, A: 1.151042, B: 0.885417, C: 0.770833, D: 0.912028, E: 0.776042, F: 0.739583, G: 0.942708, H: 1.244792, I: 0.869792, J: 1.088542, K: 1.572917, L: 0.859375, M: 1.260417, N: 1.088542, O: 0.817708, P: 1.15625, Q: 0.817708, R: 0.875, S: 0.875, T: 1.078125, U: 0.942708, V: 1.239583, W: 1.125, X: 1.203125, Y: 0.927083, Z: 0.942708, "[": 0.584961, "\\": 0.557292, "]": 0.55599, "^": 0.370036, _: 0.80599, "`": 0.221029, a: 0.505208, b: 0.416667, c: 0.364583, d: 0.536458, e: 0.369792, f: 0.666667, g: 0.453125, h: 0.489583, i: 0.3125, j: 0.505208, k: 0.484375, l: 0.3125, m: 0.697917, n: 0.453125, o: 0.292969, p: 0.510417, q: 0.359375, r: 0.46875, s: 0.421875, t: 0.401042, u: 0.505208, v: 0.359375, w: 0.520833, x: 0.505208, y: 0.463542, z: 0.395833, "{": 0.369792, "|": 0.218994, "}": 0.424967, "~": 0.302979, \u00C0: 1.1875, \u00C2: 1.255208, \u00C6: 1.494792, \u00C7: 0.776042, \u00C9: 0.78125, \u00C8: 0.776042, \u00CA: 0.828125, \u00CB: 0.822917, \u00CE: 0.885417, \u00CF: 0.859375, \u00D4: 0.828125, \u0152: 1.390625, \u00D9: 0.963542, \u00DB: 0.994792, \u00DC: 0.963542, \u0178: 0.942708, \u00E0: 0.489583, \u00E2: 0.489583, \u00E6: 0.328125, \u00E7: 0.421875, \u00E9: 0.395833, \u00E8: 0.359375, \u00EA: 0.364583, \u00EB: 0.390625, \u00EE: 0.28125, \u00EF: 0.286458, \u00F4: 0.354167, \u0153: 0.536458, \u00F9: 0.489583, \u00FB: 0.489583, \u00FC: 0.489583, \u00FF: 0.46875 } }, Barcelona: { lineHeight: 1.552083, advances: { "0": 0.459961, "1": 0.263997, "2": 0.593018, "3": 0.621989, "4": 0.642008, "5": 0.471029, "6": 0.562988, "7": 0.63501, "8": 0.524984, "9": 0.458008, " ": 0.247965, "!": 0.35498, '"': 0.219971, "#": 0.597005, $: 0.655029, "%": 0.527995, "&": 0.416016, "'": 0.146973, "(": 0.398031, ")": 0.416016, "*": 0.274007, "+": 0.28304, ",": 0.127035, "-": 0.333984, ".": 0.15096, "/": 0.5, ":": 0.174967, ";": 0.191976, "<": 0.416016, "=": 0.420003, ">": 0.351969, "?": 0.340007, "@": 0.67098, A: 1.098958, B: 1.109375, C: 0.995036, D: 1.036458, E: 1.026042, F: 1.161458, G: 1.010417, H: 1.09375, I: 0.692708, J: 0.984375, K: 0.927083, L: 0.557292, M: 1.600993, N: 1.211019, O: 1.002035, P: 1.1875, Q: 1.063965, R: 1.130208, S: 1.000977, T: 1.098958, U: 1.109375, V: 1.354167, W: 1.59196, X: 1.203125, Y: 0.989583, Z: 0.8125, "[": 0.388021, "\\": 0.572917, "]": 0.327962, "^": 0.357015, _: 0.450033, "`": 0.225016, a: 0.453125, b: 0.552083, c: 0.395833, d: 0.640625, e: 0.375, f: 0.4375, g: 0.671875, h: 0.526042, i: 0.317708, j: 0.635417, k: 0.484375, l: 0.401042, m: 0.666667, n: 0.395833, o: 0.369792, p: 0.630208, q: 0.463542, r: 0.3125, s: 0.401042, t: 0.40625, u: 0.473958, v: 0.46875, w: 0.526042, x: 0.515625, y: 0.666667, z: 0.505208, "{": 0.426025, "|": 0.179036, "}": 0.448975, "~": 0.458984, \u00C0: 1.098958, \u00C2: 1.098958, \u00C6: 0.527018, \u00C7: 0.995036, \u00C9: 1.026042, \u00C8: 1.026042, \u00CA: 1.026042, \u00CB: 1.026042, \u00CE: 0.692708, \u00CF: 0.692708, \u00D4: 1.002035, \u0152: 0.527018, \u00D9: 1.109375, \u00DB: 1.109375, \u00DC: 1.109375, \u0178: 0.527018, \u00E0: 0.453125, \u00E2: 0.453125, \u00E6: 0.527018, \u00E7: 0.395833, \u00E9: 0.375, \u00E8: 0.375, \u00EA: 0.375, \u00EB: 0.375, \u00EE: 0.317708, \u00EF: 0.317708, \u00F4: 0.369792, \u0153: 0.527018, \u00F9: 0.473958, \u00FB: 0.473958, \u00FC: 0.473958, \u00FF: 0.666667 } }, Bayview: { lineHeight: 0.880208, advances: { "0": 0.411458, "1": 0.375, "2": 0.409993, "3": 0.401042, "4": 0.395833, "5": 0.432292, "6": 0.380208, "7": 0.416667, "8": 0.401042, "9": 0.34375, " ": 0.27002, "!": 0.229167, '"': 0.202962, "#": 0.40625, $: 0.421875, "%": 0.411458, "&": 0.5, "'": 0.152018, "(": 0.229167, ")": 0.1875, "*": 0.211995, "+": 0.301025, ",": 0.077962, "-": 0.288981, ".": 0.163981, "/": 0.359375, ":": 0.21403, ";": 0.21403, "<": 0.253988, "=": 0.402018, ">": 0.274007, "?": 0.369792, "@": 0.445964, A: 1.03125, B: 0.78125, C: 0.671875, D: 0.927083, E: 0.807292, F: 0.802083, G: 0.661458, H: 0.744792, I: 1.104167, J: 0.671875, K: 0.901042, L: 0.864583, M: 0.916667, N: 0.807292, O: 0.802083, P: 0.880208, Q: 0.84375, R: 0.901042, S: 0.921875, T: 1.020833, U: 0.760417, V: 0.8125, W: 0.9375, X: 0.880208, Y: 0.625, Z: 1.0625, "[": 0.1875, "\\": 0.351969, "]": 0.192708, "^": 0.201986, _: 0.575033, "`": 0.205973, a: 0.390625, b: 0.369792, c: 0.296875, d: 0.416667, e: 0.307292, f: 0.411458, g: 0.546875, h: 0.416667, i: 0.317708, j: 0.625, k: 0.432292, l: 0.333333, m: 0.5, n: 0.421875, o: 0.333333, p: 0.526042, q: 0.265625, r: 0.291667, s: 0.307292, t: 0.479167, u: 0.447917, v: 0.369792, w: 0.5, x: 0.46875, y: 0.578125, z: 0.246012, "{": 0.197998, "|": 0.213542, "}": 0.218994, "~": 0.21696, \u00C0: 1.036458, \u00C2: 1.052083, \u00C6: 1.390625, \u00C7: 0.666667, \u00C9: 0.8125, \u00C8: 0.8125, \u00CA: 0.8125, \u00CB: 0.8125, \u00CE: 1.104167, \u00CF: 1.104167, \u00D4: 0.802083, \u0152: 1.265625, \u00D9: 0.760417, \u00DB: 0.760417, \u00DC: 0.760417, \u0178: 1.0625, \u00E0: 0.421875, \u00E2: 0.421875, \u00E6: 0.447917, \u00E7: 0.317708, \u00E9: 0.338542, \u00E8: 0.338542, \u00EA: 0.338542, \u00EB: 0.338542, \u00EE: 0.328125, \u00EF: 0.328125, \u00F4: 0.333333, \u0153: 0.442708, \u00F9: 0.447917, \u00FB: 0.447917, \u00FC: 0.447917, \u00FF: 1.15625 } }, Amsterdam: { lineHeight: 1.010417, advances: { "0": 0.61499, "1": 0.422038, "2": 0.617025, "3": 0.531982, "4": 0.517008, "5": 0.534017, "6": 0.572998, "7": 0.517008, "8": 0.531982, "9": 0.572998, " ": 0.278971, "!": 0.375, '"': 0.277995, "#": 0.707031, $: 0.531982, "%": 0.719971, "&": 0.656006, "'": 0.156982, "(": 0.286458, ")": 0.302002, "*": 0.523031, "+": 0.523031, ",": 0.156982, "-": 0.523031, ".": 0.166016, "/": 0.427083, ":": 0.194987, ";": 0.194987, "<": 0.290039, "=": 0.523031, ">": 0.290039, "?": 0.455973, "@": 0.615967, A: 0.619792, B: 0.635986, C: 0.515625, D: 0.624023, E: 0.515625, F: 0.546875, G: 0.540039, H: 0.572917, I: 0.5625, J: 0.53125, K: 0.59375, L: 0.655029, M: 0.755208, N: 0.619792, O: 0.618001, P: 0.572917, Q: 0.61499, R: 0.572917, S: 0.565023, T: 0.5625, U: 0.671875, V: 0.59375, W: 0.875, X: 0.635417, Y: 0.666667, Z: 0.666016, "[": 0.426025, "\\": 0.420003, "]": 0.458984, "^": 0.244792, _: 0.833008, "`": 0.151042, a: 0.505208, b: 0.447917, c: 0.375, d: 0.5625, e: 0.390625, f: 0.46875, g: 0.458333, h: 0.505208, i: 0.307292, j: 0.463542, k: 0.484375, l: 0.34375, m: 0.71875, n: 0.53125, o: 0.458333, p: 0.447917, q: 0.463542, r: 0.40625, s: 0.411458, t: 0.328125, u: 0.484375, v: 0.432292, w: 0.666667, x: 0.463542, y: 0.458333, z: 0.442708, "{": 0.34904, "|": 0.337972, "}": 0.368001, "~": 0.406982, \u00C0: 0.59375, \u00C2: 0.645833, \u00C6: 0.828125, \u00C7: 0.510417, \u00C9: 0.557292, \u00C8: 0.510417, \u00CA: 0.557292, \u00CB: 0.572917, \u00CE: 0.588542, \u00CF: 0.588542, \u00D4: 0.618001, \u0152: 0.807292, \u00D9: 0.6875, \u00DB: 0.6875, \u00DC: 0.6875, \u0178: 0.6875, \u00E0: 0.494792, \u00E2: 0.494792, \u00E6: 0.609375, \u00E7: 0.364583, \u00E9: 0.4375, \u00E8: 0.385417, \u00EA: 0.40625, \u00EB: 0.395833, \u00EE: 0.3125, \u00EF: 0.307292, \u00F4: 0.453125, \u0153: 0.609375, \u00F9: 0.473958, \u00FB: 0.473958, \u00FC: 0.473958, \u00FF: 0.447917 } }, Florence: { lineHeight: 1.096354, advances: { "0": 0.501994, "1": 0.378011, "2": 0.505208, "3": 0.479167, "4": 0.463989, "5": 0.520833, "6": 0.42098, "7": 0.570312, "8": 0.450521, "9": 0.435018, " ": 0.258993, "!": 0.388021, '"': 0.317993, "#": 0.746012, $: 0.541667, "%": 0.640625, "&": 0.729167, "'": 0.158, "(": 0.497396, ")": 0.517985, "*": 0.43099, "+": 0.458008, ",": 0.159017, "-": 0.406006, ".": 0.208008, "/": 0.739583, ":": 0.255981, ";": 0.255005, "<": 0.32902, "=": 0.458008, ">": 0.32902, "?": 0.381999, "@": 0.956014, A: 0.841146, B: 1.072917, C: 0.791667, D: 1.023438, E: 0.84375, F: 1.341146, G: 0.84375, H: 1.518229, I: 1.200521, J: 1.3125, K: 1.627604, L: 0.960938, M: 1.434896, N: 1.182292, O: 0.861979, P: 1.09375, Q: 0.8125, R: 1.088542, S: 0.934896, T: 1.372396, U: 1.002604, V: 1.049479, W: 1.393229, X: 1.213542, Y: 1.109375, Z: 1.067708, "[": 0.585002, "\\": 0.866984, "]": 0.55599, "^": 0.369995, _: 0.80599, "`": 0.211019, a: 0.411458, b: 0.380208, c: 0.322917, d: 0.507812, e: 0.309896, f: 0.4375, g: 0.585938, h: 0.440104, i: 0.244792, j: 0.658854, k: 0.447917, l: 0.309896, m: 0.622396, n: 0.450521, o: 0.335002, p: 0.486979, q: 0.342, r: 0.372396, s: 0.356771, t: 0.257812, u: 0.429688, v: 0.283854, w: 0.476562, x: 0.460938, y: 0.661458, z: 0.625, "{": 0.427083, "|": 0.484985, "}": 0.484985, "~": 0.484985, \u00C0: 0.841146, \u00C2: 0.841146, \u00C6: 1.373006, \u00C7: 0.794271, \u00C9: 0.902018, \u00C8: 0.902018, \u00CA: 0.902018, \u00CB: 0.902018, \u00CE: 1.268229, \u00CF: 1.268229, \u00D4: 0.861979, \u0152: 1.493001, \u00D9: 1.002604, \u00DB: 1.033854, \u00DC: 1.002604, \u0178: 1.109375, \u00E0: 0.411458, \u00E2: 0.411458, \u00E6: 0.492188, \u00E7: 0.333333, \u00E9: 0.346354, \u00E8: 0.302083, \u00EA: 0.333333, \u00EB: 0.307292, \u00EE: 0.296875, \u00EF: 0.257812, \u00F4: 0.359375, \u0153: 0.5, \u00F9: 0.424479, \u00FB: 0.424479, \u00FC: 0.424479, \u00FF: 0.661458 } }, Greenworld: { lineHeight: 0.802083, advances: { "0": 0.337972, "1": 0.337972, "2": 0.337972, "3": 0.337972, "4": 0.337972, "5": 0.337972, "6": 0.337972, "7": 0.337972, "8": 0.337972, "9": 0.337972, " ": 0.225993, "!": 0.184977, '"': 0.208333, "#": 0.552083, $: 0.379964, "%": 0.403971, "&": 0.471029, "'": 0.128988, "(": 0.1875, ")": 0.204997, "*": 0.177979, "+": 0.257975, ",": 0.193034, "-": 0.333984, ".": 0.15096, "/": 0.411458, ":": 0.253988, ";": 0.1875, "<": 0.27596, "=": 0.337972, ">": 0.27596, "?": 0.347982, "@": 0.608968, A: 0.572917, B: 0.506999, C: 0.444987, D: 0.429036, E: 0.375, F: 0.411458, G: 0.458333, H: 0.447917, I: 0.318034, J: 0.354167, K: 0.510417, L: 0.46875, M: 0.942708, N: 0.494792, O: 0.422038, P: 0.338542, Q: 0.578125, R: 0.515625, S: 0.401042, T: 0.3125, U: 0.546875, V: 0.515625, W: 0.791667, X: 0.515625, Y: 0.447917, Z: 0.46875, "[": 0.260417, "\\": 0.129964, "]": 0.260417, "^": 0.219971, _: 0.390625, "`": 0.104167, a: 0.442708, b: 0.416667, c: 0.328125, d: 0.442708, e: 0.333333, f: 0.395833, g: 0.40625, h: 0.515625, i: 0.265625, j: 0.380208, k: 0.489583, l: 0.317708, m: 0.661458, n: 0.520833, o: 0.411458, p: 0.572917, q: 0.411458, r: 0.348958, s: 0.265625, t: 0.298991, u: 0.46875, v: 0.361003, w: 0.598958, x: 0.432292, y: 0.4375, z: 0.380208, "{": 0.192708, "|": 0.166992, "}": 0.192708, "~": 0.22998, \u00C0: 0.572917, \u00C2: 0.598958, \u00C6: 0.822917, \u00C7: 0.40625, \u00C9: 0.375, \u00C8: 0.375, \u00CA: 0.375, \u00CB: 0.375, \u00CE: 0.328125, \u00CF: 0.317708, \u00D4: 0.375, \u0152: 0.65625, \u00D9: 0.546875, \u00DB: 0.546875, \u00DC: 0.546875, \u0178: 0.447917, \u00E0: 0.442708, \u00E2: 0.442708, \u00E6: 0.515625, \u00E7: 0.333333, \u00E9: 0.333333, \u00E8: 0.333333, \u00EA: 0.333333, \u00EB: 0.333333, \u00EE: 0.28125, \u00EF: 0.265625, \u00F4: 0.411458, \u0153: 0.520833, \u00F9: 0.46875, \u00FB: 0.46875, \u00FC: 0.46875, \u00FF: 0.4375 } }, LazySunday: { lineHeight: 1.158854, advances: { "0": 0.487996, "1": 0.182007, "2": 0.442993, "3": 0.468994, "4": 0.440999, "5": 0.425008, "6": 0.428019, "7": 0.388997, "8": 0.373983, "9": 0.428019, " ": 0.307007, "!": 0.130005, '"': 0.246012, "#": 0.590007, $: 0.494995, "%": 0.524007, "&": 0.52002, "'": 0.123006, "(": 0.315999, ")": 0.315999, "*": 0.432007, "+": 0.409993, ",": 0.142008, "-": 0.390991, ".": 0.133993, "/": 0.595988, ":": 0.133016, ";": 0.142008, "<": 0.465983, "=": 0.383993, ">": 0.465983, "?": 0.440999, "@": 0.847982, A: 0.888021, B: 0.715983, C: 0.664062, D: 0.86499, E: 0.721354, F: 0.601562, G: 0.69401, H: 1.158854, I: 0.550008, J: 0.461019, K: 1.080729, L: 0.848958, M: 1.380208, N: 0.937012, O: 0.602987, P: 0.713989, Q: 0.677083, R: 0.869792, S: 0.505981, T: 0.593994, U: 1.138021, V: 0.904012, W: 1.326986, X: 1.010417, Y: 0.86202, Z: 0.810994, "[": 0.234009, "\\": 0.595988, "]": 0.234009, "^": 0.486003, _: 0.861003, "`": 0.269002, a: 0.695312, b: 0.470988, c: 0.489583, d: 0.6875, e: 0.489583, f: 0.453125, g: 0.47998, h: 0.609375, i: 0.351562, j: 0.416667, k: 0.557292, l: 0.348958, m: 0.90625, n: 0.627604, o: 0.437988, p: 0.461995, q: 0.482015, r: 0.375, s: 0.451009, t: 0.401042, u: 0.6875, v: 0.567708, w: 0.916667, x: 0.549479, y: 0.475016, z: 0.460938, "{": 0.369019, "|": 0.114014, "}": 0.369019, "~": 0.652995, \u00C0: 0.888021, \u00C2: 0.911011, \u00C6: 1.507812, \u00C7: 0.687012, \u00C9: 0.744019, \u00C8: 0.721354, \u00CA: 0.721354, \u00CB: 0.744019, \u00CE: 0.534993, \u00CF: 0.550985, \u00D4: 0.583008, \u0152: 1.192708, \u00D9: 1.138021, \u00DB: 1.138021, \u00DC: 1.138021, \u0178: 0.86202, \u00E0: 0.695312, \u00E2: 0.695312, \u00E6: 1.117188, \u00E7: 0.489583, \u00E9: 0.489583, \u00E8: 0.489583, \u00EA: 0.489583, \u00EB: 0.489583, \u00EE: 0.421875, \u00EF: 0.411458, \u00F4: 0.437988, \u0153: 0.815104, \u00F9: 0.6875, \u00FB: 0.6875, \u00FC: 0.6875, \u00FF: 0.475016 } }, NewCursive: { lineHeight: 0.864583, advances: { "0": 0.357015, "1": 0.260417, "2": 0.422038, "3": 0.46875, "4": 0.381022, "5": 0.432292, "6": 0.340007, "7": 0.32902, "8": 0.421875, "9": 0.307292, " ": 0.266032, "!": 0.5, '"': 0.228027, "#": 0.482992, $: 0.312012, "%": 0.469971, "&": 0.453125, "'": 0.128011, "(": 0.416667, ")": 0.421875, "*": 0.41097, "+": 0.384033, ",": 0.232992, "-": 0.363037, ".": 0.159017, "/": 0.421875, ":": 0.291992, ";": 0.417969, "<": 0.317708, "=": 0.386963, ">": 0.317708, "?": 0.48999, "@": 0.617025, A: 0.552083, B: 0.5, C: 0.416667, D: 0.598958, E: 0.453125, F: 0.630208, G: 0.734375, H: 0.5625, I: 0.484375, J: 0.453125, K: 0.536458, L: 0.598958, M: 0.729167, N: 0.489583, O: 0.526042, P: 0.46875, Q: 0.479167, R: 0.552083, S: 0.526042, T: 0.484375, U: 0.557292, V: 0.520833, W: 0.796875, X: 0.536458, Y: 0.541667, Z: 0.484375, "[": 0.46875, "\\": 0.317708, "]": 0.46875, "^": 0.317708, _: 0.390625, "`": 0.165039, a: 0.380208, b: 0.354167, c: 0.28125, d: 0.390625, e: 0.260417, f: 0.421875, g: 0.375, h: 0.390625, i: 0.21875, j: 0.390625, k: 0.348958, l: 0.286458, m: 0.552083, n: 0.458333, o: 0.333333, p: 0.473958, q: 0.348958, r: 0.296875, s: 0.34375, t: 0.25, u: 0.385417, v: 0.4375, w: 0.520833, x: 0.395833, y: 0.416667, z: 0.40625, "{": 0.4375, "|": 0.375977, "}": 0.448975, "~": 0.135417, \u00C0: 0.541667, \u00C2: 0.567708, \u00C6: 0.932292, \u00C7: 0.411458, \u00C9: 0.453125, \u00C8: 0.453125, \u00CA: 0.458333, \u00CB: 0.453125, \u00CE: 0.520833, \u00CF: 0.53125, \u00D4: 0.520833, \u0152: 0.828125, \u00D9: 0.557292, \u00DB: 0.557292, \u00DC: 0.557292, \u0178: 0.536458, \u00E0: 0.375, \u00E2: 0.375, \u00E6: 0.588542, \u00E7: 0.28125, \u00E9: 0.255208, \u00E8: 0.255208, \u00EA: 0.255208, \u00EB: 0.255208, \u00EE: 0.213542, \u00EF: 0.208333, \u00F4: 0.328125, \u0153: 0.541667, \u00F9: 0.375, \u00FB: 0.375, \u00FC: 0.375, \u00FF: 0.411458 } }, NottingHill: { lineHeight: 1.304688, advances: { "0": 0.515991, "1": 0.286458, "2": 0.574015, "3": 0.46875, "4": 0.458333, "5": 0.463542, "6": 0.476562, "7": 0.430013, "8": 0.418009, "9": 0.486003, " ": 0.197998, "!": 0.229004, '"': 0.148438, "#": 0.489583, $: 0.39502, "%": 0.276001, "&": 0.263997, "'": 0.078125, "(": 0.330729, ")": 0.330729, "*": 0.168009, "+": 0.359375, ",": 0.090007, "-": 0.366007, ".": 0.072917, "/": 0.291992, ":": 0.083008, ";": 0.107015, "<": 0.158854, "=": 0.38798, ">": 0.158854, "?": 0.288005, "@": 0.506999, A: 0.645833, B: 0.80599, C: 0.706014, D: 0.868001, E: 0.743001, F: 0.9375, G: 0.682292, H: 0.968994, I: 0.833333, J: 0.994792, K: 0.786458, L: 0.583333, M: 0.876017, N: 0.846354, O: 0.887004, P: 0.731771, Q: 0.887004, R: 0.729167, S: 0.721354, T: 0.994792, U: 0.953125, V: 0.851562, W: 1.21875, X: 0.992188, Y: 0.788005, Z: 0.963542, "[": 0.408854, "\\": 0.300008, "]": 0.408854, "^": 0.151001, _: 0.440104, "`": 0.102987, a: 0.554688, b: 0.466146, c: 0.40625, d: 0.609375, e: 0.411458, f: 0.539062, g: 0.796875, h: 0.588542, i: 0.359375, j: 0.794271, k: 0.479167, l: 0.429688, m: 0.807292, n: 0.619792, o: 0.46875, p: 0.614583, q: 0.526042, r: 0.575521, s: 0.601562, t: 0.395833, u: 0.604167, v: 0.398438, w: 0.583333, x: 0.567708, y: 0.794271, z: 0.776042, "{": 0.440104, "|": 0.286458, "}": 0.440104, "~": 0.244019, \u00C0: 0.645833, \u00C2: 0.65625, \u00C6: 1.164062, \u00C7: 0.706014, \u00C9: 0.743001, \u00C8: 0.743001, \u00CA: 0.743001, \u00CB: 0.743001, \u00CE: 0.833333, \u00CF: 0.833333, \u00D4: 0.887004, \u00D9: 0.953125, \u00DB: 0.953125, \u00DC: 0.953125, \u0178: 0.788005, \u00E0: 0.554688, \u00E2: 0.554688, \u00E6: 0.846354, \u00E7: 0.40625, \u00E9: 0.411458, \u00E8: 0.411458, \u00EA: 0.411458, \u00EB: 0.411458, \u00EE: 0.359375, \u00EF: 0.359375, \u00F4: 0.471354, \u0153: 0.752604, \u00F9: 0.604167, \u00FB: 0.604167, \u00FC: 0.604167, \u00FF: 0.796875 } }, Olivia: { lineHeight: 1.414062, advances: { "0": 0.520508, "1": 0.34375, "2": 0.609375, "3": 0.632812, "4": 0.645833, "5": 0.520833, "6": 0.527832, "7": 0.536458, "8": 0.524902, "9": 0.549316, " ": 0.199219, "!": 0.289062, '"': 0.266113, "#": 0.841146, $: 0.585938, "%": 0.53125, "&": 0.776042, "'": 0.146973, "(": 0.494792, ")": 0.494792, "*": 0.215332, "+": 0.463867, ",": 0.200684, "-": 0.408691, ".": 0.200684, "/": 0.5625, ":": 0.258301, ";": 0.258301, "<": 0.463867, "=": 0.494629, ">": 0.463867, "?": 0.497396, "@": 0.711426, A: 1.028646, B: 1.032227, C: 1.010417, D: 1.203125, E: 1.049479, F: 1.013021, G: 0.90625, H: 1.078125, I: 0.692708, J: 0.989583, K: 1.171875, L: 0.713542, M: 1.117188, N: 0.890625, O: 0.941406, P: 1.322917, Q: 0.942871, R: 1.125, S: 1.101562, T: 1.104167, U: 0.817708, V: 0.835938, W: 1.216146, X: 1.065104, Y: 0.877441, Z: 0.989583, "[": 0.565104, "\\": 0.348145, "]": 0.565104, "^": 0.274902, _: 0.414062, "`": 0.195801, a: 0.453125, b: 0.416667, c: 0.304688, d: 0.520833, e: 0.315104, f: 0.427083, g: 0.619792, h: 0.455729, i: 0.278646, j: 0.596354, k: 0.424479, l: 0.382812, m: 0.5625, n: 0.492188, o: 0.377604, p: 0.559896, q: 0.414062, r: 0.356771, s: 0.372396, t: 0.385417, u: 0.408854, v: 0.4375, w: 0.539062, x: 0.466146, y: 0.679688, z: 0.614583, "{": 0.528646, "|": 0.61377, "}": 0.528646, "~": 0.463867, \u00C0: 1.028646, \u00C2: 1.070312, \u00C6: 1.6875, \u00C7: 1.010417, \u00C9: 1.049479, \u00C8: 1.049479, \u00CA: 1.049479, \u00CB: 1.049479, \u00CE: 0.692708, \u00CF: 0.692708, \u00D4: 0.941406, \u0152: 1.619792, \u00D9: 0.817708, \u00DB: 0.817708, \u00DC: 0.817708, \u0178: 0.877441, \u00E0: 0.453125, \u00E2: 0.453125, \u00E6: 0.460938, \u00E7: 0.304688, \u00E9: 0.315104, \u00E8: 0.315104, \u00EA: 0.315104, \u00EB: 0.315104, \u00EE: 0.283854, \u00EF: 0.28125, \u00F4: 0.377604, \u0153: 0.458333, \u00F9: 0.408854, \u00FB: 0.408854, \u00FC: 0.408854, \u00FF: 0.679688 } }, Vintage: { lineHeight: 1.026042, advances: { "0": 0.497965, "1": 0.359375, "2": 0.526042, "3": 0.453125, "4": 0.515625, "5": 0.546875, "6": 0.47998, "7": 0.515625, "8": 0.510417, "9": 0.490967, " ": 0.299967, "!": 0.302083, '"': 0.277995, "#": 0.53597, $: 0.454997, "%": 0.413005, "&": 0.577962, "'": 0.209961, "(": 0.416667, ")": 0.431966, "*": 0.291992, "+": 0.353027, ",": 0.243001, "-": 0.370036, ".": 0.155029, "/": 0.333333, ":": 0.256022, ";": 0.298991, "<": 0.489014, "=": 0.402018, ">": 0.495036, "?": 0.472005, "@": 0.726969, A: 0.817708, B: 0.794027, C: 0.65625, D: 0.833008, E: 0.541667, F: 0.833333, G: 0.760417, H: 0.90625, I: 0.6875, J: 0.635417, K: 1.036458, L: 0.78125, M: 1.104167, N: 0.807292, O: 0.802083, P: 0.78125, Q: 0.958333, R: 0.760417, S: 0.552002, T: 0.911458, U: 0.838542, V: 0.953125, W: 1.161458, X: 1.036458, Y: 0.828125, Z: 0.786458, "[": 0.494792, "\\": 0.298014, "]": 0.524984, "^": 0.370036, _: 0.454997, a: 0.463542, b: 0.458333, c: 0.375, d: 0.494792, e: 0.375, f: 0.71875, g: 0.572917, h: 0.520833, i: 0.260417, j: 0.578125, k: 0.510417, l: 0.28125, m: 0.734375, n: 0.515625, o: 0.458333, p: 0.59375, q: 0.463542, r: 0.427083, s: 0.38501, t: 0.28125, u: 0.463542, v: 0.421875, w: 0.59375, x: 0.515625, y: 0.572917, z: 0.546875, "{": 0.510417, "|": 0.34375, "}": 0.510417, "~": 0.472005, \u00C0: 0.848958, \u00C2: 0.890625, \u00C6: 1.166667, \u00C7: 0.65625, \u00C9: 0.536458, \u00C8: 0.536458, \u00CA: 0.536458, \u00CB: 0.536458, \u00CE: 0.791667, \u00CF: 0.78125, \u00D4: 0.796875, \u0152: 1.104167, \u00D9: 0.833333, \u00DB: 0.833333, \u00DC: 0.833333, \u0178: 0.822917, \u00E0: 0.463542, \u00E2: 0.463542, \u00E6: 0.609375, \u00E7: 0.380208, \u00E9: 0.390625, \u00E8: 0.375, \u00EA: 0.375, \u00EB: 0.375, \u00EE: 0.260417, \u00EF: 0.260417, \u00F4: 0.458333, \u0153: 0.583333, \u00F9: 0.473958, \u00FB: 0.473958, \u00FC: 0.473958, \u00FF: 0.572917 } }, Venetian: { lineHeight: 1.21875, advances: { "0": 0.370036, "1": 0.340007, "2": 0.437012, "3": 0.378988, "4": 0.327962, "5": 0.396973, "6": 0.381999, "7": 0.358968, "8": 0.378988, "9": 0.399007, " ": 0.245036, "!": 0.441976, '"': 0.257975, "#": 0.767985, $: 0.517985, "%": 0.465007, "&": 0.712972, "'": 0.166016, "(": 0.447917, ")": 0.442708, "*": 0.334961, "+": 0.412028, ",": 0.264974, "-": 0.406982, ".": 0.238037, "/": 0.461995, ":": 0.254964, ";": 0.281006, "<": 0.277995, "=": 0.430013, ">": 0.315999, "?": 0.520996, "@": 0.930013, A: 0.875, B: 0.854167, C: 0.682292, D: 0.878988, E: 0.625, F: 1.098958, G: 0.697917, H: 1.072917, I: 0.802083, J: 0.921875, K: 0.979167, L: 0.677083, M: 1.083333, N: 1.088542, O: 0.640625, P: 0.854167, Q: 0.640625, R: 0.854167, S: 0.973958, T: 1.083333, U: 1.020833, V: 0.947917, W: 1.244792, X: 0.895833, Y: 0.932292, Z: 0.796875, "[": 0.447917, "\\": 0.570964, "]": 0.506022, "^": 0.284017, _: 0.833008, "`": 0.375, a: 0.427083, b: 0.536458, c: 0.307292, d: 0.713542, e: 0.302083, f: 0.890625, g: 0.677083, h: 0.546875, i: 0.213542, j: 0.755208, k: 0.546875, l: 0.505208, m: 0.557292, n: 0.40625, o: 0.364583, p: 0.953125, q: 0.447917, r: 0.265625, s: 0.317708, t: 0.416667, u: 0.369792, v: 0.338542, w: 0.489583, x: 0.375, y: 0.666667, z: 0.333333, "{": 0.395833, "|": 0.371012, "}": 0.395833, "~": 0.478027, \u00C0: 0.921875, \u00C2: 0.921875, \u00C6: 1.213542, \u00C7: 0.692708, \u00C9: 0.630208, \u00C8: 0.630208, \u00CA: 0.630208, \u00CB: 0.630208, \u00CE: 0.807292, \u00CF: 0.807292, \u00D4: 0.651042, \u0152: 1.063965, \u00D9: 1.020833, \u00DB: 1.020833, \u00DC: 1.020833, \u0178: 0.932292, \u00E0: 0.432292, \u00E2: 0.432292, \u00E6: 0.526042, \u00E7: 0.317708, \u00E9: 0.3125, \u00E8: 0.3125, \u00EA: 0.317708, \u00EB: 0.3125, \u00EE: 0.239583, \u00EF: 0.239583, \u00F4: 0.364583, \u0153: 0.552979, \u00F9: 0.380208, \u00FB: 0.380208, \u00FC: 0.380208, \u00FF: 0.729167 } }, Weekender: { lineHeight: 1.973958, advances: { "0": 0.652018, "1": 0.309001, "2": 0.663005, "3": 0.560994, "4": 0.579997, "5": 0.590007, "6": 0.548991, "7": 0.545003, "8": 0.585002, "9": 0.548991, " ": 0.319987, "!": 0.187988, '"': 0.258016, "#": 0.442017, $: 0.690999, "%": 0.588013, "&": 0.737996, "'": 0.185994, "(": 0.26298, ")": 0.262004, "*": 0.269002, "+": 0.326009, ",": 0.185994, "-": 0.406006, ".": 0.211019, "/": 0.416992, ":": 0.187988, ";": 0.187988, "<": 0.20402, "=": 0.343018, ">": 0.20402, "?": 0.560994, "@": 0.845011, A: 0.984375, B: 0.928996, C: 0.848999, D: 0.881999, E: 1.055013, F: 1.21875, G: 0.937012, H: 1.177002, I: 0.434001, J: 0.810994, K: 1.304688, L: 1.135417, M: 1.142985, N: 1.109985, O: 0.991007, P: 0.800985, Q: 0.97998, R: 0.908854, S: 0.989014, T: 1.419271, U: 0.976562, V: 1.355998, W: 1.831014, X: 1.380981, Y: 1.163981, Z: 0.934896, "[": 0.319987, "\\": 0.524007, "]": 0.319987, "^": 0.277995, _: 0.52299, "`": 0.187988, a: 0.609375, b: 0.567708, c: 0.453125, d: 0.677083, e: 0.453125, f: 0.440104, g: 0.661458, h: 0.588542, i: 0.361979, j: 0.661458, k: 0.494792, l: 0.414062, m: 0.692708, n: 0.552083, o: 0.559896, p: 0.559896, q: 0.59375, r: 0.44401, s: 0.424479, t: 0.966146, u: 0.611979, v: 0.510417, w: 0.726562, x: 0.523438, y: 0.661458, z: 0.656006, "{": 0.342, "|": 0.147013, "}": 0.342, \u00C0: 0.984375, \u00C2: 0.984375, \u00C6: 1.786011, \u00C7: 0.86499, \u00C9: 1.060994, \u00C8: 1.060994, \u00CA: 1.060994, \u00CB: 1.060994, \u00CE: 0.404012, \u00CF: 0.435018, \u00D4: 0.982015, \u0152: 1.928019, \u00D9: 0.976562, \u00DB: 0.976562, \u00DC: 0.976562, \u0178: 1.149007, \u00E0: 0.609375, \u00E2: 0.609375, \u00E6: 0.669271, \u00E7: 0.46875, \u00E9: 0.453125, \u00E8: 0.453125, \u00EA: 0.453125, \u00EB: 0.453125, \u00EE: 0.429688, \u00EF: 0.403646, \u00F4: 0.5625, \u0153: 0.75, \u00F9: 0.611979, \u00FB: 0.609375, \u00FC: 0.609375, \u00FF: 0.661458 } }, Amanda: { lineHeight: 1.276042, advances: { "0": 0.653971, "1": 0.448975, "2": 0.601969, "3": 0.643962, "4": 0.613037, "5": 0.669027, "6": 0.552083, "7": 0.691976, "8": 0.755208, "9": 0.621012, " ": 0.323975, "!": 0.558024, '"': 0.424967, "#": 0.649984, $: 0.694987, "%": 0.688965, "&": 0.786458, "'": 0.327962, "(": 0.646973, ")": 0.621012, "*": 0.517008, "+": 0.541016, ",": 0.327962, "-": 0.506999, ".": 0.268962, "/": 0.691976, ":": 0.350016, ";": 0.368978, "<": 0.562012, "=": 0.527995, ">": 0.509033, "?": 0.625977, "@": 0.656006, A: 0.942708, B: 0.739583, C: 0.723958, D: 0.6875, E: 0.692708, F: 0.786458, G: 0.734375, H: 0.744792, I: 0.776042, J: 0.770833, K: 0.661458, L: 0.911458, M: 0.760417, N: 0.598958, O: 0.703125, P: 0.666667, Q: 0.645833, R: 0.807292, S: 0.651042, T: 0.776042, U: 0.59375, V: 0.505208, W: 1.005208, X: 0.713542, Y: 0.557292, Z: 0.760417, "[": 0.677979, "\\": 0.472005, "]": 0.697998, "^": 0.38501, _: 0.390625, "`": 0.329997, a: 0.526042, b: 0.395833, c: 0.427083, d: 0.552083, e: 0.46875, f: 0.604167, g: 0.604167, h: 0.640625, i: 0.348958, j: 0.583333, k: 0.541667, l: 0.375, m: 0.703125, n: 0.588542, o: 0.46875, p: 0.515625, q: 0.298014, r: 0.364583, s: 0.463542, t: 0.677083, u: 0.541667, v: 0.479167, w: 0.666667, x: 0.609375, y: 0.619792, z: 0.609375, "{": 0.632975, "|": 0.472005, "}": 0.663005, "~": 0.503988, \u00C0: 0.942708, \u00C2: 0.942708, \u00C6: 0.427083, \u00C7: 0.723958, \u00C9: 0.692708, \u00C8: 0.692708, \u00CA: 0.692708, \u00CB: 0.692708, \u00CE: 0.776042, \u00CF: 0.776042, \u00D4: 0.703125, \u0152: 0.427083, \u00D9: 0.59375, \u00DB: 0.59375, \u00DC: 0.59375, \u0178: 0.427083, \u00E0: 0.526042, \u00E2: 0.526042, \u00E6: 0.427083, \u00E7: 0.427083, \u00E9: 0.46875, \u00E8: 0.46875, \u00EA: 0.46875, \u00EB: 0.46875, \u00EE: 0.348958, \u00EF: 0.348958, \u00F4: 0.46875, \u0153: 0.427083, \u00F9: 0.541667, \u00FB: 0.541667, \u00FC: 0.541667, \u00FF: 0.619792 } }, Austin: { lineHeight: 0.78125, advances: { "0": 0.264648, "1": 0.148926, "2": 0.258789, "3": 0.228027, "4": 0.234863, "5": 0.246582, "6": 0.223145, "7": 0.193848, "8": 0.248535, "9": 0.241699, " ": 0.286133, "!": 0.153809, '"': 0.148438, "#": 0.442383, $: 0.267578, "%": 0.356934, "&": 0.304688, "'": 0.080078, "(": 0.166667, ")": 0.171875, "*": 0.202148, "+": 0.275879, ",": 0.084473, "-": 0.268066, ".": 0.094238, "/": 0.338542, ":": 0.121094, ";": 0.115234, "<": 0.189941, "=": 0.268066, ">": 0.159668, "?": 0.225586, "@": 0.373047, A: 0.635417, B: 0.535156, C: 0.53125, D: 0.453125, E: 0.484375, F: 0.614583, G: 0.546875, H: 0.677083, I: 0.276042, J: 0.463542, K: 0.494792, L: 0.302083, M: 0.756836, N: 0.575195, O: 0.46875, P: 0.385417, Q: 0.453125, R: 0.411458, S: 0.401042, T: 0.640625, U: 0.471191, V: 0.475098, W: 0.712402, X: 0.484375, Y: 0.740234, Z: 0.541667, "[": 0.161458, "\\": 0.338542, "]": 0.171875, "^": 0.201172, _: 0.286133, "`": 0.121094, a: 0.328125, b: 0.209473, c: 0.25, d: 0.234375, e: 0.265625, f: 0.1875, g: 0.307292, h: 0.328125, i: 0.203125, j: 0.328125, k: 0.328125, l: 0.197917, m: 0.421875, n: 0.432292, o: 0.223958, p: 0.25, q: 0.203125, r: 0.208333, s: 0.234375, t: 0.244792, u: 0.276042, v: 0.244792, w: 0.385417, x: 0.328125, y: 0.228516, z: 0.307292, "{": 0.182292, "|": 0.516602, "}": 0.1875, "~": 0.273926, \u00C0: 0.5, \u00C2: 0.5, \u00C6: 0.5, \u00C7: 0.5, \u00C9: 0.5, \u00C8: 0.5, \u00CA: 0.5, \u00CB: 0.5, \u00CE: 0.5, \u00CF: 0.5, \u00D4: 0.5, \u0152: 0.5, \u00D9: 0.5, \u00DB: 0.5, \u00DC: 0.5, \u0178: 0.5, \u00E0: 0.5, \u00E2: 0.5, \u00E6: 0.5, \u00E7: 0.5, \u00E9: 0.5, \u00E8: 0.5, \u00EA: 0.5, \u00EB: 0.5, \u00EE: 0.5, \u00EF: 0.5, \u00F4: 0.5, \u0153: 0.5, \u00F9: 0.5, \u00FB: 0.5, \u00FC: 0.5, \u00FF: 0.5 } }, Beachfront: { lineHeight: 1.234375, advances: { "0": 0.625, "1": 0.390788, "2": 0.635417, "3": 0.623861, "4": 0.614583, "5": 0.640625, "6": 0.590739, "7": 0.526042, "8": 0.619792, "9": 0.588542, " ": 0.230794, "!": 0.219971, '"': 0.236898, "#": 0.875, $: 0.572917, "%": 0.692301, "&": 0.760417, "'": 0.230794, "(": 0.427083, ")": 0.4375, "*": 0.395833, "+": 0.467692, ",": 0.242269, "-": 0.343099, ".": 0.167725, "/": 0.489583, ":": 0.20459, ";": 0.259196, "<": 0.476156, "=": 0.507731, ">": 0.476156, "?": 0.427083, "@": 0.989583, A: 0.864583, B: 0.790039, C: 0.8125, D: 0.84375, E: 0.802083, F: 0.869792, G: 0.817708, H: 0.833333, I: 0.932292, J: 1.151042, K: 0.84375, L: 0.640788, M: 1.036458, N: 0.927083, O: 0.791667, P: 0.708333, Q: 0.796875, R: 0.729167, S: 0.770833, T: 0.942708, U: 0.75, V: 0.729167, W: 1.125, X: 0.90625, Y: 0.765625, Z: 0.901042, "[": 0.489583, "\\": 0.403809, "]": 0.505208, "^": 0.434652, _: 0.600016, "`": 0.243815, a: 0.431559, b: 0.421875, c: 0.377686, d: 0.552083, e: 0.380778, f: 0.552083, g: 0.625, h: 0.438477, i: 0.175374, j: 0.6875, k: 0.423828, l: 0.25, m: 0.645833, n: 0.426921, o: 0.375407, p: 0.536458, q: 0.407715, r: 0.40625, s: 0.375, t: 0.666667, u: 0.420736, v: 0.390625, w: 0.630208, x: 0.494792, y: 0.423096, z: 0.432292, "{": 0.463542, "|": 0.265625, "}": 0.447917, "~": 0.540039, \u00C0: 0.869792, \u00C2: 0.869792, \u00C6: 1.338542, \u00C7: 0.802083, \u00C9: 0.807292, \u00C8: 0.807292, \u00CA: 0.807292, \u00CB: 0.807292, \u00CE: 0.958333, \u00CF: 0.958333, \u00D4: 0.786458, \u0152: 1.338542, \u00D9: 0.75, \u00DB: 0.75, \u00DC: 0.75, \u0178: 0.765625, \u00E0: 0.432292, \u00E2: 0.473958, \u00E6: 0.682292, \u00E7: 0.377686, \u00E9: 0.4375, \u00E8: 0.401042, \u00EA: 0.427083, \u00EB: 0.380778, \u00EE: 0.317708, \u00EF: 0.213542, \u00F4: 0.421875, \u0153: 0.651042, \u00F9: 0.420736, \u00FB: 0.420736, \u00FC: 0.420736, \u00FF: 0.423096 } }, Chelsea: { lineHeight: 1.057292, advances: { "0": 0.256022, "1": 0.281006, "2": 0.298014, "3": 0.315023, "4": 0.268962, "5": 0.297038, "6": 0.208008, "7": 0.28125, "8": 0.274984, "9": 0.277018, " ": 0.284017, "!": 0.16097, '"': 0.194987, "#": 0.371012, $: 0.292969, "%": 0.316976, "&": 0.357015, "'": 0.131022, "(": 0.265625, ")": 0.270833, "*": 0.193034, "+": 0.231038, ",": 0.115967, "-": 0.281982, ".": 0.159993, "/": 0.390625, ":": 0.10498, ";": 0.156982, "<": 0.201009, "=": 0.27596, ">": 0.156982, "?": 0.291992, "@": 0.312988, A: 0.557292, B: 0.506022, C: 0.427083, D: 0.635417, E: 0.765625, F: 0.645833, G: 0.493001, H: 0.598958, I: 0.572917, J: 0.369792, K: 0.572917, L: 0.484375, M: 0.859375, N: 0.661458, O: 0.473958, P: 0.59375, Q: 0.46875, R: 0.6875, S: 0.548014, T: 0.848958, U: 0.5625, V: 0.661458, W: 0.765625, X: 0.666667, Y: 0.541667, Z: 0.479167, "[": 0.223958, "\\": 0.385417, "]": 0.223958, "^": 0.240967, _: 0.392008, "`": 0.211995, a: 0.239583, b: 0.229167, c: 0.25, d: 0.270833, e: 0.213542, f: 0.348958, g: 0.505208, h: 0.390625, i: 0.208333, j: 0.463542, k: 0.338542, l: 0.25, m: 0.463542, n: 0.322917, o: 0.234375, p: 0.328125, q: 0.338542, r: 0.197917, s: 0.302083, t: 0.369792, u: 0.255208, v: 0.276042, w: 0.432292, x: 0.328125, y: 0.5, z: 0.395833, "{": 0.276042, "|": 0.223958, "}": 0.23999, "~": 0.311035, \u00C0: 0.567708, \u00C2: 0.625, \u00C6: 0.989583, \u00C7: 0.421875, \u00C9: 0.765625, \u00C8: 0.765625, \u00CA: 0.765625, \u00CB: 0.765625, \u00CE: 0.572917, \u00CF: 0.572917, \u00D4: 0.473958, \u0152: 0.947917, \u00D9: 0.5625, \u00DB: 0.5625, \u00DC: 0.5625, \u0178: 0.541667, \u00E0: 0.239583, \u00E2: 0.239583, \u00E6: 0.3125, \u00E7: 0.25, \u00E9: 0.213542, \u00E8: 0.213542, \u00EA: 0.213542, \u00EB: 0.213542, \u00EE: 0.197917, \u00EF: 0.197917, \u00F4: 0.234375, \u0153: 0.286458, \u00F9: 0.255208, \u00FB: 0.255208, \u00FC: 0.255208, \u00FF: 0.5 } }, Freehand: { lineHeight: 1.026042, advances: { "0": 0.40096, "1": 0.291992, "2": 0.332031, "3": 0.357015, "4": 0.368978, "5": 0.442708, "6": 0.333008, "7": 0.323975, "8": 0.31901, "9": 0.429036, " ": 0.184977, "!": 0.167969, '"': 0.232992, "#": 0.481038, $: 0.309001, "%": 0.447917, "&": 0.429036, "'": 0.166992, "(": 0.34375, ")": 0.348958, "*": 0.232992, "+": 0.306966, ",": 0.142985, "-": 0.253988, ".": 0.136963, "/": 0.359375, ":": 0.127035, ";": 0.121989, "<": 0.413981, "=": 0.253988, ">": 0.421875, "?": 0.302979, "@": 0.549967, A: 0.505208, B: 0.458333, C: 0.416667, D: 0.52002, E: 0.432292, F: 0.520833, G: 0.5, H: 0.586995, I: 0.557292, J: 0.458008, K: 0.552083, L: 0.427083, M: 0.708984, N: 0.5, O: 0.531982, P: 0.4375, Q: 0.473958, R: 0.4375, S: 0.531006, T: 0.682292, U: 0.544027, V: 0.484375, W: 0.635986, X: 0.463542, Y: 0.495036, Z: 0.492025, "[": 0.299967, "\\": 0.392008, "]": 0.296875, "^": 0.219971, _: 0.361979, "`": 0.152995, a: 0.390625, b: 0.286458, c: 0.328125, d: 0.4375, e: 0.270833, f: 0.28125, g: 0.267985, h: 0.40625, i: 0.208333, j: 0.239583, k: 0.395833, l: 0.265625, m: 0.5625, n: 0.427083, o: 0.276042, p: 0.458333, q: 0.390625, r: 0.3125, s: 0.328125, t: 0.744792, u: 0.34375, v: 0.260417, w: 0.369792, x: 0.380208, y: 0.28125, z: 0.416667, "{": 0.34375, "|": 0.231038, "}": 0.295003, "~": 0.256999, \u00C0: 0.505208, \u00C2: 0.505208, \u00C6: 0.765625, \u00C7: 0.416667, \u00C9: 0.453125, \u00C8: 0.432292, \u00CA: 0.453125, \u00CB: 0.432292, \u00CE: 0.557292, \u00CF: 0.557292, \u00D4: 0.531982, \u0152: 0.798014, \u00D9: 0.544027, \u00DB: 0.545003, \u00DC: 0.545003, \u0178: 0.495036, \u00E0: 0.390625, \u00E2: 0.390625, \u00E6: 0.46875, \u00E7: 0.328125, \u00E9: 0.276042, \u00E8: 0.276042, \u00EA: 0.276042, \u00EB: 0.276042, \u00EE: 0.244792, \u00EF: 0.213542, \u00F4: 0.276042, \u0153: 0.416667, \u00F9: 0.34375, \u00FB: 0.34375, \u00FC: 0.34375, \u00FF: 0.291016 } }, Freespirit: { lineHeight: 1.802083, advances: { "0": 0.454997, "1": 0.379964, "2": 0.53304, "3": 0.521973, "4": 0.490967, "5": 0.59904, "6": 0.476969, "7": 0.440999, "8": 0.427979, "9": 0.405029, " ": 0.399984, "!": 0.378011, '"': 0.447021, "#": 0.743001, $: 0.934977, "%": 0.718994, "&": 0.833008, "'": 0.249023, "(": 0.34196, ")": 0.377035, "*": 0.427979, "+": 0.639974, ",": 0.195964, "-": 0.784017, ".": 0.191976, "/": 0.681966, ":": 0.187988, ";": 0.195964, "<": 0.596029, "=": 0.611979, ">": 0.5, "?": 0.555013, "@": 0.823975, A: 0.867025, B: 1.622965, C: 0.984375, D: 1.058024, E: 1.052979, F: 1.317708, G: 0.944987, H: 0.795003, I: 0.395996, J: 0.829997, K: 0.807292, L: 0.979167, M: 1.062012, N: 1.193034, O: 0.97998, P: 0.989583, Q: 1.65625, R: 1.140625, S: 1.107015, T: 1.354167, U: 1.083984, V: 0.947998, W: 1.615967, X: 1.078125, Y: 1.083008, Z: 1.895833, "[": 0.381022, "\\": 0.541667, "]": 0.38501, "^": 0.502035, _: 0.625, "`": 0.377035, a: 0.84375, b: 0.671875, c: 0.666667, d: 0.927083, e: 0.489583, f: 0.430013, g: 0.557292, h: 0.911458, i: 0.317708, j: 0.5625, k: 0.916667, l: 0.567708, m: 1.270833, n: 0.932292, o: 0.708333, p: 0.927083, q: 0.65625, r: 0.395833, s: 0.489583, t: 1.104167, u: 0.84375, v: 0.380208, w: 0.677083, x: 0.578125, y: 0.713542, z: 0.635417, "{": 0.475016, "|": 0.323975, "}": 0.506999, "~": 0.652018 } }, LoveNote: { lineHeight: 0.916667, advances: { "0": 0.429036, "1": 0.197021, "2": 0.419027, "3": 0.344971, "4": 0.429036, "5": 0.372965, "6": 0.367025, "7": 0.371989, "8": 0.40096, "9": 0.370036, " ": 0.18099, "!": 0.191976, '"': 0.236979, "#": 0.431966, $: 0.319987, "%": 0.33903, "&": 0.38501, "'": 0.121989, "(": 0.284993, ")": 0.284993, "*": 0.471029, "+": 0.263021, ",": 0.120036, "-": 0.333984, ".": 0.121012, "/": 0.250977, ":": 0.167969, ";": 0.125, "<": 0.391032, "=": 0.34196, ">": 0.391032, "?": 0.358968, "@": 0.547038, A: 0.78125, B: 0.630208, C: 0.59375, D: 0.635417, E: 0.630208, F: 0.734375, G: 0.770833, H: 0.651042, I: 0.755208, J: 0.635417, K: 0.625, L: 0.697917, M: 0.989583, N: 0.713542, O: 0.96875, P: 0.630208, Q: 0.770833, R: 0.682292, S: 0.614583, T: 0.692708, U: 1, V: 0.916667, W: 1.260417, X: 0.911458, Y: 0.973958, Z: 0.770996, "[": 1.90625, "]": 1.911458, _: 1.505208, "`": 0.107015, a: 0.557292, b: 0.28304, c: 0.369792, d: 0.546875, e: 0.375, f: 0.463542, g: 0.536458, h: 0.494792, i: 0.375, j: 0.505208, k: 0.380208, l: 0.369792, m: 0.682292, n: 0.515625, o: 0.421875, p: 0.53125, q: 0.53125, r: 0.4375, s: 0.453125, t: 0.458333, u: 0.567708, v: 0.401042, w: 0.572917, x: 0.46875, y: 0.53125, z: 0.515625, "{": 0.260986, "|": 1.505208, "}": 0.26001, \u00C0: 0.78125, \u00C2: 0.78125, \u00C6: 0.817708, \u00C7: 0.59375, \u00C9: 0.630208, \u00C8: 0.630208, \u00CA: 0.630208, \u00CB: 0.630208, \u00CE: 0.755208, \u00CF: 0.755208, \u00D4: 0.963542, \u0152: 1.046875, \u00D9: 1, \u00DB: 1, \u00DC: 1, \u0178: 0.973958, \u00E0: 0.557292, \u00E2: 0.557292, \u00E6: 0.5625, \u00E7: 0.369792, \u00E9: 0.369792, \u00E8: 0.390625, \u00EA: 0.385417, \u00EB: 0.380208, \u00EE: 0.416667, \u00EF: 0.411458, \u00F4: 0.421875, \u0153: 0.578125, \u00F9: 0.567708, \u00FB: 0.567708, \u00FC: 0.567708, \u00FF: 0.53125 } }, Manchester: { lineHeight: 0.921875, advances: { "0": 0.377604, "1": 0.294271, "2": 0.317708, "3": 0.289062, "4": 0.304688, "5": 0.322917, "6": 0.289062, "7": 0.299479, "8": 0.255208, "9": 0.286458, " ": 0.25, "!": 0.25, '"': 0.187012, "#": 0.489014, $: 0.409993, "%": 0.491984, "&": 0.612996, "'": 0.116984, "(": 0.26298, ")": 0.26298, "*": 0.281006, "+": 0.451009, ",": 0.128988, "-": 0.265015, ".": 0.138997, "/": 0.387004, ":": 0.18099, ";": 0.18099, "<": 0.189982, "=": 0.489014, ">": 0.189982, "?": 0.368001, "@": 0.675008, A: 0.369995, B: 0.454997, C: 0.418009, D: 0.494792, E: 0.369019, F: 0.411458, G: 0.385986, H: 0.458333, I: 0.486979, J: 0.466146, K: 0.413005, L: 0.409017, M: 0.774007, N: 0.508016, O: 0.380981, P: 0.367188, Q: 0.372396, R: 0.366007, S: 0.385417, T: 0.411458, U: 0.408854, V: 0.40625, W: 0.75, X: 0.401042, Y: 0.390625, Z: 0.395833, "[": 0.213013, "\\": 0.387004, "]": 0.213013, _: 0.539998, "`": 0.09375, a: 0.401042, b: 0.375, c: 0.315104, d: 0.421875, e: 0.317708, f: 0.330729, g: 0.434896, h: 0.440104, i: 0.236979, j: 0.341146, k: 0.247396, l: 0.234375, m: 0.645833, n: 0.494792, o: 0.335938, p: 0.28125, q: 0.395833, r: 0.330729, s: 0.246989, t: 0.291667, u: 0.395833, v: 0.252604, w: 0.451986, x: 0.359375, y: 0.424479, z: 0.388021, "{": 0.333984, "|": 0.19401, "}": 0.333984, "~": 0.255981, \u00C0: 0.369995, \u00C2: 0.399007, \u00C6: 0.616984, \u00C7: 0.388021, \u00C9: 0.369019, \u00C8: 0.369019, \u00CA: 0.381999, \u00CB: 0.369995, \u00CE: 0.486979, \u00CF: 0.486979, \u00D4: 0.380981, \u0152: 0.628011, \u00D9: 0.408854, \u00DB: 0.408854, \u00DC: 0.408854, \u0178: 0.390625, \u00E0: 0.401042, \u00E2: 0.401042, \u00E6: 0.515625, \u00E7: 0.315104, \u00E9: 0.317708, \u00E8: 0.317708, \u00EA: 0.317708, \u00EB: 0.317708, \u00EE: 0.236979, \u00EF: 0.236979, \u00F4: 0.335938, \u0153: 0.473958, \u00F9: 0.395833, \u00FB: 0.395833, \u00FC: 0.395833, \u00FF: 0.424479 } }, Neonscript: { lineHeight: 1.494792, advances: { "0": 0.384033, "1": 0.260417, "2": 0.423991, "3": 0.399007, "4": 0.385417, "5": 0.447917, "6": 0.343994, "7": 0.288981, "8": 0.348958, "9": 0.312012, " ": 0.360026, "!": 0.507975, '"': 0.333984, "#": 0.440023, $: 0.563965, "%": 0.555013, "&": 0.427979, "'": 0.268962, "(": 0.337972, ")": 0.36499, "*": 0.423014, "+": 0.608968, ",": 0.318034, "-": 0.447998, ".": 0.278971, "/": 0.506022, ":": 0.284993, ";": 0.309977, "<": 0.447021, "=": 0.431966, ">": 0.422038, "?": 0.531006, "@": 0.568034, A: 0.651042, B: 1.041667, C: 0.697917, D: 1.010417, E: 0.682292, F: 0.682292, G: 0.692708, H: 0.682292, I: 0.3125, J: 0.546875, K: 0.661458, L: 0.551025, M: 0.942708, N: 0.619792, O: 0.671875, P: 1.083333, Q: 0.677083, R: 0.807292, S: 0.723958, T: 0.958333, U: 0.53125, V: 0.588542, W: 0.703125, X: 0.640625, Y: 0.536458, Z: 0.588542, "[": 0.475016, "\\": 0.346029, "]": 0.484375, "^": 0.266032, _: 0.475016, "`": 0.107015, a: 0.458333, b: 0.458333, c: 0.322917, d: 0.515625, e: 0.291667, f: 0.510417, g: 0.536458, h: 0.489583, i: 0.229167, j: 0.625, k: 0.609375, l: 0.34375, m: 0.578125, n: 0.432292, o: 0.416667, p: 0.453125, q: 0.28125, r: 0.322917, s: 0.364583, t: 0.395833, u: 0.401042, v: 0.3125, w: 0.515625, x: 0.317708, y: 0.494792, z: 0.243001, "{": 0.338542, "|": 0.21696, "}": 0.353027, "~": 0.28304, \u00C0: 0.666667, \u00C2: 0.744792, \u00C7: 0.744792, \u00C9: 0.682292, \u00C8: 0.682292, \u00CA: 0.682292, \u00CB: 0.682292, \u00CE: 0.432292, \u00CF: 0.442708, \u00D4: 0.713542, \u00D9: 0.53125, \u00DB: 0.53125, \u00DC: 0.541667, \u00E0: 0.458333, \u00E2: 0.458333, \u00E7: 0.390625, \u00E9: 0.291667, \u00E8: 0.291667, \u00EA: 0.302083, \u00EB: 0.333333, \u00EE: 0.307292, \u00EF: 0.28125, \u00F4: 0.416667, \u00F9: 0.401042, \u00FB: 0.401042, \u00FC: 0.401042, \u00FF: 0.494792 } }, Northshore: { lineHeight: 1.359375, advances: { "0": 0.461019, "1": 0.266032, "2": 0.538005, "3": 0.515625, "4": 0.524007, "5": 0.489583, "6": 0.447021, "7": 0.447917, "8": 0.465007, "9": 0.433024, " ": 0.312012, "!": 0.233968, '"': 0.209961, "#": 0.559977, $: 0.604004, "%": 0.572917, "&": 0.496989, "'": 0.13501, "(": 0.280029, ")": 0.255208, "*": 0.360026, "+": 0.524984, ",": 0.166016, "-": 0.420003, ".": 0.148031, "/": 0.338542, ":": 0.159993, ";": 0.163981, "<": 0.476969, "=": 0.495036, ">": 0.438965, "?": 0.493978, "@": 0.690999, A: 0.520833, B: 0.473958, C: 0.452962, D: 0.499023, E: 0.59375, F: 0.541667, G: 0.493978, H: 0.645833, I: 0.723958, J: 0.848958, K: 0.609375, L: 0.505208, M: 0.701986, N: 0.52002, O: 0.58903, P: 0.734375, Q: 0.583333, R: 0.619792, S: 0.697917, T: 0.786458, U: 0.510986, V: 0.510417, W: 0.764974, X: 0.760417, Y: 0.514974, Z: 0.557292, "[": 0.338542, "\\": 0.34375, "]": 0.358968, "^": 0.179036, _: 0.593994, "`": 0.197998, a: 0.235026, b: 0.364583, c: 0.40625, d: 0.369792, e: 0.40625, f: 0.302083, g: 0.6875, h: 0.3125, i: 0.135417, j: 0.682292, k: 0.281982, l: 0.302083, m: 0.391032, n: 0.421875, o: 0.187012, p: 0.473958, q: 0.338542, r: 0.338542, s: 0.192708, t: 0.651042, u: 0.297038, v: 0.421875, w: 0.333333, x: 0.296875, y: 0.552083, z: 0.541667, "{": 0.266032, "|": 0.299967, "}": 0.309977, "~": 0.327962, \u00C0: 0.671875, \u00C2: 0.671875, \u00C6: 0.963542, \u00C7: 0.406006, \u00C9: 0.625, \u00C8: 0.625, \u00CA: 0.625, \u00CB: 0.625, \u00CE: 0.796875, \u00CF: 0.796875, \u00D4: 0.534993, \u0152: 0.963542, \u00D9: 0.5625, \u00DB: 0.5625, \u00DC: 0.5625, \u0178: 0.4375, \u00E0: 0.442708, \u00E2: 0.442708, \u00E6: 0.463542, \u00E7: 0.187988, \u00E9: 0.265625, \u00E8: 0.265625, \u00EA: 0.265625, \u00EB: 0.265625, \u00EE: 0.34375, \u00EF: 0.34375, \u00F4: 0.328125, \u0153: 0.375, \u00F9: 0.4375, \u00FB: 0.4375, \u00FC: 0.4375, \u00FF: 0.640625 } }, Photogenic: { lineHeight: 1.182292, advances: { "0": 0.677083, "1": 0.5, "2": 0.744792, "3": 0.607992, "4": 0.567708, "5": 0.786458, "6": 0.53125, "7": 0.583333, "8": 0.760417, "9": 0.541667, " ": 0.326009, "!": 0.452962, '"': 0.228027, "#": 0.601969, $: 0.520833, "%": 0.468018, "&": 0.618001, "'": 0.180013, "(": 0.377035, ")": 0.302002, "*": 0.503011, "+": 0.506022, ",": 0.437012, "-": 0.485026, ".": 0.191976, "/": 0.40804, ":": 0.249023, ";": 0.256999, "<": 0.476969, "=": 0.476969, ">": 0.399984, "?": 0.326009, "@": 0.575033, A: 1.291667, B: 1.3125, C: 0.994792, D: 1.348958, E: 0.984375, F: 1.135417, G: 0.774007, H: 1.515625, I: 0.953125, J: 0.885417, K: 1.4375, L: 0.869792, M: 1, N: 1, O: 0.941976, P: 1.255208, Q: 0.916667, R: 1.416667, S: 1.208333, T: 1.130208, U: 1.109375, V: 0.817708, W: 1.135417, X: 1.088542, Y: 1.135417, Z: 0.901042, "[": 0.484375, "\\": 0.35498, "]": 0.473958, "^": 0.318034, _: 0.371012, "`": 0.180013, a: 0.354167, b: 0.369792, c: 0.322917, d: 0.515625, e: 0.302083, f: 0.494792, g: 0.526042, h: 0.395833, i: 0.223958, j: 0.536458, k: 0.458333, l: 0.505208, m: 0.447917, n: 0.385417, o: 0.296875, p: 0.375, q: 0.447917, r: 0.333333, s: 0.213542, t: 0.401042, u: 0.307292, v: 0.322917, w: 0.447917, x: 0.40625, y: 0.510417, z: 0.239583, "{": 0.427083, "|": 0.356038, "}": 0.369792, "~": 0.471029, \u00C0: 1.291667, \u00C2: 1.380208, \u00C6: 2.072917, \u00C7: 0.911458, \u00C9: 1.255208, \u00C8: 1.255208, \u00CA: 1.255208, \u00CB: 1.255208, \u00CE: 0.96875, \u00CF: 0.96875, \u00D4: 1.479167, \u00D9: 1.234375, \u00DB: 1.234375, \u00DC: 1.234375, \u00E0: 0.348958, \u00E2: 0.348958, \u00E6: 0.348958, \u00E7: 0.322917, \u00E9: 0.3125, \u00E8: 0.3125, \u00EA: 0.3125, \u00EB: 0.3125, \u00EE: 0.223958, \u00EF: 0.223958, \u00F4: 0.291667, \u00F9: 0.34375, \u00FB: 0.34375, \u00FC: 0.34375, \u00FF: 0.786458 } }, Royalty: { lineHeight: 1.489583, advances: { "0": 0.572917, "1": 0.479167, "2": 0.578125, "3": 0.46875, "4": 0.541667, "5": 0.604167, "6": 0.453613, "7": 0.515625, "8": 0.546875, "9": 0.431641, " ": 0.384766, "!": 0.494792, '"': 0.125, "#": 0.599121, $: 0.328613, "%": 0.61084, "&": 0.505208, "'": 0.074707, "(": 0.510417, ")": 0.411458, "*": 0.393555, "+": 0.407715, ",": 0.208984, "-": 0.414551, ".": 0.230957, "/": 0.609375, ":": 0.193848, ";": 0.195801, "<": 0.298828, "=": 0.385742, ">": 0.300781, "?": 0.597656, "@": 0.481934, A: 0.901042, B: 1.015625, C: 0.859375, D: 0.885417, E: 0.770833, F: 1.036458, G: 0.796875, H: 1.0625, I: 0.760417, J: 1.03125, K: 0.90625, L: 1.052083, M: 1.442708, N: 1.041667, O: 0.765625, P: 0.890625, Q: 0.973958, R: 0.958333, S: 0.911458, T: 0.885417, U: 0.817708, V: 1.052083, W: 1.182292, X: 1.067708, Y: 1.067708, Z: 0.901042, "[": 0.494792, "\\": 0.46875, "]": 0.536458, "^": 0.353516, _: 0.447917, "`": 0.239746, a: 0.625, b: 0.640625, c: 0.526042, d: 0.640625, e: 0.520833, f: 0.734375, g: 0.895833, h: 0.671875, i: 0.46875, j: 0.895833, k: 0.692708, l: 0.479167, m: 0.895833, n: 0.682292, o: 0.479167, p: 0.864583, q: 0.802083, r: 0.447917, s: 0.567708, t: 0.5, u: 0.572917, v: 0.552083, w: 0.786458, x: 0.598958, y: 0.901042, z: 0.890625, "{": 0.4375, "|": 0.4375, "}": 0.411458, "~": 0.396973, \u00C0: 0.963542, \u00C2: 0.989583, \u00C6: 1.307292, \u00C7: 0.859375, \u00C9: 0.776042, \u00C8: 0.776042, \u00CA: 0.776042, \u00CB: 0.776042, \u00CE: 0.786458, \u00CF: 0.755208, \u00D4: 0.776042, \u0152: 1.229167, \u00D9: 0.817708, \u00DB: 0.817708, \u00DC: 0.817708, \u0178: 1.0625, \u00E0: 0.630208, \u00E2: 0.630208, \u00E6: 0.75, \u00E7: 0.520833, \u00E9: 0.510417, \u00E8: 0.510417, \u00EA: 0.510417, \u00EB: 0.510417, \u00EE: 0.473958, \u00EF: 0.473958, \u00F4: 0.494792, \u0153: 0.6875, \u00F9: 0.572917, \u00FB: 0.572917, \u00FC: 0.572917, \u00FF: 0.901042 } }, Rocket: { lineHeight: 1.578125, advances: { "0": 0.665039, "1": 0.572917, "2": 0.791667, "3": 0.697917, "4": 0.744792, "5": 0.677083, "6": 0.638997, "7": 0.625, "8": 0.583984, "9": 0.631999, " ": 0.502035, "!": 0.588542, '"': 0.309977, "#": 0.921875, $: 0.604167, "%": 0.776042, "&": 0.59375, "'": 0.174967, "(": 0.796875, ")": 0.723958, "*": 0.552979, "+": 0.649984, ",": 0.229004, "-": 0.55599, ".": 0.148031, "/": 0.683024, ":": 0.364014, ";": 0.299967, "<": 0.627035, "=": 0.611979, ">": 0.642985, "?": 0.609375, "@": 0.9375, A: 1.432292, B: 1.26001, C: 1.145833, D: 1.354004, E: 1.223958, F: 1.3125, G: 1.186035, H: 1.567708, I: 1, J: 1.223958, K: 1.442708, L: 1.328125, M: 1.713542, N: 1.619792, O: 1.083008, P: 1.151042, Q: 1.125, R: 1.380208, S: 1.052083, T: 1.432292, U: 1.182292, V: 1.40625, W: 1.963542, X: 1.494792, Y: 1.135417, Z: 1.322917, "[": 0.645833, "\\": 0.482015, "]": 0.645833, "^": 0.517008, _: 0.732992, "`": 0.281006, a: 1.125, b: 0.614583, c: 0.677083, d: 1.072917, e: 0.708333, f: 0.880208, g: 1.09375, h: 1.192708, i: 0.666667, j: 1.119792, k: 0.994792, l: 0.614583, m: 1.395833, n: 1.109375, o: 0.786458, p: 1.182292, q: 1.057292, r: 0.65625, s: 0.802083, t: 1.0625, u: 1.015625, v: 0.869792, w: 1.072917, x: 1.020833, y: 1.125, z: 1.15625, "{": 0.46875, "|": 0.392008, "}": 0.458333, "~": 0.565999, \u00C0: 1.364583, \u00C2: 1.489583, \u00C6: 1.994792, \u00C7: 1.197917, \u00C9: 1.223958, \u00C8: 1.223958, \u00CA: 1.223958, \u00CB: 1.223958, \u00CE: 1.114583, \u00CF: 1.104167, \u00D4: 1.083008, \u0152: 1.567708, \u00D9: 1.197917, \u00DB: 1.197917, \u00DC: 1.197917, \u0178: 1.15625, \u00E0: 1.125, \u00E2: 1.125, \u00E6: 1.125, \u00E7: 0.677083, \u00E9: 0.703125, \u00E8: 0.703125, \u00EA: 0.703125, \u00EB: 0.703125, \u00EE: 0.661458, \u00EF: 0.661458, \u00F4: 0.786458, \u0153: 0.932292, \u00F9: 1.010417, \u00FB: 1.010417, \u00FC: 1.010417, \u00FF: 1.125 } }, Signature: { lineHeight: 1.067708, advances: { "0": 0.468994, "1": 0.333333, "2": 0.505208, "3": 0.505208, "4": 0.520833, "5": 0.541667, "6": 0.429036, "7": 0.461995, "8": 0.552083, "9": 0.437012, " ": 0.28597, "!": 0.375, '"': 0.130208, "#": 0.40804, $: 0.294027, "%": 0.541992, "&": 0.325033, "'": 0.104004, "(": 0.354167, ")": 0.302083, "*": 0.351969, "+": 0.329997, ",": 0.122965, "-": 0.334961, ".": 0.121012, "/": 0.494792, ":": 0.232015, ";": 0.232015, "<": 0.243001, "=": 0.322021, ">": 0.247965, "?": 0.409017, "@": 0.427002, A: 0.588542, B: 0.5, C: 0.471029, D: 0.572917, E: 0.552083, F: 0.614583, G: 0.536458, H: 0.59375, I: 0.375, J: 0.526042, K: 0.635417, L: 0.40625, M: 0.84375, N: 0.744792, O: 0.494792, P: 0.473958, Q: 0.509033, R: 0.515625, S: 0.463542, T: 0.541667, U: 0.53125, V: 0.546875, W: 0.833333, X: 0.588542, Y: 0.526042, Z: 0.536458, "[": 0.442708, "\\": 0.401042, "]": 0.421875, "^": 0.245036, _: 0.437012, "`": 0.225993, a: 0.375, b: 0.40625, c: 0.322917, d: 0.453125, e: 0.322917, f: 0.442708, g: 0.53125, h: 0.473958, i: 0.3125, j: 0.494792, k: 0.479167, l: 0.375, m: 0.651042, n: 0.432292, o: 0.338542, p: 0.489583, q: 0.473958, r: 0.223958, s: 0.359375, t: 0.40625, u: 0.390625, v: 0.380208, w: 0.552083, x: 0.359375, y: 0.536458, z: 0.541667, "{": 0.380208, "|": 0.364583, "}": 0.333333, "~": 0.347982, \u00C0: 0.598958, \u00C2: 0.619792, \u00C6: 0.895833, \u00C7: 0.473958, \u00C9: 0.552083, \u00C8: 0.552083, \u00CA: 0.552083, \u00CB: 0.552083, \u00CE: 0.432292, \u00CF: 0.442708, \u00D4: 0.494792, \u0152: 0.828125, \u00D9: 0.53125, \u00DB: 0.53125, \u00DC: 0.53125, \u0178: 0.4375, \u00E0: 0.375, \u00E2: 0.375, \u00E6: 0.494792, \u00E7: 0.359375, \u00E9: 0.322917, \u00E8: 0.322917, \u00EA: 0.322917, \u00EB: 0.322917, \u00EE: 0.328125, \u00EF: 0.328125, \u00F4: 0.338542, \u0153: 0.489583, \u00F9: 0.390625, \u00FB: 0.390625, \u00FC: 0.390625, \u00FF: 0.536458 } }, Sorrento: { lineHeight: 1.640625, advances: { "0": 0.451986, "1": 0.334961, "2": 0.461995, "3": 0.496989, "4": 0.411458, "5": 0.494792, "6": 0.381999, "7": 0.463542, "8": 0.442708, "9": 0.381999, " ": 0.301025, "!": 0.347005, '"': 0.326009, "#": 0.707031, $: 0.590007, "%": 0.766032, "&": 0.798014, "'": 0.242025, "(": 0.463542, ")": 0.463542, "*": 0.447021, "+": 0.381999, ",": 0.152018, "-": 0.496989, ".": 0.136963, "/": 0.354167, ":": 0.277018, ";": 0.288981, "<": 0.427002, "=": 0.433024, ">": 0.427002, "?": 0.405029, "@": 0.996012, A: 1.307292, B: 0.815999, C: 0.755208, D: 1.015625, E: 0.927083, F: 1.140625, G: 0.916667, H: 1.046875, I: 0.927083, J: 0.989583, K: 0.989583, L: 0.864583, M: 1.427083, N: 1.005208, O: 0.859375, P: 0.885417, Q: 0.875, R: 0.911458, S: 0.822917, T: 1.088542, U: 0.802083, V: 0.916667, W: 1.067708, X: 1.244792, Y: 1.03125, Z: 1.458333, "[": 0.354167, "\\": 0.348958, "]": 0.316976, "^": 0.493978, _: 0.531982, "`": 0.422038, a: 0.651042, b: 0.625, c: 0.552083, d: 0.78125, e: 0.541667, f: 0.755208, g: 0.755208, h: 0.65625, i: 0.447917, j: 0.989583, k: 0.619792, l: 0.552083, m: 0.973958, n: 0.703125, o: 0.614583, p: 0.953125, q: 0.770833, r: 0.463542, s: 0.578125, t: 0.666667, u: 0.583333, v: 0.390625, w: 0.6875, x: 0.677083, y: 0.84375, z: 0.640625, "{": 0.40625, "|": 0.292969, "}": 0.390625, "~": 0.506999, \u00C0: 1.307292, \u00C2: 1.395833, \u00C6: 2.052083, \u00C7: 0.755208, \u00C9: 0.927083, \u00C8: 0.927083, \u00CA: 0.927083, \u00CB: 0.927083, \u00CE: 1, \u00CF: 0.96875, \u00D4: 0.859375, \u0152: 1.729167, \u00D9: 0.802083, \u00DB: 0.802083, \u00DC: 0.802083, \u0178: 0.994792, \u00E0: 0.651042, \u00E2: 0.651042, \u00E6: 1.109375, \u00E7: 0.552083, \u00E9: 0.541667, \u00E8: 0.541667, \u00EA: 0.541667, \u00EB: 0.541667, \u00EE: 0.4375, \u00EF: 0.4375, \u00F4: 0.614583, \u0153: 1.067708, \u00F9: 0.583333, \u00FB: 0.583333, \u00FC: 0.583333, \u00FF: 0.84375 } }, WildScript: { lineHeight: 1.0625, advances: { "0": 0.475016, "1": 0.194987, "2": 0.442708, "3": 0.442708, "4": 0.356038, "5": 0.494792, "6": 0.372965, "7": 0.395833, "8": 0.411458, "9": 0.378011, " ": 0.204997, "!": 0.166016, '"': 0.184001, "#": 0.479167, $: 0.338542, "%": 0.473958, "&": 0.489583, "'": 0.069987, "(": 0.203125, ")": 0.16097, "*": 0.188965, "+": 0.368001, ",": 0.129964, "-": 0.30599, ".": 0.118001, "/": 0.286458, ":": 0.14502, ";": 0.13501, "<": 0.312988, "=": 0.375977, ">": 0.284017, "?": 0.234375, "@": 0.481038, A: 0.526042, B: 0.489583, C: 0.39502, D: 0.489583, E: 0.5625, F: 0.546875, G: 0.415039, H: 0.708333, I: 0.588542, J: 0.729167, K: 0.463542, L: 0.416667, M: 0.534993, N: 0.484375, O: 0.48999, P: 0.473958, Q: 0.499023, R: 0.458333, S: 0.40625, T: 0.645833, U: 0.505208, V: 0.479167, W: 0.677083, X: 0.609375, Y: 0.53125, Z: 0.489583, "[": 0.229167, "\\": 0.302083, "]": 0.208333, "^": 0.152018, _: 0.427002, "`": 0.132975, a: 0.1875, b: 0.238037, c: 0.317708, d: 0.260417, e: 0.203125, f: 0.328125, g: 0.276042, h: 0.369792, i: 0.083333, j: 0.453125, k: 0.223958, l: 0.197917, m: 0.385417, n: 0.354167, o: 0.19401, p: 0.28125, q: 0.239583, r: 0.234375, s: 0.395833, t: 0.46875, u: 0.225993, v: 0.348958, w: 0.3125, x: 0.34375, y: 0.369792, z: 0.359375, "{": 0.215983, "|": 0.211019, "}": 0.177083, "~": 0.437012, \u00C0: 0.526042, \u00C2: 0.526042, \u00C6: 0.90625, \u00C7: 0.396973, \u00C9: 0.567708, \u00C8: 0.567708, \u00CA: 0.567708, \u00CB: 0.567708, \u00CE: 0.588542, \u00CF: 0.588542, \u00D4: 0.48999, \u0152: 0.848958, \u00D9: 0.505208, \u00DB: 0.505208, \u00DC: 0.505208, \u0178: 0.520833, \u00E0: 0.184001, \u00E2: 0.184001, \u00E6: 0.333333, \u00E7: 0.182292, \u00E9: 0.184001, \u00E8: 0.184001, \u00EA: 0.184001, \u00EB: 0.184001, \u00EE: 0.104167, \u00EF: 0.09375, \u00F4: 0.19401, \u0153: 0.298014, \u00F9: 0.225993, \u00FB: 0.225993, \u00FC: 0.225993, \u00FF: 0.364583 } }, Avante: { lineHeight: 0.921875, advances: { "0": 0.564941, "1": 0.564941, "2": 0.564941, "3": 0.564941, "4": 0.564941, "5": 0.564941, "6": 0.564941, "7": 0.564941, "8": 0.564941, "9": 0.564941, " ": 0.282227, "!": 0.287109, '"': 0.277832, "#": 0.769043, $: 0.564941, "%": 0.876953, "&": 0.693848, "'": 0.144043, "(": 0.26416, ")": 0.26416, "*": 0.5, "+": 0.833008, ",": 0.282227, "-": 0.321777, ".": 0.282227, "/": 0.296875, ":": 0.287109, ";": 0.287109, "<": 0.833008, "=": 0.833008, ">": 0.833008, "?": 0.462891, "@": 1, A: 0.619792, B: 0.508789, C: 0.751953, D: 0.666992, E: 0.501953, F: 0.483887, G: 0.787109, H: 0.61084, I: 0.201172, J: 0.446777, K: 0.537109, L: 0.412109, M: 0.826172, N: 0.666992, O: 0.787109, P: 0.504883, Q: 0.787109, R: 0.556152, S: 0.464844, T: 0.366211, U: 0.564941, V: 0.572917, W: 0.833333, X: 0.568848, Y: 0.505208, Z: 0.458008, "[": 0.26416, "\\": 0.291667, "]": 0.26416, "^": 1, _: 0.5, "`": 0.5, a: 0.629883, b: 0.629883, c: 0.605957, d: 0.629883, e: 0.605957, f: 0.274902, g: 0.625, h: 0.558105, i: 0.181152, j: 0.181152, k: 0.414062, l: 0.181152, m: 0.931152, n: 0.558105, o: 0.605957, p: 0.629883, q: 0.629883, r: 0.25, s: 0.38916, t: 0.276042, u: 0.558105, v: 0.479167, w: 0.693848, x: 0.416667, y: 0.484375, z: 0.402832, "{": 0.5, "|": 0.5, "}": 0.5, "~": 0.833008, \u00C0: 0.619792, \u00C2: 0.508789, \u00C6: 0.864583, \u00C7: 0.52002, \u00C9: 0.638672, \u00C8: 0.640625, \u00CA: 0.533203, \u00CB: 0.578125, \u00CE: 0.787109, \u00CF: 0.583984, \u00D4: 0.800781, \u0152: 1.089844, \u00D9: 0.833984, \u00DB: 0.652344, \u00DC: 0.5, \u0178: 0.505208, \u00E0: 0.629883, \u00E2: 0.625, \u00E6: 0.677083, \u00E7: 0.38916, \u00E9: 0.558105, \u00E8: 0.558105, \u00EA: 0.410645, \u00EB: 0.479167, \u00EE: 0.602539, \u00EF: 0.558105, \u00F4: 1.081055, \u0153: 1.087891, \u00F9: 0.968262, \u00FB: 0.6875, \u00FC: 0.533203, \u00FF: 0.533203 } }, Buttercup: { lineHeight: 0.895833, advances: { "0": 0.390625, "1": 0.213379, "2": 0.279785, "3": 0.287109, "4": 0.368652, "5": 0.301758, "6": 0.300293, "7": 0.296875, "8": 0.318359, "9": 0.304199, " ": 0.248047, "!": 0.134277, '"': 0.180664, "#": 0.587402, $: 0.282715, "%": 0.480957, "&": 0.351074, "'": 0.11084, "(": 0.174316, ")": 0.175781, "*": 0.182129, "+": 0.370605, ",": 0.118652, "-": 0.292969, ".": 0.171875, "/": 0.238281, ":": 0.15332, ";": 0.143555, "<": 0.397949, "=": 0.362793, ">": 0.393066, "?": 0.250488, "@": 0.512695, A: 0.337402, B: 0.23584, C: 0.322266, D: 0.310059, E: 0.305664, F: 0.265137, G: 0.291016, H: 0.347656, I: 0.145508, J: 0.271484, K: 0.283203, L: 0.289062, M: 0.321777, N: 0.321289, O: 0.359375, P: 0.288574, Q: 0.357422, R: 0.266602, S: 0.266602, T: 0.32373, U: 0.378418, V: 0.364746, W: 0.425293, X: 0.317871, Y: 0.287109, Z: 0.282227, "[": 0.17627, "\\": 0.243164, "]": 0.183105, "^": 0.213867, _: 0.36084, "`": 0.324219, a: 0.252441, b: 0.251465, c: 0.231445, d: 0.25, e: 0.231934, f: 0.220215, g: 0.248535, h: 0.25293, i: 0.123535, j: 0.146484, k: 0.242676, l: 0.164551, m: 0.306641, n: 0.258789, o: 0.25293, p: 0.25293, q: 0.23877, r: 0.217285, s: 0.192871, t: 0.169434, u: 0.26123, v: 0.250488, w: 0.274902, x: 0.20459, y: 0.226562, z: 0.196777, "{": 0.164062, "|": 0.151855, "}": 0.15332, "~": 0.318359, \u00C0: 0.337402, \u00C2: 0.335449, \u00C6: 0.470703, \u00C7: 0.313965, \u00C9: 0.288574, \u00C8: 0.286621, \u00CA: 0.286621, \u00CB: 0.284668, \u00CE: 0.172363, \u00CF: 0.181641, \u00D4: 0.347168, \u0152: 0.513672, \u00D9: 0.364746, \u00DB: 0.36084, \u00DC: 0.358887, \u0178: 0.273926, \u00E0: 0.22998, \u00E2: 0.228027, \u00E6: 0.358887, \u00E7: 0.21875, \u00E9: 0.228027, \u00E8: 0.228027, \u00EA: 0.228027, \u00EB: 0.224121, \u00EE: 0.158203, \u00EF: 0.147461, \u00F4: 0.231934, \u0153: 0.361816, \u00F9: 0.244141, \u00FB: 0.244141, \u00FC: 0.241211, \u00FF: 0.226562 } }, ClassicType: { lineHeight: 0.921875, advances: { "0": 0.653971, "1": 0.346029, "2": 0.594971, "3": 0.600993, "4": 0.577962, "5": 0.572021, "6": 0.597005, "7": 0.46875, "8": 0.643962, "9": 0.597005, " ": 0.280029, "!": 0.267985, '"': 0.313965, "#": 0.76001, $: 0.624023, "%": 0.784017, "&": 0.698975, "'": 0.184001, "(": 0.281006, ")": 0.281006, "*": 0.447998, "+": 0.500977, ",": 0.242025, "-": 0.572021, ".": 0.242025, "/": 0.517985, ":": 0.252035, ";": 0.252035, "<": 0.499023, "=": 0.579997, ">": 0.499023, "?": 0.541992, "@": 0.922038, A: 0.744792, B: 0.65096, C: 0.694987, D: 0.733968, E: 0.614014, F: 0.586019, G: 0.763997, H: 0.781982, I: 0.322021, J: 0.504964, K: 0.695964, L: 0.577962, M: 0.972005, N: 0.784993, O: 0.78597, P: 0.632975, Q: 0.787028, R: 0.687988, S: 0.64502, T: 0.618001, U: 0.77596, V: 0.744792, W: 1.03125, X: 0.66097, Y: 0.645833, Z: 0.61499, "[": 0.290039, "\\": 0.518962, "]": 0.290039, "^": 0.46696, _: 0.708008, "`": 0.242025, a: 0.572021, b: 0.59904, c: 0.548991, d: 0.631022, e: 0.566976, f: 0.413981, g: 0.60498, h: 0.65096, i: 0.28597, j: 0.286458, k: 0.580973, l: 0.267985, m: 0.958984, n: 0.667969, o: 0.59196, p: 0.621989, q: 0.611979, r: 0.506999, s: 0.554036, t: 0.402995, u: 0.649984, v: 0.625, w: 0.864583, x: 0.57902, y: 0.619792, z: 0.538005, "{": 0.323975, "|": 0.246012, "}": 0.323975, "~": 0.524007, \u00C0: 0.744792, \u00C2: 0.744792, \u00C6: 0.96403, \u00C7: 0.695964, \u00C9: 0.614014, \u00C8: 0.614014, \u00CA: 0.614014, \u00CB: 0.614014, \u00CE: 0.322021, \u00CF: 0.322021, \u00D4: 0.78597, \u0152: 0.923014, \u00D9: 0.77596, \u00DB: 0.77596, \u00DC: 0.77596, \u0178: 0.645833, \u00E0: 0.572021, \u00E2: 0.572021, \u00E6: 0.937012, \u00E7: 0.559977, \u00E9: 0.566976, \u00E8: 0.566976, \u00EA: 0.566976, \u00EB: 0.566976, \u00EE: 0.28597, \u00EF: 0.28597, \u00F4: 0.59196, \u0153: 0.916016, \u00F9: 0.649984, \u00FB: 0.649984, \u00FC: 0.649984, \u00FF: 0.619792 } }, LosAngeles: { lineHeight: 0.71875, advances: { "0": 0.47998, "1": 0.220011, "2": 0.449992, "3": 0.444987, "4": 0.47998, "5": 0.465007, "6": 0.470011, "7": 0.399984, "8": 0.444987, "9": 0.470011, " ": 0.149984, "!": 0.130005, '"': 0.220011, "#": 0.48999, $: 0.380005, "%": 0.550008, "&": 0.52002, "'": 0.109985, "(": 0.185018, ")": 0.185018, "*": 0.355998, "+": 0.539998, ",": 0.109985, "-": 0.300008, ".": 0.140991, "/": 0.25, ":": 0.109985, ";": 0.109985, "<": 0.439982, "=": 0.470011, ">": 0.439982, "?": 0.460002, "@": 0.699992, A: 0.47998, B: 0.470011, C: 0.470011, D: 0.47998, E: 0.409993, F: 0.399984, G: 0.47998, H: 0.47998, I: 0.130005, J: 0.310018, K: 0.47998, L: 0.399984, M: 0.829997, N: 0.47998, O: 0.47998, P: 0.461995, Q: 0.47998, R: 0.470011, S: 0.460002, T: 0.420003, U: 0.47998, V: 0.47998, W: 0.829997, X: 0.47998, Y: 0.470011, Z: 0.409993, "[": 0.220011, "\\": 0.25, "]": 0.220011, "^": 0.470011, _: 0.401042, "`": 0.210002, a: 0.399984, b: 0.392008, c: 0.390015, d: 0.399984, e: 0.340007, f: 0.335002, g: 0.399984, h: 0.399984, i: 0.130005, j: 0.26001, k: 0.399984, l: 0.336019, m: 0.670003, n: 0.399984, o: 0.399984, p: 0.38798, q: 0.399984, r: 0.390015, s: 0.380005, t: 0.350016, u: 0.399984, v: 0.399984, w: 0.670003, x: 0.399984, y: 0.390015, z: 0.343994, "{": 0.25, "|": 0.130005, "}": 0.25, "~": 0.539998, \u00C0: 0.47998, \u00C2: 0.47998, \u00C6: 0.76001, \u00C7: 0.470011, \u00C9: 0.409993, \u00C8: 0.409993, \u00CA: 0.409993, \u00CB: 0.409993, \u00CE: 0.234375, \u00CF: 0.182292, \u00D4: 0.47998, \u0152: 0.76001, \u00D9: 0.47998, \u00DB: 0.47998, \u00DC: 0.47998, \u0178: 0.470011, \u00E0: 0.399984, \u00E2: 0.399984, \u00E6: 0.609985, \u00E7: 0.390015, \u00E9: 0.340007, \u00E8: 0.340007, \u00EA: 0.340007, \u00EB: 0.340007, \u00EE: 0.151042, \u00EF: 0.151042, \u00F4: 0.399984, \u0153: 0.609985, \u00F9: 0.399984, \u00FB: 0.399984, \u00FC: 0.399984, \u00FF: 0.390015 } }, Melbourne: { lineHeight: 0.921875, advances: { "0": 0.554199, "1": 0.554199, "2": 0.554199, "3": 0.554199, "4": 0.554199, "5": 0.554199, "6": 0.554199, "7": 0.554199, "8": 0.554199, "9": 0.554199, " ": 0.243164, "!": 0.225586, '"': 0.287109, "#": 0.620117, $: 0.554199, "%": 0.73877, "&": 0.615234, "'": 0.169922, "(": 0.318848, ")": 0.325684, "*": 0.424316, "+": 0.564453, ",": 0.191406, "-": 0.286133, ".": 0.229004, "/": 0.396973, ":": 0.209961, ";": 0.194824, "<": 0.51123, "=": 0.553223, ">": 0.518066, "?": 0.454102, "@": 0.913086, A: 0.624512, B: 0.612793, C: 0.649414, D: 0.654785, E: 0.568848, F: 0.5625, G: 0.683594, H: 0.70752, I: 0.266113, J: 0.550293, K: 0.630859, L: 0.526855, M: 0.865234, N: 0.709961, O: 0.676758, P: 0.615723, Q: 0.676758, R: 0.634766, S: 0.592285, T: 0.597168, U: 0.657227, V: 0.616699, W: 0.896484, X: 0.611816, Y: 0.598633, Z: 0.598145, "[": 0.239746, "\\": 0.394043, "]": 0.239746, "^": 0.416016, _: 0.432292, "`": 0.285645, a: 0.535645, b: 0.554199, c: 0.515137, d: 0.555664, e: 0.516602, f: 0.331055, g: 0.554688, h: 0.548828, i: 0.224121, j: 0.228027, k: 0.489746, l: 0.224121, m: 0.88623, n: 0.549316, o: 0.560059, p: 0.554199, q: 0.557617, r: 0.336426, s: 0.506348, t: 0.321289, u: 0.549316, v: 0.480957, w: 0.753906, x: 0.486328, y: 0.475098, z: 0.486328, "{": 0.330078, "|": 0.220703, "}": 0.330078, "~": 0.68457, \u00C0: 0.624512, \u00C2: 0.624512, \u00C6: 0.910645, \u00C7: 0.649414, \u00C9: 0.568848, \u00C8: 0.568848, \u00CA: 0.568848, \u00CB: 0.568848, \u00CE: 0.276042, \u00CF: 0.296875, \u00D4: 0.676758, \u0152: 0.934082, \u00D9: 0.657227, \u00DB: 0.657227, \u00DC: 0.657227, \u0178: 0.598633, \u00E0: 0.535645, \u00E2: 0.535645, \u00E6: 0.845703, \u00E7: 0.515137, \u00E9: 0.516602, \u00E8: 0.516602, \u00EA: 0.516602, \u00EB: 0.516602, \u00EE: 0.276042, \u00EF: 0.296875, \u00F4: 0.560059, \u0153: 0.923828, \u00F9: 0.549316, \u00FB: 0.549316, \u00FC: 0.549316, \u00FF: 0.475098 } }, NeoTokyo: { lineHeight: 1.03125, advances: { "0": 0.677002, "1": 0.336995, "2": 0.537028, "3": 0.590007, "4": 0.629964, "5": 0.587972, "6": 0.614014, "7": 0.584961, "8": 0.621989, "9": 0.613037, " ": 0.340007, "!": 0.208984, '"': 0.322998, "#": 0.607015, $: 0.562012, "%": 0.71696, "&": 0.587972, "'": 0.200033, "(": 0.378988, ")": 0.378988, "*": 0.461995, "+": 0.531006, ",": 0.208984, "-": 0.398031, ".": 0.208984, "/": 0.48999, ":": 0.208984, ";": 0.209961, "<": 0.378988, "=": 0.541016, ">": 0.378988, "?": 0.496012, "@": 0.93099, A: 0.743001, B: 0.718018, C: 0.773031, D: 0.719971, E: 0.691976, F: 0.670003, G: 0.82902, H: 0.746012, I: 0.22998, J: 0.586995, K: 0.756999, L: 0.679036, M: 1.045003, N: 0.746012, O: 0.836995, P: 0.656982, Q: 0.836995, R: 0.65804, S: 0.582031, T: 0.67098, U: 0.746012, V: 0.743001, W: 1.044027, X: 0.790039, Y: 0.743978, Z: 0.711995, "[": 0.391032, "\\": 0.48999, "]": 0.391032, "^": 0.530029, _: 0.682292, "`": 0.311035, a: 0.556966, b: 0.55599, c: 0.500977, d: 0.556966, e: 0.541992, f: 0.423991, g: 0.565999, h: 0.565999, i: 0.169027, j: 0.354167, k: 0.57902, l: 0.190023, m: 0.781006, n: 0.565999, o: 0.547038, p: 0.55599, q: 0.55599, r: 0.38501, s: 0.39502, t: 0.413005, u: 0.54598, v: 0.563965, w: 0.853027, x: 0.552002, y: 0.562988, z: 0.465983, "{": 0.437012, "|": 0.209961, "}": 0.437012, "~": 0.60498, \u00C0: 0.743001, \u00C2: 0.743001, \u00C6: 1.211019, \u00C7: 0.773031, \u00C9: 0.691976, \u00C8: 0.691976, \u00CA: 0.691976, \u00CB: 0.691976, \u00CE: 0.265625, \u00CF: 0.296875, \u00D4: 0.836995, \u0152: 1.312012, \u00D9: 0.746012, \u00DB: 0.746012, \u00DC: 0.746012, \u0178: 0.743978, \u00E0: 0.556966, \u00E2: 0.556966, \u00E6: 0.938965, \u00E7: 0.500977, \u00E9: 0.541992, \u00E8: 0.541992, \u00EA: 0.541992, \u00EB: 0.541992, \u00EE: 0.265625, \u00EF: 0.296875, \u00F4: 0.547038, \u0153: 0.938965, \u00F9: 0.54598, \u00FB: 0.54598, \u00FC: 0.54598, \u00FF: 0.562988 } }, Monaco: { lineHeight: 0.713542, advances: { "0": 0.475098, "1": 0.158691, "2": 0.366211, "3": 0.393555, "4": 0.396973, "5": 0.393555, "6": 0.441895, "7": 0.362793, "8": 0.433105, "9": 0.441895, " ": 0.224609, "!": 0.164062, '"': 0.228027, "#": 0.531738, $: 0.373047, "%": 0.515625, "&": 0.417969, "'": 0.124512, "(": 0.186523, ")": 0.186523, "*": 0.272949, "+": 0.269531, ",": 0.17041, "-": 0.258789, "/": 0.380208, ":": 0.157227, ";": 0.156738, "<": 0.390137, "=": 0.263672, ">": 0.390137, "?": 0.314453, "@": 0.699219, A: 0.574707, B: 0.503906, C: 0.541992, D: 0.580078, E: 0.414551, F: 0.414551, G: 0.538574, H: 0.556152, I: 0.106934, J: 0.269531, K: 0.485352, L: 0.44873, M: 0.75293, N: 0.569824, O: 0.73877, P: 0.503906, Q: 0.77002, R: 0.514648, S: 0.473145, T: 0.455566, U: 0.55957, V: 0.573242, W: 1.015137, X: 0.49707, Y: 0.483398, Z: 0.44873, "[": 0.151855, "\\": 0.380208, "]": 0.151855, "^": 0.25293, _: 0.258789, "`": 0.110352, a: 0.574707, b: 0.503906, c: 0.541992, d: 0.580078, e: 0.414551, f: 0.414551, g: 0.538574, h: 0.556152, i: 0.106934, j: 0.269531, k: 0.485352, l: 0.44873, m: 0.75293, n: 0.569824, o: 0.73877, p: 0.503906, q: 0.77002, r: 0.514648, s: 0.476562, t: 0.455566, u: 0.55957, v: 0.573242, w: 1.015137, x: 0.49707, y: 0.486328, z: 0.44873, "{": 0.265137, "|": 0.191406, "}": 0.260417, "~": 0.293457, \u00C0: 0.574707, \u00C2: 0.578125, \u00C6: 0.835449, \u00C7: 0.51123, \u00C9: 0.414551, \u00C8: 0.414551, \u00CA: 0.414551, \u00CB: 0.414551, \u00CE: 0.213542, \u00CF: 0.208333, \u00D4: 0.73877, \u0152: 1.146484, \u00D9: 0.55957, \u00DB: 0.55957, \u00DC: 0.55957, \u0178: 1.146484, \u00E0: 0.574707, \u00E2: 0.578125, \u00E6: 0.835449, \u00E7: 0.51123, \u00E9: 0.414551, \u00E8: 0.414551, \u00EA: 0.414551, \u00EB: 0.414551, \u00EE: 0.213542, \u00EF: 0.208333, \u00F4: 0.73877, \u0153: 1.146484, \u00F9: 0.55957, \u00FB: 0.55957, \u00FC: 0.55957, \u00FF: 0.49707 } }, SanDiego: { lineHeight: 0.914062, advances: { "0": 0.623006, "1": 0.404989, "2": 0.541992, "3": 0.586995, "4": 0.576986, "5": 0.526001, "6": 0.560018, "7": 0.461995, "8": 0.628988, "9": 0.560018, " ": 0.286987, "!": 0.281982, '"': 0.408, "#": 0.831991, $: 0.583984, "%": 0.741007, "&": 0.76001, "'": 0.230998, "(": 0.352987, ")": 0.352987, "*": 0.590007, "+": 0.652995, ",": 0.26001, "-": 0.546997, ".": 0.26001, "/": 0.303019, ":": 0.26001, ";": 0.26001, "<": 0.564982, "=": 0.628011, ">": 0.564982, "?": 0.543009, "@": 1.060994, A: 0.680013, B: 0.656006, C: 0.673991, D: 0.73702, E: 0.607992, F: 0.581991, G: 0.70402, H: 0.744995, I: 0.284017, J: 0.321981, K: 0.534993, L: 0.533, M: 0.86499, N: 0.746012, O: 0.767008, P: 0.626017, Q: 0.783, R: 0.649007, S: 0.583984, T: 0.515015, U: 0.706014, V: 0.630981, W: 0.873006, X: 0.609985, Y: 0.571981, Z: 0.576009, "[": 0.366984, "\\": 0.303019, "]": 0.366984, "^": 0.513997, _: 0.510986, "`": 0.31901, a: 0.633993, b: 0.633993, c: 0.536011, d: 0.633993, e: 0.567993, f: 0.38798, g: 0.633993, h: 0.64502, i: 0.262004, j: 0.243001, k: 0.480998, l: 0.262004, m: 0.970011, n: 0.626994, o: 0.598999, p: 0.633993, q: 0.633993, r: 0.32902, s: 0.47701, t: 0.442017, u: 0.61499, v: 0.517985, w: 0.763997, x: 0.574015, y: 0.619995, z: 0.496012, "{": 0.375, "|": 0.286011, "}": 0.375, "~": 0.595011, \u00C0: 0.680013, \u00C2: 0.680013, \u00C6: 1.027995, \u00C7: 0.673991, \u00C9: 0.607992, \u00C8: 0.607992, \u00CA: 0.607992, \u00CB: 0.607992, \u00CE: 0.320312, \u00CF: 0.284017, \u00D4: 0.767008, \u0152: 1.164998, \u00D9: 0.706014, \u00DB: 0.706014, \u00DC: 0.706014, \u0178: 0.571981, \u00E0: 0.633993, \u00E2: 0.633993, \u00E6: 1.036011, \u00E7: 0.536011, \u00E9: 0.567993, \u00E8: 0.567993, \u00EA: 0.567993, \u00EB: 0.567993, \u00EE: 0.320312, \u00EF: 0.286458, \u00F4: 0.598999, \u0153: 1.02002, \u00F9: 0.61499, \u00FB: 0.61499, \u00FC: 0.61499, \u00FF: 0.619995 } }, Simplicity: { lineHeight: 0.489583, advances: { "0": 0.357015, "1": 0.138997, "2": 0.328003, "3": 0.331991, "4": 0.274984, "5": 0.322998, "6": 0.293009, "7": 0.329997, "8": 0.357992, "9": 0.317993, " ": 0.175008, "!": 0.140991, '"': 0.213989, "#": 0.454997, $: 0.364014, "%": 0.362996, "&": 0.369995, "'": 0.159993, "(": 0.229004, ")": 0.229004, "*": 0.189006, "+": 0.312988, ",": 0.154989, "-": 0.277995, ".": 0.156006, "/": 0.277995, ":": 0.156006, ";": 0.168986, "<": 0.22998, "=": 0.312988, ">": 0.22998, "?": 0.303996, "@": 0.545003, A: 0.289062, B: 0.253011, C: 0.277018, D: 0.26001, E: 0.234009, F: 0.232015, G: 0.267008, H: 0.269002, I: 0.138997, J: 0.239014, K: 0.255005, L: 0.217, M: 0.343994, N: 0.274007, O: 0.279012, P: 0.239014, Q: 0.279012, R: 0.243001, S: 0.26298, T: 0.286458, U: 0.298014, V: 0.304688, W: 0.421875, X: 0.300008, Y: 0.307292, Z: 0.309896, "[": 0.237996, "\\": 0.277995, "]": 0.225016, "^": 0.196981, _: 0.277995, "`": 0.168009, a: 0.289062, b: 0.253011, c: 0.277018, d: 0.26001, e: 0.234009, f: 0.232015, g: 0.267008, h: 0.269002, i: 0.138997, j: 0.239014, k: 0.253988, l: 0.217, m: 0.343994, n: 0.274007, o: 0.279012, p: 0.239014, q: 0.279012, r: 0.243001, s: 0.26298, t: 0.286458, u: 0.298014, v: 0.304688, w: 0.421875, x: 0.300008, y: 0.307292, z: 0.309896, "{": 0.284993, "|": 0.138997, "}": 0.284993, \u00C0: 0.289062, \u00C2: 0.289062, \u00C6: 0.463542, \u00C7: 0.277018, \u00C9: 0.234009, \u00C8: 0.234009, \u00CA: 0.234009, \u00CB: 0.234009, \u00CE: 0.138997, \u00CF: 0.138997, \u00D4: 0.279012, \u0152: 0.435018, \u00D9: 0.298014, \u00DB: 0.298014, \u00DC: 0.298014, \u0178: 0.307292, \u00E0: 0.289062, \u00E2: 0.289062, \u00E6: 0.463542, \u00E7: 0.277018, \u00E9: 0.234009, \u00E8: 0.234009, \u00EA: 0.234009, \u00EB: 0.234009, \u00EE: 0.138997, \u00EF: 0.138997, \u00F4: 0.279012, \u0153: 0.435018, \u00F9: 0.298014, \u00FB: 0.298014, \u00FC: 0.298014, \u00FF: 0.307292 } }, Typewriter: { lineHeight: 0.854167, advances: { "0": 0.524902, "1": 0.524902, "2": 0.524902, "3": 0.524902, "4": 0.524902, "5": 0.524902, "6": 0.524902, "7": 0.524902, "8": 0.524902, "9": 0.524902, " ": 0.524902, "!": 0.524902, '"': 0.524902, "#": 0.524902, $: 0.524902, "%": 0.524902, "&": 0.524902, "'": 0.524902, "(": 0.524902, ")": 0.524902, "*": 0.524902, "+": 0.524902, ",": 0.524902, "-": 0.524902, ".": 0.524902, "/": 0.524902, ":": 0.524902, ";": 0.524902, "<": 0.524902, "=": 0.524902, ">": 0.524902, "?": 0.524902, "@": 0.524902, A: 0.524902, B: 0.524902, C: 0.524902, D: 0.524902, E: 0.524902, F: 0.524902, G: 0.524902, H: 0.524902, I: 0.524902, J: 0.524902, K: 0.524902, L: 0.524902, M: 0.524902, N: 0.524902, O: 0.524902, P: 0.524902, Q: 0.524902, R: 0.524902, S: 0.524902, T: 0.524902, U: 0.524902, V: 0.524902, W: 0.524902, X: 0.524902, Y: 0.524902, Z: 0.524902, "[": 0.524902, "\\": 0.524902, "]": 0.524902, "^": 0.524902, _: 0.524902, "`": 0.524902, a: 0.524902, b: 0.524902, c: 0.524902, d: 0.524902, e: 0.524902, f: 0.524902, g: 0.524902, h: 0.524902, i: 0.524902, j: 0.524902, k: 0.524902, l: 0.524902, m: 0.526042, n: 0.524902, o: 0.524902, p: 0.524902, q: 0.524902, r: 0.524902, s: 0.524902, t: 0.524902, u: 0.524902, v: 0.524902, w: 0.524902, x: 0.524902, y: 0.524902, z: 0.524902, "{": 0.524902, "|": 0.524902, "}": 0.524902, "~": 0.524902, \u00C0: 0.524902, \u00C2: 0.524902, \u00C6: 0.524902, \u00C7: 0.524902, \u00C9: 0.524902, \u00C8: 0.524902, \u00CA: 0.524902, \u00CB: 0.524902, \u00CE: 0.524902, \u00CF: 0.524902, \u00D4: 0.524902, \u0152: 0.524902, \u00D9: 0.524902, \u00DB: 0.524902, \u00DC: 0.524902, \u0178: 0.524902, \u00E0: 0.524902, \u00E2: 0.524902, \u00E6: 0.524902, \u00E7: 0.524902, \u00E9: 0.524902, \u00E8: 0.524902, \u00EA: 0.524902, \u00EB: 0.524902, \u00EE: 0.524902, \u00EF: 0.524902, \u00F4: 0.524902, \u0153: 0.524902, \u00F9: 0.524902, \u00FB: 0.524902, \u00FC: 0.524902, \u00FF: 0.524902 } }, Waikiki: { lineHeight: 0.65625, advances: { "0": 0.590983, "1": 0.375977, "2": 0.538005, "3": 0.559977, "4": 0.641032, "5": 0.561035, "6": 0.544027, "7": 0.582031, "8": 0.552979, "9": 0.565999, " ": 0.332031, "!": 0.256999, '"': 0.354004, "#": 0.818034, $: 0.611979, "%": 0.729004, "&": 0.72998, "'": 0.22998, "(": 0.33903, ")": 0.337972, "*": 0.496012, "+": 0.547038, ",": 0.22404, "-": 0.547038, ".": 0.18099, "/": 0.568034, ":": 0.225016, ";": 0.249023, "<": 0.479004, "=": 0.547038, ">": 0.479004, "?": 0.584961, "@": 0.851969, A: 0.694987, B: 0.601969, C: 0.684977, D: 0.648031, E: 0.601969, F: 0.593018, G: 0.708984, H: 0.659017, I: 0.250977, J: 0.572021, K: 0.649007, L: 0.580973, M: 0.854004, N: 0.677979, O: 0.756999, P: 0.594971, Q: 0.763021, R: 0.618001, S: 0.617025, T: 0.669027, U: 0.679036, V: 0.687988, W: 0.882975, X: 0.628011, Y: 0.71696, Z: 0.597005, "[": 0.318034, "\\": 0.568034, "]": 0.31901, "^": 0.607992, _: 0.833008, "`": 0.52002, a: 0.694987, b: 0.601969, c: 0.684977, d: 0.648031, e: 0.601969, f: 0.593018, g: 0.708984, h: 0.659017, i: 0.250977, j: 0.572021, k: 0.649007, l: 0.580973, m: 0.854004, n: 0.677979, o: 0.756999, p: 0.594971, q: 0.763021, r: 0.618001, s: 0.617025, t: 0.669027, u: 0.679036, v: 0.687988, w: 0.882975, x: 0.628011, y: 0.71696, z: 0.597005, "{": 0.354004, "|": 0.245036, "}": 0.354004, "~": 0.559977, \u00C0: 0.694987, \u00C2: 0.723958, \u00C6: 0.95402, \u00C7: 0.684977, \u00C9: 0.601969, \u00C8: 0.601969, \u00CA: 0.651042, \u00CB: 0.601969, \u00CE: 0.25, \u00CF: 0.260417, \u00D4: 0.756999, \u0152: 1.121989, \u00D9: 0.677002, \u00DB: 0.677083, \u00DC: 0.677002, \u0178: 0.71696, \u00E0: 0.694987, \u00E2: 0.723958, \u00E6: 0.95402, \u00E7: 0.684977, \u00E9: 0.601969, \u00E8: 0.601969, \u00EA: 0.651042, \u00EB: 0.601969, \u00EE: 0.25, \u00EF: 0.260417, \u00F4: 0.756999, \u0153: 1.121989, \u00F9: 0.677002, \u00FB: 0.677083, \u00FC: 0.677002, \u00FF: 0.71696 } }, Bellview: { lineHeight: 0.75, advances: { "0": 0.495117, "1": 0.398926, "2": 0.510417, "3": 0.463542, "4": 0.505208, "5": 0.495117, "6": 0.495117, "7": 0.40625, "8": 0.464355, "9": 0.462402, " ": 0.248047, "!": 0.328125, '"': 0.328125, "#": 0.652344, $: 0.495117, "%": 0.786133, "&": 0.821777, "'": 0.324219, "(": 0.370117, ")": 0.370117, "*": 0.568848, "+": 0.605957, ",": 0.271973, "-": 0.398926, ".": 0.271973, "/": 0.348958, ":": 0.271973, ";": 0.271973, "<": 0.567871, "=": 0.561523, ">": 0.625488, "?": 0.375, "@": 0.98584, A: 0.984375, B: 0.776042, C: 0.67041, D: 0.823242, E: 0.510417, F: 0.71875, G: 0.651042, H: 0.932292, I: 0.71875, J: 0.854167, K: 0.854167, L: 0.957031, M: 1.041667, N: 1.036458, O: 0.670898, P: 0.744792, Q: 0.838542, R: 0.744792, S: 0.604167, T: 0.770833, U: 0.635417, V: 0.630208, W: 0.786458, X: 0.817708, Y: 0.651042, Z: 0.75, "[": 0.444336, "\\": 0.458496, "]": 0.421875, "^": 0.495117, _: 0.604492, "`": 0.5, a: 0.380208, b: 0.302083, c: 0.307292, d: 0.489583, e: 0.3125, f: 0.692708, g: 0.447917, h: 0.375, i: 0.244792, j: 0.494792, k: 0.369792, l: 0.307292, m: 0.552083, n: 0.416667, o: 0.364583, p: 0.578125, q: 0.364583, r: 0.333333, s: 0.244792, t: 0.3125, u: 0.364583, v: 0.265625, w: 0.421875, x: 0.375, y: 0.442708, z: 0.303223, "{": 0.495117, "|": 0.495117, "}": 0.495117, "~": 0.49707, \u00C0: 0.984375, \u00C2: 0.984375, \u00C6: 1.427734, \u00C7: 0.683105, \u00C9: 0.510417, \u00C8: 0.510417, \u00CA: 0.510417, \u00CB: 0.510417, \u00CE: 0.755208, \u00CF: 0.739583, \u00D4: 0.660645, \u0152: 0.5, \u00D9: 0.640625, \u00DB: 0.640625, \u00DC: 0.640625, \u0178: 0.5, \u00E0: 0.364583, \u00E2: 0.364583, \u00E9: 0.317708, \u00E8: 0.302083, \u00EA: 0.34375, \u00EB: 0.354167, \u00EE: 0.239583, \u00EF: 0.255208, \u00F4: 0.359375, \u0153: 0.5, \u00F9: 0.364583, \u00FB: 0.364583, \u00FC: 0.364583, \u00FF: 0.4375 } }, LoveNeon: { lineHeight: 0.760417, advances: { "0": 0.617025, "1": 0.379964, "2": 0.559001, "3": 0.471029, "4": 0.576009, "5": 0.565023, "6": 0.527995, "7": 0.5, "8": 0.534993, "9": 0.534017, " ": 0.284017, "!": 0.299967, '"': 0.256022, "#": 0.854167, $: 0.549967, "%": 0.72404, "&": 0.69401, "'": 0.15096, "(": 0.253011, ")": 0.256999, ",": 0.313965, "-": 0.419027, ".": 0.23999, "/": 0.427979, ":": 0.23999, ";": 0.23999, "?": 0.493001, "@": 0.857992, A: 0.646973, B: 0.64502, C: 0.606038, D: 0.728027, E: 0.527018, F: 0.511963, G: 0.695964, H: 0.684001, I: 0.326986, J: 0.486979, K: 0.614014, L: 0.562012, M: 0.899984, N: 0.767008, O: 0.861979, P: 0.625, Q: 0.864014, R: 0.621012, S: 0.549967, T: 0.569987, U: 0.700033, V: 0.627035, W: 0.902018, X: 0.665039, Y: 0.673014, Z: 0.570964, "`": 0.28597, a: 0.646973, b: 0.64502, c: 0.606038, d: 0.728027, e: 0.527018, f: 0.511963, g: 0.695964, h: 0.684001, i: 0.326986, j: 0.486979, k: 0.614014, l: 0.562012, m: 0.899984, n: 0.767008, o: 0.861979, p: 0.625, q: 0.864014, r: 0.621012, s: 0.549967, t: 0.569987, u: 0.700033, v: 0.627035, w: 0.902018, x: 0.665039, y: 0.673014, z: 0.570964, \u00C0: 0.646973, \u00C2: 0.646973, \u00C6: 0.843018, \u00C7: 0.606038, \u00C9: 0.527018, \u00C8: 0.527018, \u00CA: 0.527018, \u00CB: 0.527018, \u00CE: 0.326986, \u00CF: 0.375, \u00D4: 0.861979, \u0152: 0.856038, \u00D9: 0.700033, \u00DB: 0.700033, \u00DC: 0.700033, \u0178: 0.673014, \u00E0: 0.646973, \u00E2: 0.646973, \u00E6: 0.843018, \u00E7: 0.606038, \u00E9: 0.527018, \u00E8: 0.527018, \u00EA: 0.527018, \u00EB: 0.527018, \u00EE: 0.326986, \u00EF: 0.375, \u00F4: 0.861979, \u0153: 0.856038, \u00F9: 0.700033, \u00FB: 0.700033, \u00FC: 0.700033, \u00FF: 0.673014 } }, Majorca: { lineHeight: 0.851562, advances: { "0": 0.682007, "1": 0.472005, "2": 0.692017, "3": 0.692993, "4": 0.755981, "5": 0.697998, "6": 0.670003, "7": 0.633016, "8": 0.664998, "9": 0.685994, " ": 0.343018, "!": 0.456014, '"': 0.475993, "#": 0.777018, $: 0.682007, "%": 0.706991, "&": 1.13501, "'": 0.267008, "(": 0.482015, ")": 0.482015, "*": 0.630005, "+": 0.666016, ",": 0.314006, "-": 0.590983, ".": 0.255981, "/": 0.600016, ":": 0.262004, ";": 0.265991, "<": 0.567993, "=": 0.645996, ">": 0.567993, "?": 0.656982, "@": 1.190999, A: 0.776001, B: 0.605998, C: 0.607015, D: 0.642008, E: 0.571004, F: 0.565999, G: 0.701986, H: 0.715007, I: 0.338989, J: 0.708984, K: 0.675985, L: 0.498006, M: 0.779989, N: 0.701009, O: 0.671997, P: 0.534993, Q: 0.687012, R: 0.647013, S: 0.619995, T: 0.621012, U: 0.673991, V: 0.755005, W: 0.819987, X: 0.744995, Y: 0.715007, Z: 0.687988, "[": 0.482992, "\\": 0.600016, "]": 0.482992, "^": 0.663005, _: 0.675008, "`": 0.256999, a: 0.609985, b: 0.656982, c: 0.623983, d: 0.611003, e: 0.722982, f: 0.708008, g: 0.675008, h: 0.699992, i: 0.348999, j: 0.628988, k: 0.633993, l: 0.369019, m: 0.937012, n: 0.725993, o: 0.654989, p: 0.557007, q: 0.753988, r: 0.684001, s: 0.619995, t: 0.770996, u: 0.699015, v: 0.793986, w: 0.979004, x: 0.692017, y: 0.661987, z: 0.592, "{": 0.574015, "|": 0.314982, "}": 0.574015, "~": 0.751994, \u00C0: 0.776001, \u00C2: 0.776001, \u00C6: 1.041016, \u00C7: 0.607015, \u00C9: 0.571004, \u00C8: 0.571004, \u00CA: 0.571004, \u00CB: 0.571004, \u00CE: 0.668986, \u00CF: 0.637004, \u00D4: 1.001994, \u00D9: 0.673991, \u00DB: 0.673991, \u00DC: 0.673991, \u0178: 0.715007, \u00E0: 0.609985, \u00E2: 0.609985, \u00E6: 1.060018, \u00E7: 0.623983, \u00E9: 0.722982, \u00E8: 0.722982, \u00EA: 0.722982, \u00EB: 0.722982, \u00EE: 0.348999, \u00EF: 0.348999, \u00F4: 0.654989, \u00F9: 0.699015, \u00FB: 0.699015, \u00FC: 0.699015, \u00FF: 0.661987 } }, Manhattan: { lineHeight: 0.927083, advances: { "0": 0.607015, "1": 0.288981, "2": 0.52002, "3": 0.52002, "4": 0.557007, "5": 0.534993, "6": 0.531006, "7": 0.536987, "8": 0.553996, "9": 0.531006, " ": 0.303996, "!": 0.234009, '"': 0.326009, "#": 0.748006, $: 0.52002, "%": 0.786987, "&": 0.64799, "(": 0.346354, ")": 0.346354, "*": 0.298991, "+": 0.293009, ",": 0.17098, "-": 0.189006, ".": 0.170003, "/": 0.578003, ":": 0.180013, ";": 0.182983, "<": 0.248983, "=": 0.291016, ">": 0.248983, "?": 0.432292, "@": 0.755005, A: 0.46875, B: 0.524007, C: 0.512004, D: 0.527995, E: 0.508016, F: 0.5, G: 0.534993, H: 0.546997, I: 0.236003, J: 0.468018, K: 0.538981, L: 0.494995, M: 0.979167, N: 0.546997, O: 0.574992, P: 0.51298, Q: 0.598958, R: 0.522013, S: 0.482015, T: 0.46875, U: 0.533, V: 0.46875, W: 0.979167, X: 0.481771, Y: 0.479167, Z: 0.479167, "[": 0.28125, "\\": 0.578003, "]": 0.28125, "^": 0.380005, _: 0.277018, a: 0.503988, b: 0.508016, c: 0.432983, d: 0.51001, e: 0.482015, f: 0.554688, g: 0.510986, h: 0.522013, i: 0.232015, j: 0.356771, k: 0.517008, l: 0.232015, m: 0.854004, n: 0.517008, o: 0.501017, p: 0.508993, q: 0.508016, r: 0.430013, s: 0.451986, t: 0.425985, u: 0.501017, v: 0.458333, w: 0.760417, x: 0.502604, y: 0.517008, z: 0.502604, "{": 0.307292, "}": 0.307292, \u00C0: 0.46875, \u00C2: 0.46875, \u00C6: 0.807292, \u00C7: 0.512004, \u00C9: 0.508016, \u00C8: 0.508016, \u00CA: 0.508016, \u00CB: 0.508016, \u00CE: 0.236003, \u00CF: 0.236003, \u00D4: 0.574992, \u0152: 0.939982, \u00D9: 0.534017, \u00DB: 0.534017, \u00DC: 0.534017, \u0178: 0.479167, \u00E0: 0.503988, \u00E2: 0.503988, \u00E6: 0.784993, \u00E7: 0.432983, \u00E9: 0.482015, \u00E8: 0.482015, \u00EA: 0.482015, \u00EB: 0.482015, \u00EE: 0.232015, \u00EF: 0.230998, \u00F4: 0.501017, \u0153: 0.857015, \u00F9: 0.501017, \u00FB: 0.501017, \u00FC: 0.501017, \u00FF: 0.517008 } }, Marquee: { lineHeight: 0.822917, advances: { "0": 0.406982, "1": 0.306966, "2": 0.40804, "3": 0.402018, "4": 0.424967, "5": 0.409017, "6": 0.40804, "7": 0.384033, "8": 0.406982, "9": 0.406982, " ": 0.260986, "!": 0.211995, '"': 0.322021, "#": 0.436035, $: 0.409993, "%": 0.753011, "&": 0.447998, "'": 0.173991, "(": 0.274007, ")": 0.274007, "*": 0.316976, "+": 0.666992, ",": 0.16097, "-": 0.226969, ".": 0.212972, "/": 0.390625, ":": 0.212972, ";": 0.243978, "<": 0.731038, "=": 0.725016, ">": 0.72998, "?": 0.33903, "@": 0.618001, A: 0.420003, B: 0.42098, C: 0.405029, D: 0.423991, E: 0.36499, F: 0.350016, G: 0.419027, H: 0.42098, I: 0.173991, J: 0.398031, K: 0.36499, L: 0.357015, M: 0.555013, N: 0.472005, O: 0.406982, P: 0.402018, Q: 0.406982, R: 0.417969, S: 0.417969, T: 0.381999, U: 0.42098, V: 0.42098, W: 0.548991, X: 0.396973, Y: 0.343018, Z: 0.346029, "[": 0.322021, "\\": 0.390625, "]": 0.322021, "^": 0.412028, _: 0.296875, "`": 0.263021, a: 0.420003, b: 0.42098, c: 0.405029, d: 0.423991, e: 0.36499, f: 0.350016, g: 0.419027, h: 0.42098, i: 0.173991, j: 0.398031, k: 0.36499, l: 0.357015, m: 0.555013, n: 0.472005, o: 0.406982, p: 0.402018, q: 0.406982, r: 0.417969, s: 0.417969, t: 0.381999, u: 0.42098, v: 0.42098, w: 0.548991, x: 0.396973, y: 0.343018, z: 0.346029, "{": 0.277995, "|": 0.327962, "}": 0.277995, "~": 0.746012, \u00C0: 0.420003, \u00C2: 0.420003, \u00C6: 0.604004, \u00C7: 0.405029, \u00C9: 0.36499, \u00C8: 0.36499, \u00CA: 0.36499, \u00CB: 0.36499, \u00CE: 0.291667, \u00CF: 0.3125, \u00D4: 0.406982, \u0152: 0.587972, \u00D9: 0.42098, \u00DB: 0.42098, \u00DC: 0.42098, \u0178: 0.343018, \u00E0: 0.420003, \u00E2: 0.420003, \u00E6: 0.604004, \u00E7: 0.405029, \u00E9: 0.36499, \u00E8: 0.36499, \u00EA: 0.36499, \u00EB: 0.36499, \u00EE: 0.291667, \u00EF: 0.3125, \u00F4: 0.406982, \u0153: 0.587972, \u00F9: 0.42098, \u00FB: 0.42098, \u00FC: 0.42098, \u00FF: 0.343018 } }, Mayfair: { lineHeight: 0.848958, advances: { "0": 0.502035, "1": 0.465983, "2": 0.500977, "3": 0.502035, "4": 0.502035, "5": 0.499023, "6": 0.503011, "7": 0.506022, "8": 0.504964, "9": 0.503011, " ": 0.299967, "!": 0.222982, '"': 0.334961, "#": 0.673014, $: 0.502035, "%": 0.788005, "&": 0.611979, "'": 0.136963, "(": 0.271973, ")": 0.274007, "*": 0.471029, "+": 0.554036, ",": 0.222982, "-": 0.277995, ".": 0.21696, "/": 0.322917, ":": 0.201986, ";": 0.218994, "<": 0.597982, "=": 0.597982, ">": 0.597982, "?": 0.500977, "@": 0.955973, A: 0.615967, B: 0.604004, C: 0.656982, D: 0.67098, E: 0.579997, F: 0.534017, G: 0.686035, H: 0.649007, I: 0.20402, J: 0.440023, K: 0.608968, L: 0.496012, M: 0.76001, N: 0.652018, O: 0.701986, P: 0.572021, Q: 0.708008, R: 0.618001, S: 0.597005, T: 0.536458, U: 0.632975, V: 0.578125, W: 0.847005, X: 0.5625, Y: 0.588542, Z: 0.556966, "[": 0.27002, "\\": 0.328125, "]": 0.27002, "^": 0.600993, _: 0.503011, "`": 0.267008, a: 0.490967, b: 0.493001, c: 0.469971, d: 0.493001, e: 0.493001, f: 0.302083, g: 0.493001, h: 0.48999, i: 0.163005, j: 0.21875, k: 0.451986, l: 0.162028, m: 0.770996, n: 0.495036, o: 0.5, p: 0.502035, q: 0.52002, r: 0.295003, s: 0.441976, t: 0.291667, u: 0.493001, v: 0.484375, w: 0.67098, x: 0.46875, y: 0.463542, z: 0.451986, "{": 0.340007, "|": 0.250977, "}": 0.340007, "~": 0.718994, \u00CB: 0.638021, \u00E0: 0.547038, \u00E2: 0.547038, \u00E9: 0.54598, \u00E8: 0.54598, \u00EA: 0.54598, \u00EB: 0.54598, \u00F4: 0.555013 } }, Milan: { lineHeight: 0.744792, advances: { "0": 0.579997, "1": 0.515015, "2": 0.621989, "3": 0.609009, "4": 0.64799, "5": 0.597005, "6": 0.565999, "7": 0.489014, "8": 0.621989, "9": 0.559001, " ": 0.25, "!": 0.265015, '"': 0.234009, "#": 0.838013, $: 0.569987, "%": 0.656982, "&": 0.670003, "'": 0.135986, "(": 0.345011, ")": 0.345011, "*": 0.397013, "+": 0.527995, ",": 0.189006, "-": 0.508993, ".": 0.13501, "/": 0.51298, ":": 0.14502, ";": 0.14502, "<": 0.588989, "=": 0.465983, ">": 0.588989, "?": 0.548014, "@": 0.817017, A: 0.562988, B: 0.586995, C: 0.560018, D: 0.600993, E: 0.57902, F: 0.562012, G: 0.581991, H: 0.60498, I: 0.291016, J: 0.564006, K: 0.579997, L: 0.553996, M: 0.720988, N: 0.630005, O: 0.576986, P: 0.567993, Q: 0.576986, R: 0.585002, S: 0.536987, T: 0.48702, U: 0.600016, V: 0.555013, W: 0.85201, X: 0.550985, Y: 0.550985, Z: 0.550985, "[": 0.336995, "\\": 0.51298, "]": 0.336995, "^": 0.449015, _: 0.619792, "`": 0.159017, a: 0.562988, b: 0.586995, c: 0.560018, d: 0.600993, e: 0.57902, f: 0.567993, g: 0.581991, h: 0.60498, i: 0.291016, j: 0.564006, k: 0.579997, l: 0.553996, m: 0.720988, n: 0.630005, o: 0.576986, p: 0.567993, q: 0.576986, r: 0.585002, s: 0.536987, t: 0.48702, u: 0.600016, v: 0.555013, w: 0.85201, x: 0.550985, y: 0.550985, z: 0.550985, "{": 0.428019, "|": 0.298014, "}": 0.427002, "~": 0.47998, \u00C0: 0.562988, \u00C2: 0.562988, \u00C6: 0.760986, \u00C7: 0.560018, \u00C9: 0.57902, \u00C8: 0.57902, \u00CA: 0.57902, \u00CB: 0.57902, \u00CE: 0.291016, \u00CF: 0.291016, \u00D4: 0.576986, \u0152: 0.888997, \u00D9: 0.600016, \u00DB: 0.600016, \u00DC: 0.600016, \u0178: 0.550985, \u00E0: 0.562988, \u00E2: 0.562988, \u00E6: 0.760986, \u00E7: 0.560018, \u00E9: 0.57902, \u00E8: 0.57902, \u00EA: 0.57902, \u00EB: 0.57902, \u00EE: 0.291016, \u00EF: 0.291016, \u00F4: 0.576986, \u0153: 0.888997, \u00F9: 0.600016, \u00FB: 0.600016, \u00FC: 0.600016, \u00FF: 0.550985 } }, NeonGlow: { lineHeight: 0.9375, advances: { "0": 0.635254, "1": 0.291504, "2": 0.613281, "3": 0.635742, "4": 0.635254, "5": 0.626953, "6": 0.635254, "7": 0.635254, "8": 0.635742, "9": 0.635742, " ": 0.248047, "!": 0.208984, '"': 0.398926, "#": 0.673828, $: 0.672363, "%": 0.673828, "&": 0.73291, "'": 0.217773, "(": 0.32666, ")": 0.32666, "*": 0.409668, "+": 0.556641, ",": 0.217773, "-": 0.556641, ".": 0.208984, "/": 0.366699, ":": 0.208984, ";": 0.217773, "<": 0.586914, "=": 0.556641, ">": 0.586914, "?": 0.644531, "@": 0.95166, A: 0.675293, B: 0.673828, C: 0.650391, D: 0.673828, E: 0.673828, F: 0.673828, G: 0.657715, H: 0.673828, I: 0.208984, J: 0.647461, K: 0.629883, L: 0.557617, M: 0.910645, N: 0.673828, O: 0.673828, P: 0.673828, Q: 0.673828, R: 0.673828, S: 0.672363, T: 0.673828, U: 0.673828, V: 0.675293, W: 0.910645, X: 0.673828, Y: 0.67334, Z: 0.673828, "[": 0.388184, "\\": 0.366699, "]": 0.388184, "^": 0.304688, _: 0.673828, "`": 0.23291, a: 0.506836, b: 0.506836, c: 0.506348, d: 0.506836, e: 0.519531, f: 0.54541, g: 0.506348, h: 0.506836, i: 0.208984, j: 0.474121, k: 0.506836, l: 0.208984, m: 0.830566, n: 0.520508, o: 0.519531, p: 0.506836, q: 0.506836, r: 0.418945, s: 0.506836, t: 0.54541, u: 0.506348, v: 0.509766, w: 0.810547, x: 0.512695, y: 0.522461, z: 0.52002, "{": 0.341309, "|": 0.208984, "}": 0.341309, "~": 0.673828, \u0152: 0.644531, \u0178: 0.644531, \u0153: 0.644531 } }, NeonLite: { lineHeight: 0.6875, advances: { "0": 0.600016, "1": 0.299967, "2": 0.493001, "3": 0.500977, "4": 0.448975, "5": 0.527018, "6": 0.506999, "7": 0.461995, "8": 0.490967, "9": 0.47998, " ": 0.190023, "!": 0.110026, '"': 0.136963, "#": 0.551025, $: 0.475016, "%": 0.631022, "&": 0.690023, "'": 0.063965, "(": 0.222005, ")": 0.222982, "*": 0.267008, "+": 0.409017, ",": 0.190023, "-": 0.229167, ".": 0.170003, "/": 0.319987, ":": 0.170003, ";": 0.174967, "<": 0.462972, "=": 0.384033, ">": 0.476969, "?": 0.311035, "@": 0.494792, A: 0.631022, B: 0.659993, C: 0.628988, D: 0.597982, E: 0.59196, F: 0.552002, G: 0.653971, H: 0.649007, I: 0.209961, J: 0.549967, K: 0.593018, L: 0.549967, M: 0.872965, N: 0.642008, O: 0.718018, P: 0.590007, Q: 0.728027, R: 0.629964, S: 0.562012, T: 0.552002, U: 0.670003, V: 0.600016, W: 0.891032, X: 0.76001, Y: 0.638997, Z: 0.683024, "[": 0.170003, "\\": 0.255208, "]": 0.170003, "^": 0.208333, _: 0.427083, "`": 0.140625, a: 0.634033, b: 0.659993, c: 0.624023, d: 0.597982, e: 0.593018, f: 0.552979, g: 0.653971, h: 0.649984, i: 0.209961, j: 0.549967, k: 0.59196, l: 0.549967, m: 0.875, n: 0.642008, o: 0.715983, p: 0.586995, q: 0.747965, r: 0.629964, s: 0.562012, t: 0.552979, u: 0.670003, v: 0.600016, w: 0.889974, x: 0.76001, y: 0.638997, z: 0.681966, "{": 0.170003, "|": 0.120036, "}": 0.170003, "~": 0.270833, \u00C0: 0.653971, \u00C2: 0.653971, \u00C6: 1.079997, \u00C7: 0.643962, \u00C9: 0.611003, \u00C8: 0.611003, \u00CA: 0.611003, \u00CB: 0.611003, \u00CE: 0.22998, \u00CF: 0.22998, \u00D4: 0.736979, \u0152: 1.090007, \u00D9: 0.690023, \u00DB: 0.690023, \u00DC: 0.690023, \u00E0: 0.653971, \u00E2: 0.653971, \u00E6: 1.079997, \u00E7: 0.643962, \u00E9: 0.611003, \u00E8: 0.611003, \u00EA: 0.611003, \u00EB: 0.611003, \u00EE: 0.22998, \u00EF: 0.22998, \u00F4: 0.736979, \u0153: 1.090007, \u00F9: 0.690023, \u00FB: 0.690023, \u00FC: 0.690023, \u00FF: 0.659017 } }, Neontrace: { lineHeight: 0.802083, advances: { "0": 0.649007, "1": 0.302002, "2": 0.613037, "3": 0.590983, "4": 0.57902, "5": 0.593018, "6": 0.58903, "7": 0.583984, "8": 0.621012, "9": 0.58903, " ": 0.5, "!": 0.152018, '"': 0.301025, "#": 0.732015, $: 0.489014, "%": 0.719971, "&": 0.726969, "'": 0.17098, "(": 0.280029, ")": 0.278971, "*": 0.5, "+": 0.583008, ",": 0.274007, "-": 0.454997, ".": 0.274984, "/": 0.506022, ":": 0.274984, ";": 0.274984, "<": 0.41097, "=": 0.472005, ">": 0.41097, "?": 0.514974, "@": 0.864014, A: 0.722982, B: 0.645996, C: 0.648031, D: 0.646973, E: 0.597982, F: 0.59904, G: 0.646973, H: 0.620036, I: 0.152018, J: 0.506022, K: 0.58903, L: 0.503011, M: 0.832031, N: 0.64502, O: 0.648031, P: 0.642985, Q: 0.705973, R: 0.677002, S: 0.597982, T: 0.643962, U: 0.643962, V: 0.722982, W: 1.009033, X: 0.679036, Y: 0.66097, Z: 0.643962, "[": 0.280029, "\\": 0.506022, "]": 0.278971, "^": 0.413005, _: 0.617025, "`": 0.264974, a: 0.722982, b: 0.645996, c: 0.648031, d: 0.646973, e: 0.597982, f: 0.59904, g: 0.646973, h: 0.620036, i: 0.152018, j: 0.506022, k: 0.58903, l: 0.503011, m: 0.832031, n: 0.64502, o: 0.648031, p: 0.642985, q: 0.705973, r: 0.677002, s: 0.597982, t: 0.643962, u: 0.643962, v: 0.722982, w: 1.009033, x: 0.679036, y: 0.66097, z: 0.643962, "{": 0.280029, "|": 0.155029, "}": 0.278971, "~": 0.461995, \u00C0: 0.722982, \u00C2: 0.722982, \u00C6: 1.250977, \u00C7: 0.648031, \u00C9: 0.597982, \u00C8: 0.597982, \u00CA: 0.597982, \u00CB: 0.597982, \u00CE: 0.333333, \u00CF: 0.411458, \u00D4: 0.648031, \u0152: 1.176025, \u00D9: 0.643962, \u00DB: 0.643962, \u00DC: 0.643962, \u0178: 0.66097, \u00E0: 0.722982, \u00E2: 0.722982, \u00E6: 1.250977, \u00E7: 0.648031, \u00E9: 0.597982, \u00E8: 0.597982, \u00EA: 0.597982, \u00EB: 0.597982, \u00EE: 0.333333, \u00EF: 0.40625, \u00F4: 0.648031, \u0153: 1.176025, \u00F9: 0.643962, \u00FB: 0.643962, \u00FC: 0.643962, \u00FF: 0.66097 } }, Nevada: { lineHeight: 0.932292, advances: { "0": 0.415039, "1": 0.169027, "2": 0.361979, "3": 0.34904, "4": 0.356038, "5": 0.363037, "6": 0.368978, "7": 0.299967, "8": 0.399007, "9": 0.374023, " ": 0.25, "!": 0.15096, '"': 0.27596, "#": 0.412028, $: 0.478027, "%": 0.28597, "&": 0.436035, "'": 0.134033, "(": 0.28304, ")": 0.281006, "*": 0.316976, "+": 0.317708, ",": 0.15804, "-": 0.386963, ".": 0.14502, "/": 0.223958, ":": 0.11499, ";": 0.151042, "<": 0.284017, "=": 0.378011, ">": 0.284017, "?": 0.278971, "@": 0.563965, A: 0.421875, B: 0.513021, C: 0.43099, D: 0.483968, E: 0.409017, F: 0.385417, G: 0.445964, H: 0.451986, I: 0.191976, J: 0.381022, K: 0.434977, L: 0.405029, M: 0.559977, N: 0.513021, O: 0.481038, P: 0.490967, Q: 0.484375, R: 0.489583, S: 0.444987, T: 0.359375, U: 0.521973, V: 0.450033, W: 0.561035, X: 0.463542, Y: 0.453125, Z: 0.447917, "[": 0.253988, "\\": 0.223958, "]": 0.247965, "^": 0.298014, _: 0.430013, "`": 0.121989, a: 0.384033, b: 0.375, c: 0.309001, d: 0.360026, e: 0.319987, f: 0.301025, g: 0.392008, h: 0.399007, i: 0.152018, j: 0.255208, k: 0.337972, l: 0.152018, m: 0.510986, n: 0.357015, o: 0.312012, p: 0.388021, q: 0.421875, r: 0.351969, s: 0.305013, t: 0.260417, u: 0.360026, v: 0.298991, w: 0.402018, x: 0.281982, y: 0.370036, z: 0.302083, "{": 0.27002, "|": 0.110026, "}": 0.267008, "~": 0.357015, \u00C0: 0.421875, \u00C2: 0.421875, \u00C6: 0.65625, \u00C7: 0.423991, \u00C9: 0.409017, \u00C8: 0.409017, \u00CA: 0.409017, \u00CB: 0.409017, \u00CE: 0.234375, \u00CF: 0.25, \u00D4: 0.481038, \u00D9: 0.521973, \u00DB: 0.521973, \u00DC: 0.521973, \u0178: 0.453125, \u00E0: 0.384033, \u00E2: 0.384033, \u00E6: 0.557292, \u00E7: 0.302979, \u00E9: 0.319987, \u00E8: 0.319987, \u00EA: 0.319987, \u00EB: 0.319987, \u00EE: 0.171875, \u00EF: 0.203125, \u00F4: 0.312012, \u00F9: 0.360026, \u00FB: 0.360026, \u00FC: 0.360026, \u00FF: 0.370036 } }, SciFi: { lineHeight: 0.838542, advances: { "0": 0.903971, "1": 0.423991, "2": 0.903971, "3": 0.903971, "4": 0.903971, "5": 0.903971, "6": 0.903971, "7": 0.903971, "8": 0.903971, "9": 0.903971, " ": 0.5, "!": 0.263997, '"': 0.583984, "#": 0.903971, $: 0.903971, "%": 0.583984, "&": 0.903971, "'": 0.278971, "(": 0.423991, ")": 0.423991, "*": 0.503988, "+": 0.583984, ",": 0.263997, "-": 0.583984, ".": 0.263997, "/": 0.583984, ":": 0.263997, ";": 0.263997, "<": 0.583984, "=": 0.583984, ">": 0.583984, "?": 0.903971, "@": 1.22404, A: 0.903971, B: 0.903971, C: 0.903971, D: 0.903971, E: 0.903971, F: 0.903971, G: 0.903971, H: 0.903971, I: 0.263997, J: 0.743978, K: 0.903971, L: 0.743978, M: 1.225016, N: 0.903971, O: 0.903971, P: 0.903971, Q: 0.903971, R: 0.903971, S: 0.903971, T: 0.903971, U: 0.903971, V: 1.22404, W: 1.225016, X: 0.903971, Y: 0.903971, Z: 0.903971, "[": 0.423991, "\\": 0.583984, "]": 0.423991, "^": 0.903971, _: 0.583984, "`": 0.326986, a: 0.903971, b: 0.903971, c: 0.903971, d: 0.903971, e: 0.903971, f: 0.903971, g: 0.903971, h: 0.903971, i: 0.263997, j: 0.743978, k: 0.903971, l: 0.743978, m: 0.903971, n: 0.903971, o: 0.903971, p: 0.903971, q: 0.903971, r: 0.743978, s: 0.903971, t: 0.743978, u: 0.903971, v: 0.903971, w: 0.903971, x: 0.903971, y: 0.903971, z: 0.903971, "{": 0.583984, "|": 0.263997, "}": 0.583984, "~": 0.743978, \u00C0: 0.5, \u00C2: 0.5, \u00C6: 0.5, \u00C7: 0.5, \u00C9: 0.5, \u00C8: 0.5, \u00CA: 0.5, \u00CB: 0.5, \u00CE: 0.5, \u00CF: 0.5, \u00D4: 0.5, \u0152: 0.5, \u00D9: 0.5, \u00DB: 0.5, \u00DC: 0.5, \u0178: 0.5, \u00E0: 0.5, \u00E2: 0.5, \u00E6: 0.5, \u00E7: 0.5, \u00E9: 0.5, \u00E8: 0.5, \u00EA: 0.5, \u00EB: 0.5, \u00EE: 0.5, \u00EF: 0.5, \u00F4: 0.5, \u0153: 0.5, \u00F9: 0.5, \u00FB: 0.5, \u00FC: 0.5, \u00FF: 0.5 } }, Rockstar: { lineHeight: 0.723958, advances: { "0": 0.756836, "1": 0.470215, "2": 0.601562, "3": 0.601562, "4": 0.621094, "5": 0.630859, "6": 0.618652, "7": 0.621094, "8": 0.630371, "9": 0.618652, " ": 0.248047, "!": 0.252441, '"': 0.30127, "#": 0.795898, $: 0.57666, "%": 0.737305, "&": 0.659668, "'": 0.164062, "(": 0.330078, ")": 0.330078, "*": 0.250488, "+": 0.659668, ",": 0.330078, "-": 0.659668, ".": 0.252441, "/": 0.349609, ":": 0.252441, ";": 0.330078, "<": 0.49707, "=": 0.659668, ">": 0.49707, "?": 0.504883, "@": 0.74707, A: 0.819824, B: 0.659668, C: 0.654297, D: 0.69873, E: 0.659668, F: 0.659668, G: 0.756836, H: 0.69873, I: 0.252441, J: 0.407715, K: 0.725586, L: 0.659668, M: 0.795898, N: 0.659668, O: 0.756836, P: 0.659668, Q: 0.776367, R: 0.659668, S: 0.708496, T: 0.679199, U: 0.675293, V: 0.819824, W: 1.015625, X: 0.763184, Y: 0.707031, Z: 0.666992, "[": 0.349609, "\\": 0.349609, "]": 0.349609, _: 0.659668, "`": 0.330078, a: 0.819824, b: 0.659668, c: 0.654297, d: 0.69873, e: 0.659668, f: 0.659668, g: 0.756836, h: 0.69873, i: 0.252441, j: 0.407715, k: 0.725586, l: 0.659668, m: 0.795898, n: 0.659668, o: 0.756836, p: 0.659668, q: 0.776367, r: 0.659668, s: 0.708496, t: 0.679199, u: 0.675293, v: 0.819824, w: 1.015625, x: 0.763184, y: 0.707031, z: 0.666992, \u00C0: 0.819824, \u00C2: 0.819824, \u00C6: 1.164062, \u00C7: 0.654785, \u00C9: 0.659668, \u00C8: 0.659668, \u00CA: 0.659668, \u00CB: 0.659668, \u00CE: 0.282227, \u00CF: 0.291504, \u00D4: 0.756836, \u00D9: 0.675293, \u00DB: 0.675293, \u00DC: 0.675293, \u00E0: 0.819824, \u00E2: 0.819824, \u00E6: 1.164062, \u00E7: 0.654785, \u00E9: 0.659668, \u00E8: 0.659668, \u00EA: 0.659668, \u00EB: 0.659668, \u00EE: 0.282227, \u00EF: 0.291504, \u00F4: 0.756836, \u00F9: 0.675293, \u00FB: 0.675293, \u00FC: 0.675293, \u00FF: 0.707031 } }, Submarine: { lineHeight: 0.760417, advances: { "0": 0.453125, "1": 0.338542, "2": 0.429688, "3": 0.46875, "4": 0.445312, "5": 0.455729, "6": 0.424479, "7": 0.377604, "8": 0.440104, "9": 0.450521, " ": 0.260986, "!": 0.28125, '"': 0.5, "#": 0.744792, $: 0.445312, "%": 0.640625, "&": 0.484375, "'": 0.270833, "(": 0.395833, ")": 0.395833, "*": 0.434896, "+": 0.466146, ",": 0.270833, "-": 0.466146, ".": 0.252604, "/": 0.46875, ":": 0.252604, ";": 0.273438, "<": 0.544271, "=": 0.526042, ">": 0.544271, "?": 0.382812, "@": 0.703125, A: 0.588542, B: 0.489583, C: 0.460938, D: 0.473958, E: 0.460938, F: 0.40625, G: 0.455729, H: 0.588542, I: 0.338542, J: 0.46875, K: 0.523438, L: 0.460938, M: 0.747396, N: 0.570312, O: 0.53125, P: 0.489583, Q: 0.53125, R: 0.526042, S: 0.445312, T: 0.401042, U: 0.489583, V: 0.544271, W: 0.570312, X: 0.53125, Y: 0.479167, Z: 0.427083, "[": 0.408854, "\\": 0.46875, "]": 0.411458, _: 0.466146, "`": 0.166667, a: 0.398438, b: 0.390625, c: 0.411458, d: 0.390625, e: 0.411458, f: 0.390625, g: 0.375, h: 0.481771, i: 0.3125, j: 0.375, k: 0.460938, l: 0.296875, m: 0.622396, n: 0.481771, o: 0.432292, p: 0.427083, q: 0.427083, r: 0.419271, s: 0.364583, t: 0.338542, u: 0.398438, v: 0.440104, w: 0.463542, x: 0.427083, y: 0.382812, z: 0.354167, "{": 0.401042, "|": 0.21875, "}": 0.401042, "~": 0.486003, \u00C0: 0.588542, \u00C2: 0.588542, \u00C6: 0.773438, \u00C7: 0.460938, \u00C9: 0.460938, \u00C8: 0.460938, \u00CA: 0.460938, \u00CB: 0.460938, \u00CE: 0.338542, \u00CF: 0.338542, \u00D4: 0.53125, \u0152: 0.700521, \u00D9: 0.489583, \u00DB: 0.489583, \u00DC: 0.489583, \u0178: 0.479167, \u00E0: 0.398438, \u00E2: 0.398438, \u00E6: 0.619792, \u00E7: 0.411458, \u00E9: 0.411458, \u00E8: 0.411458, \u00EA: 0.411458, \u00EB: 0.411458, \u00EE: 0.3125, \u00EF: 0.3125, \u00F4: 0.432292, \u0153: 0.632812, \u00F9: 0.398438, \u00FB: 0.398438, \u00FC: 0.398438, \u00FF: 0.382812 } }, Vancouver: { lineHeight: 0.71875, advances: { "0": 0.515015, "1": 0.262004, "2": 0.421997, "3": 0.383993, "4": 0.404989, "5": 0.406006, "6": 0.401001, "7": 0.371012, "8": 0.439982, "9": 0.395996, " ": 0.265015, "!": 0.343994, '"': 0.296997, "#": 0.565999, $: 0.35498, "%": 0.340983, "&": 0.611003, "'": 0.178019, "(": 0.328003, ")": 0.326009, "*": 0.460002, "+": 0.437012, ",": 0.22701, "-": 0.343994, ".": 0.215007, "/": 0.305013, ":": 0.248006, ";": 0.232015, "<": 0.366007, "=": 0.307983, ">": 0.366007, "?": 0.413005, "@": 0.548991, A: 0.55599, B: 0.510417, C: 0.512004, D: 0.527018, E: 0.442708, F: 0.442708, G: 0.598958, H: 0.560994, I: 0.26298, J: 0.472982, K: 0.543986, L: 0.421875, M: 0.649984, N: 0.600016, O: 0.546997, P: 0.507812, Q: 0.534017, R: 0.507812, S: 0.515625, T: 0.546875, U: 0.529989, V: 0.526042, W: 0.585002, X: 0.560018, Y: 0.580729, Z: 0.472982, "[": 0.373006, "\\": 0.262004, "]": 0.373006, "^": 0.291992, _: 0.439982, a: 0.55599, b: 0.510417, c: 0.512004, d: 0.527018, e: 0.442708, f: 0.442708, g: 0.598958, h: 0.560994, i: 0.26298, j: 0.472982, k: 0.543986, l: 0.421875, m: 0.649984, n: 0.600016, o: 0.546997, p: 0.507812, q: 0.534017, r: 0.507812, s: 0.515625, t: 0.546875, u: 0.529989, v: 0.526042, w: 0.585002, x: 0.560018, y: 0.580729, z: 0.472982, "{": 0.321981, "}": 0.321981, "~": 0.503011, \u00C0: 0.555013, \u00C2: 0.555013, \u00C7: 0.510986, \u00C9: 0.442708, \u00C8: 0.442708, \u00CA: 0.442708, \u00CB: 0.442708, \u00CE: 0.291992, \u00CF: 0.29598, \u00D4: 0.546997, \u00D9: 0.529012, \u00DB: 0.529012, \u00DC: 0.529012, \u0178: 0.588013, \u00E0: 0.555013, \u00E2: 0.555013, \u00E7: 0.510986, \u00E9: 0.442708, \u00E8: 0.442708, \u00EA: 0.442708, \u00EB: 0.442708, \u00EE: 0.291992, \u00EF: 0.29598, \u00F4: 0.546997, \u00F9: 0.529012, \u00FB: 0.529012, \u00FC: 0.529012, \u00FF: 0.588013 } }, Westcoast: { lineHeight: 1.153646, advances: { "0": 0.544922, "1": 0.547852, "2": 0.550781, "3": 0.55957, "4": 0.538086, "5": 0.517578, "6": 0.563477, "7": 0.569336, "8": 0.613281, "9": 0.521484, " ": 0.390625, "!": 0.289062, '"': 0.695312, "#": 0.777344, $: 0.599609, "%": 0.757812, "&": 0.671875, "'": 0.353516, "(": 0.496094, ")": 0.512695, "*": 0.582031, "+": 0.59375, ",": 0.298828, "-": 0.412109, ".": 0.283203, "/": 0.683594, ":": 0.362305, ";": 0.368164, "<": 0.542969, "=": 0.5, ">": 0.550781, "?": 0.539062, "@": 1.025391, A: 0.729492, B: 0.698242, C: 0.666992, D: 0.59375, E: 0.549805, F: 0.507812, G: 0.661133, H: 0.610352, I: 0.53125, J: 0.601562, K: 0.601562, L: 0.524414, M: 0.731445, N: 0.667969, O: 0.649414, P: 0.59668, Q: 0.679688, R: 0.672852, S: 0.563477, T: 0.611979, U: 0.613281, V: 0.708008, W: 0.893555, X: 0.735352, Y: 0.75293, Z: 0.679688, "[": 0.371094, "\\": 0.683594, "]": 0.40625, "^": 0.44043, _: 0.682617, "`": 0.306641, a: 0.551758, b: 0.538086, c: 0.464844, d: 0.516602, e: 0.523438, f: 0.546875, g: 0.507812, h: 0.50293, i: 0.283203, j: 0.513021, k: 0.589844, l: 0.290039, m: 0.685547, n: 0.566406, o: 0.494141, p: 0.55957, q: 0.643229, r: 0.498047, s: 0.458008, t: 0.453125, u: 0.5, v: 0.556641, w: 0.78125, x: 0.632812, y: 0.601562, z: 0.540039, "{": 0.481771, "|": 0.307617, "}": 0.479167, "~": 0.566406, \u00C0: 0.729492, \u00C2: 0.729492, \u00C6: 0.893555, \u00C7: 0.666992, \u00C9: 0.556641, \u00C8: 0.554688, \u00CA: 0.556641, \u00CB: 0.554688, \u00CE: 0.53125, \u00CF: 0.556641, \u00D4: 0.649414, \u0152: 0.824219, \u00D9: 0.59375, \u00DB: 0.59375, \u00DC: 0.59375, \u0178: 0.739583, \u00E0: 0.538086, \u00E2: 0.538086, \u00E6: 0.757812, \u00E7: 0.450521, \u00E9: 0.52832, \u00E8: 0.523438, \u00EA: 0.510417, \u00EB: 0.533203, \u00EE: 0.382812, \u00EF: 0.518229, \u00F4: 0.494141, \u0153: 0.774414, \u00F9: 0.5, \u00FB: 0.5, \u00FC: 0.518229, \u00FF: 0.601562 } } } };

  // src/neon-text-designer-reference/sizing.js
  function characterWidthIn(options = {}) {
    const font = options.font === "Loveneon" ? "LoveNeon" : options.font;
    return options.specialOutline || lettering_policy_default.doubleStrokeFonts.includes(font) ? lettering_policy_default.doubleInchesPerCharacter : lettering_policy_default.singleInchesPerCharacter;
  }
  var MAX_WIDTH_CM = 304.8;
  function minimumWidthIn(text = "", options = {}) {
    const lines = String(text).replace(/\r\n?/g, "\n").trim().replace(/\t/g, "    ").split("\n");
    const longest = Math.max(0, ...lines.map((line) => [...line].length));
    return Math.max(18, longest * Math.round(characterWidthIn(options) * 10) / 10);
  }
  var minimumWidthCm = (text, options = {}) => Math.round(minimumWidthIn(text, options) * 2.54 * 1e4) / 1e4;
  function minimumSupportedWidthIn(text = "", options = {}) {
    const floor = minimumWidthIn(text, options);
    const name = options.font === "Loveneon" ? "LoveNeon" : options.font;
    const font = production_width_metrics_default.fonts[name];
    const lines = String(text).replace(/\r\n?/g, "\n").trim().replace(/\t/g, "    ").split("\n");
    if (!font || !String(text).trim()) return floor;
    let widest = 0;
    for (const line of lines) {
      let width = 0;
      for (const char of line) {
        if (!Object.hasOwn(font.advances, char)) return floor;
        width += font.advances[char];
      }
      widest = Math.max(widest, width);
    }
    const heightFloor = production_width_metrics_default.minimumHeightInches * widest / (font.lineHeight * lines.length);
    return Math.max(floor, Math.ceil(heightFloor * 10) / 10);
  }
  var minimumSupportedWidthCm = (text, options = {}) => Math.round(minimumSupportedWidthIn(text, options) * 2.54 * 1e4) / 1e4;
  function fontSelectionWidth(state2, font) {
    const widthCm = minimumSupportedWidthCm(state2.text, { ...state2, font });
    return widthCm <= MAX_WIDTH_CM ? { widthCm, exactSize: true } : {};
  }
  function minimumWidthIncrease(state2, partial) {
    const next = { ...state2, ...partial };
    const widthCm = minimumSupportedWidthCm(next.text, next);
    return widthCm <= MAX_WIDTH_CM && Number(state2.widthCm) + 1e-7 < widthCm ? { widthCm, exactSize: true } : {};
  }
  var displayWidth = (cm, unit) => Math.round((unit === "in" ? cm / 2.54 : cm) * 1e4) / 1e4;
  function widthBoundaryLabel(cm, unit, french2 = false) {
    const value = displayWidth(cm, unit);
    return `${unit === "in" ? value.toFixed(1) : value} ${unit === "in" ? french2 ? "po" : "in" : "cm"}`;
  }
  function widthControls(unit, text = "", options = {}) {
    const min = minimumSupportedWidthIn(text, options);
    return unit === "in" ? { min, max: 120, step: 0.1 } : { min: minimumSupportedWidthCm(text, options), max: MAX_WIDTH_CM, step: 1e-3 };
  }
  function requestedWidth(value, unit, text = "", options = {}) {
    const width = String(value).trim() === "" ? NaN : Number(value);
    const { min, max } = widthControls(unit, text, options);
    return {
      valid: Number.isFinite(width) && width >= min && width <= max,
      widthCm: unit === "in" ? width * 2.54 : width
    };
  }
  function preserveWidthSelection(state2, patch, sizes) {
    if (patch.exactSize === true) return { exactSize: true };
    if (Object.hasOwn(patch, "size") || patch.exactSize === false) {
      const tier2 = sizes.find((size) => size.key === state2.size && size.available) || sizes.find((size) => size.available);
      return tier2 ? { size: tier2.key, exactSize: false, widthCm: tier2.widthCm } : { exactSize: true };
    }
    const tier = sizes.find((size) => size.key === state2.size);
    return !state2.exactSize && (!tier?.available || Math.abs(tier.widthCm - state2.widthCm) > 1e-4) ? { exactSize: true } : {};
  }

  // src/neon-text-designer-reference/text-layout.js?v=20261018-launch1
  function normalizedTextLayout(raw = " ") {
    const source = String(raw), sourceIndices = [];
    const text = source.replace(/\r\n?|\n|[^\S\r\n]+|[^\s]/gu, (token, offset) => {
      sourceIndices.push(offset);
      return /^(\r\n?|\n)$/.test(token) ? "\n" : /^\s+$/.test(token) ? " " : token;
    });
    return { text, sourceIndices };
  }
  function inkAwareLineOffsets(metrics, fontSize, lineHeight) {
    const size = Number(fontSize) > 0 ? Number(fontSize) : 60;
    const advance = size * (Number(lineHeight) > 0 ? Number(lineHeight) : 1.3), gap = size * 0.12;
    const offsets = [];
    let previousInk = -1;
    metrics.forEach((line, index) => {
      let offset = index ? offsets[index - 1] + advance : 0;
      if (line.hasInk && previousInk >= 0) {
        const descent = Math.max(0, Number(metrics[previousInk].actualBoundingBoxDescent) || 0);
        const ascent = Math.max(0, Number(line.actualBoundingBoxAscent) || 0);
        offset = Math.max(offset, offsets[previousInk] + descent + ascent + gap);
      }
      offsets.push(offset);
      if (line.hasInk) previousInk = index;
    });
    return offsets;
  }
  function visibleTextHeight(lines, offsets, fontSize) {
    const visible = offsets.filter((offset, index) => /\S/.test(lines[index] || ""));
    return fontSize + (visible.length ? visible[visible.length - 1] - visible[0] : 0);
  }

  // src/neon-text-designer-reference/editor.js?v=20261018-launch1
  var clone = (x) => JSON.parse(JSON.stringify(x));
  var clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  var DEFAULT_PREVIEW_FONT_SIZE = 60;
  function previewTypeScale(fontSize) {
    return (Number(fontSize) || DEFAULT_PREVIEW_FONT_SIZE) / 110;
  }
  function multilinePreviewScale({ text, ink, width, height, fontSize }) {
    if (String(text).split(/\r\n?|\n/).filter((line) => line.trim()).length < 2 || !ink) return null;
    const inkWidth = ink.right - ink.left, inkHeight = ink.bottom - ink.top;
    if (![inkWidth, inkHeight, width, height].every((value) => Number.isFinite(value) && value > 0)) return null;
    return Math.min(width * 0.65 / inkWidth, height * 0.65 / inkHeight) * ((Number(fontSize) || DEFAULT_PREVIEW_FONT_SIZE) / DEFAULT_PREVIEW_FONT_SIZE);
  }
  function transformInkBounds(bounds, matrix) {
    const points = [
      [bounds.left, bounds.top],
      [bounds.right, bounds.top],
      [bounds.right, bounds.bottom],
      [bounds.left, bounds.bottom]
    ].map(([x, y]) => ({
      x: matrix[0] * x + matrix[2] * y + matrix[4],
      y: matrix[1] * x + matrix[3] * y + matrix[5]
    }));
    const left = Math.min(...points.map((p) => p.x)), top = Math.min(...points.map((p) => p.y));
    return {
      left,
      top,
      width: Math.max(...points.map((p) => p.x)) - left,
      height: Math.max(...points.map((p) => p.y)) - top
    };
  }
  function previewPresentation(state2, locale = "en") {
    const text = String(state2.text ?? ""), example = !text.trim();
    return {
      text: example ? locale.startsWith("fr") ? "Votre texte" : "Your text" : text,
      example,
      showDimensions: !example && Boolean(state2.showDimensions)
    };
  }
  var DEFAULT = {
    text: "Good vibes",
    font: "Barcelona",
    fontSize: DEFAULT_PREVIEW_FONT_SIZE,
    lineHeight: 1.3,
    align: "center",
    color: "#ff408b",
    letterColors: {},
    wordColors: {},
    widthCm: 80,
    on: true,
    brightness: 1,
    effectMode: "single",
    effectPreset: "steady",
    effectSpeed: 1,
    effectPaused: false,
    background: "#14191e",
    backboardShape: "cut-to-shape",
    backboardColor: "clear",
    showDimensions: true,
    position: { x: 0.5, y: 0.46, scale: 1, angle: 0 }
  };
  var NeonEditor = class {
    constructor(el, { onChange = () => {
    }, onSelect = () => {
    }, onReady = () => {
    } } = {}) {
      this.f = window.fabric;
      if (!this.f) throw Error("Fabric.js must be loaded before the editor");
      this.root = el.closest("#ens-reference-designer") || el.parentElement;
      this.onChange = onChange;
      this.onSelect = onSelect;
      this.state = clone(DEFAULT);
      this.history = [clone(this.state)];
      this.historyIndex = 0;
      this.revision = 0;
      this.layers = [];
      this.canvas = new this.f.Canvas(el, {
        width: 900,
        height: 650,
        backgroundColor: "#14191e",
        preserveObjectStacking: true,
        selection: false,
        renderOnAddRemove: false,
        allowTouchScrolling: true
      });
      this.configureTouchInteraction();
      this.canvas.on("object:moving", (e) => {
        if (e.target === this.sign) {
          this.constrainSign();
          this.drawDimensions();
        }
      });
      this.canvas.on("object:scaling", (e) => {
        if (e.target === this.sign) {
          this.constrainSign();
          this.drawDimensions();
        }
      });
      this.canvas.on("object:rotating", (e) => {
        if (e.target === this.sign) {
          this.constrainSign();
          this.drawDimensions();
        }
      });
      this.canvas.on("object:modified", (e) => {
        if (e.target !== this.sign) return;
        this.constrainSign();
        this.state.position = {
          x: this.sign.left / this.canvas.width,
          y: this.sign.top / this.previewHeight(),
          scale: this.sign.scaleX / (this.baseScale || 1),
          angle: this.sign.angle
        };
        this.commit();
        this.onChange(this.getState(), { source: "canvas" });
        this.drawDimensions();
      });
      this.canvas.on("mouse:down", (e) => {
        if (e.target === this.sign && this.mode() === "multicolor")
          this.selectAt(e.scenePoint || this.canvas.getScenePoint(e.e));
      });
      this.update({}, { history: false }).then(() => onReady(this));
      this.animate();
      const controller = this.root.querySelector(
        ".size-effects-controller-container"
      );
      if (controller && typeof ResizeObserver !== "undefined") {
        this.controllerObserver = new ResizeObserver(() => {
          if (this.destroyed || !this.sign) return;
          this.build();
          this.canvas.requestRenderAll();
        });
        this.controllerObserver.observe(controller);
      }
    }
    configureTouchInteraction() {
      this.adjustButton = this.root.querySelector("#previewAdjust");
      this.touchViewport = matchMedia("(pointer: coarse), (max-width: 900px)");
      this.touchAdjusting = false;
      this.updateTouchInteraction = () => {
        const touch = this.touchViewport.matches, adjusting = touch && this.touchAdjusting;
        this.root.classList.toggle("is-touch-preview", touch);
        this.root.classList.toggle("is-adjusting-preview", adjusting);
        this.canvas.allowTouchScrolling = !adjusting;
        this.canvas.skipTargetFind = touch && !adjusting;
        this.canvas.selection = false;
        if (touch && !adjusting) this.canvas.discardActiveObject();
        if (this.adjustButton) {
          this.adjustButton.hidden = !touch;
          this.adjustButton.setAttribute("aria-pressed", String(adjusting));
          this.adjustButton.textContent = adjusting ? this.adjustButton.dataset.doneLabel : this.adjustButton.dataset.moveLabel;
        }
        this.canvas.requestRenderAll();
      };
      this.toggleTouchAdjustment = () => {
        this.touchAdjusting = !this.touchAdjusting;
        this.updateTouchInteraction();
      };
      this.adjustButton?.addEventListener("click", this.toggleTouchAdjustment);
      this.touchViewport.addEventListener?.(
        "change",
        this.updateTouchInteraction
      );
      this.updateTouchInteraction();
    }
    getState() {
      return clone(this.state);
    }
    commit() {
      this.history.splice(this.historyIndex + 1);
      this.history.push(this.getState());
      if (this.history.length > 80) this.history.shift();
      this.historyIndex = this.history.length - 1;
    }
    async update(partial = {}, { history = true } = {}) {
      this.state = {
        ...this.state,
        ...clone(partial),
        position: { ...this.state.position, ...partial.position }
      };
      const revision = ++this.revision;
      const s = this.state;
      try {
        await document.fonts.load(`${Number(s.fontSize) || DEFAULT_PREVIEW_FONT_SIZE}px "${s.font}"`);
      } catch {
      }
      if (revision !== this.revision) return this.getState();
      this.build();
      await this.setBackground(s.background, revision);
      if (revision !== this.revision) return this.getState();
      this.canvas.requestRenderAll();
      if (!history && !this.initialDesignSeeded && Object.hasOwn(partial, "text") && Object.hasOwn(partial, "font")) {
        this.history = [this.getState()];
        this.historyIndex = 0;
        this.initialDesignSeeded = true;
      } else if (history) this.commit();
      this.onChange(this.getState(), { source: "update" });
      return this.getState();
    }
    build() {
      const f = this.f, s = this.state;
      this.canvas.remove(...this.canvas.getObjects());
      this.layers = [];
      const preview = previewPresentation(s, this.root.dataset.locale);
      this.root.dataset.previewExample = String(preview.example);
      if (this.adjustButton) this.adjustButton.disabled = preview.example;
      if (preview.example && this.touchAdjusting) {
        this.touchAdjusting = false;
        this.updateTouchInteraction();
      }
      const caption = this.root.querySelector(".canvas-caption");
      if (caption) caption.textContent = preview.example ? this.root.dataset.locale?.startsWith("fr") ? "Aper\xE7u d\u2019exemple" : "Example preview" : this.root.dataset.locale?.startsWith("fr") ? "Glissez pour d\xE9placer \xB7 utilisez les poign\xE9es pour redimensionner" : "Drag to position \xB7 use the corner handles to resize";
      const { text: txt, sourceIndices } = normalizedTextLayout(preview.text), styles = {};
      let index = 0, wordIndex = -1, inWord = false;
      this.charMap = [];
      txt.split("\n").forEach((line, li) => {
        styles[li] = {};
        Array.from(line).forEach((char, ci) => {
          if (/\s/.test(char)) inWord = false;
          else if (!inWord) {
            wordIndex++;
            inWord = true;
          }
          const color = this.mode() === "multicolor" ? s.letterColors?.[sourceIndices[index]] || s.wordColors?.[wordIndex] || s.color : s.color;
          styles[li][ci] = { fill: color };
          this.charMap.push({
            index: sourceIndices[index],
            line: li,
            charIndex: ci,
            char,
            wordIndex,
            color
          });
          index++;
        });
        index++;
        inWord = false;
      });
      const common = {
        fontFamily: s.font,
        fontSize: Number(s.fontSize) || DEFAULT_PREVIEW_FONT_SIZE,
        lineHeight: Number(s.lineHeight) || 1.3,
        textAlign: s.align || "center",
        originX: "center",
        originY: "center",
        left: 0,
        top: 0,
        objectCaching: false,
        selectable: false,
        evented: false,
        styles
      };
      const measure = new f.FabricText(txt, common);
      const ctx = document.createElement("canvas").getContext("2d");
      ctx.font = `${measure.fontSize}px "${s.font}"`;
      const lineStrings = txt.split("\n"), lineOffsets = inkAwareLineOffsets(lineStrings.map((line) => {
        const metrics = ctx.measureText(line);
        return { hasInk: /\S/.test(line), actualBoundingBoxAscent: metrics.actualBoundingBoxAscent, actualBoundingBoxDescent: metrics.actualBoundingBoxDescent };
      }), measure.fontSize, measure.lineHeight);
      const w = Math.max(30, measure.width), h = Math.max(30, measure.fontSize + lineOffsets[lineOffsets.length - 1]), fitHeight = Math.max(30, visibleTextHeight(lineStrings, lineOffsets, measure.fontSize));
      this.state.aspectRatio = this.getInkAspectRatio();
      this.state.heightCm = Math.round((Number(s.widthCm) || 80) / this.state.aspectRatio * 10) / 10;
      this.state.reconstructionNotes = [
        "Physical dimensions estimate rasterized glyph ink bounds, not LED centerline geometry.",
        "Backing is selected in order settings and is hidden in the preview.",
        "Dynamic animations are preview simulations."
      ];
      const objects = [];
      this.textMeasure = measure;
      for (const item of this.charMap) {
        if (item.char === " ") continue;
        const line = lineStrings[item.line];
        const lineWidth = ctx.measureText(line).width;
        const lineLeft = s.align === "left" ? -w / 2 : s.align === "right" ? w / 2 - lineWidth : -lineWidth / 2;
        const prefix = ctx.measureText(line.slice(0, item.charIndex)).width;
        const glyphMeasure = new f.FabricText(item.char, {
          ...common,
          styles: {}
        });
        const palette = catalog.colors.find(
          (c) => c.hex.toLowerCase() === String(item.color).toLowerCase()
        ) || (this.mode() === "single" ? catalog.colors.find((c) => c.name === s.colorName) : null);
        item.coreColor = palette?.coreHex || "#fff6f1";
        item.offColor = palette?.offHex || item.color;
        item.glowColor = palette?.glowHex || item.color;
        const glyphOptions = {
          ...common,
          styles: {},
          left: lineLeft + prefix + glyphMeasure.width / 2,
          top: -h / 2 + lineOffsets[item.line] + glyphMeasure.height / 2,
          fill: item.color
        };
        for (const blur of [40, 20, 8, 2]) {
          const layer = new f.FabricText(item.char, {
            ...glyphOptions,
            opacity: blur === 40 ? 0.4 : blur === 20 ? 0.55 : 0.9,
            shadow: new f.Shadow({
              color: item.glowColor,
              blur,
              offsetX: 0,
              offsetY: 0
            })
          });
          layer.neonBlur = blur;
          layer.neonChar = item;
          this.layers.push(layer);
          objects.push(layer);
        }
        const core = new f.FabricText(item.char, {
          ...glyphOptions,
          fill: s.on ? item.coreColor : item.offColor,
          opacity: 0.87
        });
        core.neonCore = true;
        core.neonChar = item;
        this.layers.push(core);
        objects.push(core);
      }
      const p = preview.example ? { x: 0.5, y: 0.5, scale: 1, angle: 0 } : s.position;
      this.sign = new f.Group(objects, {
        left: p.x * this.canvas.width,
        top: p.y * this.previewHeight(),
        originX: "center",
        originY: "center",
        scaleX: p.scale,
        scaleY: p.scale,
        angle: p.angle || 0,
        objectCaching: false,
        cornerColor: "#cafc01",
        cornerStrokeColor: "#000",
        borderColor: "#ffffff77",
        transparentCorners: false,
        cornerSize: 12,
        touchCornerSize: 26,
        lockScalingFlip: true,
        lockUniScaling: true,
        selectable: !preview.example,
        evented: !preview.example
      });
      const ink = { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity };
      for (const glyph of this.layers.filter((layer) => layer.neonCore)) {
        const metrics = ctx.measureText(glyph.neonChar.char), baseline = glyph.top - glyph.height / 2 + glyph.getHeightOfLineImpl(0) * (1 - glyph._fontSizeFraction), x = glyph.left - glyph.width / 2;
        ink.left = Math.min(ink.left, x - metrics.actualBoundingBoxLeft);
        ink.right = Math.max(ink.right, x + metrics.actualBoundingBoxRight);
        ink.top = Math.min(ink.top, baseline - metrics.actualBoundingBoxAscent);
        ink.bottom = Math.max(ink.bottom, baseline + metrics.actualBoundingBoxDescent);
      }
      this.inkBounds = Number.isFinite(ink.left) && ink.right > ink.left && ink.bottom > ink.top ? ink : null;
      const touch = this.touchViewport?.matches, fitScale = touch ? Math.min(
        this.canvas.width * 0.85 / (w + 30),
        this.previewHeight() * 0.9 / (fitHeight + 20)
      ) : Math.min(
        this.canvas.width * 0.8 / (w + 60),
        this.previewHeight() * 0.8 / (fitHeight + 50)
      );
      this.baseScale = multilinePreviewScale({
        text: txt,
        ink: this.inkBounds,
        width: this.canvas.width,
        height: this.previewHeight(),
        fontSize: s.fontSize
      }) ?? (touch ? fitScale : Math.min(fitScale, fitScale * (Number(s.widthCm) || 80) / 120)) * previewTypeScale(s.fontSize);
      this.sign.scaleX = this.sign.scaleY = this.baseScale * p.scale;
      this.canvas.add(this.sign);
      this.sign.setCoords();
      this.constrainSign({ preserveScale: true });
      this.drawDimensions();
      this.paintFrame(0);
    }
    async setBackground(background, revision) {
      const f = this.f;
      const url = typeof background === "object" ? background.url : typeof background === "string" && !background.startsWith("#") && !background.startsWith("rgb") ? background : null;
      this.canvas.backgroundImage = void 0;
      this.canvas.backgroundColor = typeof background === "object" ? background.color || "#14191e" : url ? "#14191e" : background || "#14191e";
      if (url) {
        try {
          const image = await f.FabricImage.fromURL(url, {
            crossOrigin: "anonymous"
          });
          if (revision !== this.revision) return;
          const scale = Math.max(
            this.canvas.width / image.width,
            this.canvas.height / image.height
          );
          image.set({
            scaleX: scale,
            scaleY: scale,
            left: this.canvas.width / 2,
            top: this.canvas.height / 2,
            originX: "center",
            originY: "center",
            opacity: 0.85
          });
          this.canvas.backgroundImage = image;
        } catch (error) {
          this.onChange(this.getState(), {
            source: "background",
            error: error.message
          });
        }
      }
    }
    previewHeight() {
      const controller = this.root.querySelector(
        ".size-effects-controller-container"
      );
      return Math.max(
        32,
        this.canvas.height - (controller?.offsetHeight || 0) - (this.touchViewport?.matches ? 24 : 38)
      );
    }
    getSignBounds() {
      return this.inkBounds ? transformInkBounds(this.inkBounds, this.sign.calcTransformMatrix()) : this.sign.getBoundingRect();
    }
    constrainSign({ preserveScale = false } = {}) {
      if (!this.sign) return;
      const sign = this.sign, W = this.canvas.width, H = this.previewHeight(), margin = this.touchViewport?.matches ? 8 : 12;
      sign.setCoords();
      let bounds = this.getSignBounds();
      if (bounds.width > W - margin * 2 || bounds.height > H - margin * 2) {
        const shrink = Math.min(
          (W - margin * 2) / Math.max(1, bounds.width),
          (H - margin * 2) / Math.max(1, bounds.height)
        );
        sign.set({
          scaleX: Math.max(1e-3, sign.scaleX * shrink),
          scaleY: Math.max(1e-3, sign.scaleY * shrink)
        });
        sign.setCoords();
        bounds = this.getSignBounds();
      }
      let dx = 0, dy = 0;
      if (bounds.left < margin) dx = margin - bounds.left;
      else if (bounds.left + bounds.width > W - margin)
        dx = W - margin - bounds.left - bounds.width;
      if (bounds.top < margin) dy = margin - bounds.top;
      else if (bounds.top + bounds.height > H - margin)
        dy = H - margin - bounds.top - bounds.height;
      if (dx || dy) {
        sign.set({ left: sign.left + dx, top: sign.top + dy });
        sign.setCoords();
      }
      this.state.position = {
        x: sign.left / W,
        y: sign.top / H,
        // Automatic fitting must not become a permanent user resize. Otherwise
        // enlarging then reducing text, or rotating a phone, progressively shrinks it.
        scale: preserveScale ? this.state.position.scale : sign.scaleX / (this.baseScale || 1),
        angle: sign.angle || 0
      };
    }
    drawDimensions() {
      if (this.dimensionObjects) this.canvas.remove(...this.dimensionObjects);
      this.dimensionObjects = [];
      if (!previewPresentation(this.state, this.root.dataset.locale).showDimensions || !this.sign) return;
      const touch = this.touchViewport?.matches, controller = this.root.querySelector(
        ".size-effects-controller-container"
      ), f = this.f, b = this.getSignBounds(), W = this.canvas.width, H = touch ? this.canvas.height - (controller?.offsetHeight || 0) - 8 : this.canvas.height, left = clamp(b.left, 12, W - 12), right = clamp(b.left + b.width, 12, W - 12), top = clamp(b.top, 8, H - 12), bottom = clamp(b.top + b.height, 8, H - 12), y = clamp(bottom + (touch ? 10 : 35), 12, H - (touch ? 16 : 35)), x = clamp(right + (touch ? 20 : 32), 20, W - 26);
      const style = {
        stroke: "#ffffff99",
        strokeWidth: 1,
        selectable: false,
        evented: false
      };
      const label = {
        fontFamily: "Arial",
        fontSize: touch ? 9 : 12,
        fill: "#eeeff1",
        selectable: false,
        evented: false,
        originX: "center"
      };
      const unit = this.state.unit === "in" ? "in" : "cm", suffix = unit === "in" && this.root.dataset.locale?.startsWith("fr") ? "po" : unit, display = (value) => `${Math.round(Number(value) / (unit === "in" ? 2.54 : 1) * 10) / 10} ${suffix}`;
      const widthLabel = Number.isFinite(this.state.displayWidthIn) ? display(this.state.displayWidthIn * 2.54) : display(this.state.widthCm), heightLabel = Number.isFinite(this.state.displayHeightIn) ? display(this.state.displayHeightIn * 2.54) : display(this.state.heightCm);
      this.dimensionObjects = [
        new f.Line([left, y, right, y], style),
        new f.Line([left, y - 4, left, y + 4], style),
        new f.Line([right, y - 4, right, y + 4], style),
        new f.FabricText(widthLabel, {
          ...label,
          left: clamp((left + right) / 2, 35, W - 35),
          top: y + (touch ? 3 : 6)
        }),
        new f.Line([x, top, x, bottom], style),
        new f.FabricText(heightLabel, {
          ...label,
          left: x + 10,
          top: clamp((top + bottom) / 2, 20, H - 20),
          angle: -90
        })
      ];
      this.canvas.add(...this.dimensionObjects);
    }
    selectAt(point) {
      const f = this.f, local = f.util.transformPoint(
        point,
        f.util.invertTransform(this.sign.calcTransformMatrix())
      );
      let selected2 = null, best = Infinity;
      for (const glyph of this.layers.filter((l) => l.neonCore)) {
        const dx = Math.max(0, Math.abs(local.x - glyph.left) - glyph.width / 2), dy = Math.max(0, Math.abs(local.y - glyph.top) - glyph.height / 2), distance = dx * dx + dy * dy * 4;
        if (distance < best) {
          best = distance;
          selected2 = glyph;
        }
      }
      const char = selected2?.neonChar;
      if (!char) return;
      const members = this.charMap.filter(
        (c) => c.wordIndex === char.wordIndex && !/\s/.test(c.char)
      );
      this.onSelect({
        ...char,
        word: members.map((c) => c.char).join(""),
        start: members[0]?.index,
        end: (members.at(-1)?.index ?? char.index) + 1
      });
    }
    paintFrame(t) {
      const s = this.state, mode = this.mode(), preset = String(s.effectPreset).toLowerCase();
      let opacity = s.on ? clamp(
        Number(s.brightness) > 1 ? Number(s.brightness) / 100 : Number(s.brightness),
        0,
        1
      ) : 0.3, color = s.color;
      if (s.on && !s.effectPaused && (mode === "rgb" || mode === "dynamic")) {
        const phase = t / 1e3 * (Number(s.effectSpeed) || 1);
        if (mode === "rgb" || /rainbow|color|gradient|flow|chase/.test(preset))
          color = `hsl(${phase * 60 % 360},100%,65%)`;
        if (/pulse|breathe|fade/.test(preset))
          opacity *= 0.35 + 0.65 * (1 + Math.sin(phase * 2)) / 2;
        else if (/flash|blink|strobe/.test(preset))
          opacity *= Math.sin(phase * 5) > 0 ? 1 : 0.08;
        else if (/flicker|spark|fire/.test(preset))
          opacity *= 0.65 + 0.35 * Math.sin(phase * 31) * Math.sin(phase * 13);
        else if (/wave|chase|scan|running/.test(preset))
          opacity *= 0.5 + 0.5 * (1 + Math.sin(phase * 4)) / 2;
      }
      this.layers.forEach((layer) => {
        const core = layer.neonCore;
        const item = layer.neonChar;
        const effect = this.effectForGlyph(t, item);
        const glyphColor = mode === "multicolor" ? item.color : effect.color || color;
        const light = opacity * effect.opacity;
        layer.set({
          fill: core ? s.on ? mode === "single" || mode === "multicolor" ? item.coreColor : "#fff6f1" : item.offColor : glyphColor,
          opacity: core ? s.on ? 0.87 * light : 0.6 : light * (layer.neonBlur === 40 ? 0.4 : layer.neonBlur === 20 ? 0.55 : 0.9),
          shadow: core || !s.on ? null : new this.f.Shadow({
            color: mode === "single" || mode === "multicolor" ? item.glowColor : glyphColor,
            blur: layer.neonBlur,
            offsetX: 0,
            offsetY: 0
          })
        });
      });
      this.canvas.requestRenderAll();
    }
    getInkAspectRatio() {
      const s = this.state, lines = String(s.text || " ").replace(/\r\n?|\n/g, "\n").replace(/[^\S\n]+/g, " ").split("\n"), size = 90, ctx = document.createElement("canvas").getContext("2d");
      ctx.font = `${size}px "${s.font}"`;
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      const measurements = lines.map((line) => {
        const metrics = ctx.measureText(line);
        return { width: metrics.width, hasInk: /\S/.test(line), actualBoundingBoxAscent: metrics.actualBoundingBoxAscent, actualBoundingBoxDescent: metrics.actualBoundingBoxDescent };
      }), lineOffsets = inkAwareLineOffsets(measurements, size, s.lineHeight), widths = measurements.map((metrics) => metrics.width), maxWidth = Math.max(1, ...widths);
      lines.forEach((line, li) => {
        const left = s.align === "left" ? 0 : s.align === "right" ? maxWidth - widths[li] : (maxWidth - widths[li]) / 2;
        let prefix = "";
        Array.from(line).forEach((char) => {
          const x = left + ctx.measureText(prefix).width, m = ctx.measureText(char), y = lineOffsets[li];
          prefix += char;
          if (/\s/.test(char)) return;
          minX = Math.min(minX, x - m.actualBoundingBoxLeft);
          maxX = Math.max(maxX, x + m.actualBoundingBoxRight);
          minY = Math.min(minY, y - m.actualBoundingBoxAscent);
          maxY = Math.max(maxY, y + m.actualBoundingBoxDescent);
        });
      });
      const width = maxX - minX, height = maxY - minY;
      this.state.inkWidthEm = width / size;
      return Number.isFinite(width) && height > 0 ? width / height : 2;
    }
    mode() {
      return {
        "single-color": "single",
        "multi-color": "multicolor",
        "rgb-color-changing": "rgb",
        "dynamic-effects-pack": "dynamic"
      }[this.state.effectMode] || this.state.effectMode;
    }
    effectForGlyph(t, item) {
      const s = this.state, mode = this.mode(), phase = t / 1e3 * (Number(s.effectSpeed) || 1), i = item?.index || 0, n = Math.max(1, this.charMap.length), pos = i / n;
      if (!s.on || !["rgb", "dynamic"].includes(mode)) return { opacity: 1 };
      const preset = (mode === "rgb" ? catalog.rgbEffects : catalog.dynamicEffects).find(
        (e) => String(e.id) === String(s.effectPreset) || e.name === s.effectPreset
      );
      const p = s.effectPaused ? this.pausedPhase ?? phase : phase;
      if (!s.effectPaused) this.pausedPhase = phase;
      const palette = preset?.palette || [
        "#ff2a4d",
        "#ff8d02",
        "#fff97c",
        "#85ffaa",
        "#00ffff",
        "#0274fc",
        "#8c59ff"
      ];
      const type = preset?.type || (mode === "rgb" ? "smooth-cycle" : "flow");
      const cycle = (p * 0.35 % 1 + 1) % 1;
      if (type === "static")
        return { color: preset.color || preset.hex || s.color, opacity: 1 };
      if (type === "flow")
        return { color: paletteColor(palette, p * 0.3 - pos * 0.9), opacity: 1 };
      if (type === "smooth-cycle")
        return { color: paletteColor(palette, p * 0.2), opacity: 1 };
      if (type === "color-jump")
        return {
          color: palette[Math.floor(p * 1.2) % palette.length],
          opacity: 1
        };
      if (type === "color-flash")
        return {
          color: palette[Math.floor(p * 3) % palette.length],
          opacity: p * 6 % 2 < 1 ? 1 : 0.025
        };
      if (type === "chase")
        return {
          color: palette[(Math.floor(pos * 8 - p * 3) % palette.length + palette.length) % palette.length],
          opacity: 0.8 + 0.2 * Math.sin(p * 8 - pos * 8)
        };
      if (type === "double-trail") {
        const tail = ((pos - cycle) % 1 + 1) % 1;
        return {
          color: palette[(Math.floor(p / 3) + (tail > 0.5 ? 1 : 0)) % palette.length],
          opacity: Math.max(0.08, 1 - tail * 2 % 1 * 1.4)
        };
      }
      if (type === "brush-open" || type === "brush-close") {
        const distance = Math.abs(pos - 0.5) * 2;
        const active = type === "brush-open" ? 1 - distance < cycle : distance < cycle;
        return {
          color: palette[Math.floor(p * 0.35) % palette.length],
          opacity: active ? 1 : 0.035
        };
      }
      return { color: s.color, opacity: 1 };
    }
    animate() {
      const tick = (t) => {
        if (this.destroyed) return;
        if (this.mode() === "rgb" || this.mode() === "dynamic")
          this.paintFrame(t);
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }
    async undo() {
      if (this.historyIndex > 0) {
        this.historyIndex--;
        return this.update(this.history[this.historyIndex], { history: false });
      }
    }
    async redo() {
      if (this.historyIndex < this.history.length - 1) {
        this.historyIndex++;
        return this.update(this.history[this.historyIndex], { history: false });
      }
    }
    async resize(width, height) {
      const nextWidth = Math.max(1, Math.round(Number(width) || 1)), nextHeight = Math.max(1, Math.round(Number(height) || 1));
      this.canvas.setDimensions({ width: nextWidth, height: nextHeight });
      return this.update({}, { history: false });
    }
    exportPNG({ multiplier = 2 } = {}) {
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
      return this.canvas.toDataURL({ format: "png", multiplier });
    }
    exportSVG({ production = false } = {}) {
      if (!production) return this.canvas.toSVG();
      const layers = this.layers.map((l) => ({
        l,
        visible: l.visible,
        shadow: l.shadow
      })), dims = (this.dimensionObjects || []).map((l) => ({
        l,
        visible: l.visible
      }));
      layers.forEach(({ l }) => l.set({ visible: !!l.neonCore, shadow: null }));
      dims.forEach(({ l }) => l.visible = false);
      const bg = this.canvas.backgroundImage;
      this.canvas.backgroundImage = void 0;
      const svg = this.canvas.toSVG();
      this.canvas.backgroundImage = bg;
      layers.forEach(({ l, visible, shadow }) => l.set({ visible, shadow }));
      dims.forEach(({ l, visible }) => l.visible = visible);
      this.canvas.requestRenderAll();
      return svg;
    }
    exportJSON() {
      return JSON.stringify(
        { version: 1, engine: "fabric", design: this.getState() },
        null,
        2
      );
    }
    loadJSON(json) {
      const data = typeof json === "string" ? JSON.parse(json) : json;
      return this.update(data.design || data);
    }
    destroy() {
      this.destroyed = true;
      cancelAnimationFrame(this.raf);
      this.controllerObserver?.disconnect();
      this.adjustButton?.removeEventListener("click", this.toggleTouchAdjustment);
      this.touchViewport?.removeEventListener?.(
        "change",
        this.updateTouchInteraction
      );
      this.canvas.dispose();
    }
  };
  function paletteColor(palette, phase) {
    const value = (phase % 1 + 1) % 1 * palette.length, a = palette[Math.floor(value) % palette.length], b = palette[(Math.floor(value) + 1) % palette.length], mix = value % 1;
    const parse = (h) => [1, 3, 5].map((n) => parseInt(h.slice(n, n + 2), 16));
    const aa = parse(a), bb = parse(b);
    return "#" + aa.map(
      (v, i) => Math.round(v + (bb[i] - v) * mix).toString(16).padStart(2, "0")
    ).join("");
  }

  // src/neon-text-designer-reference/font-metadata.js
  var fontMetadata = {
    "Alexa": {
      "id": 10,
      "price": 0.82,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 80,
      "mob": 75,
      "lineh": "94%",
      "nosize": "xxs"
    },
    "Barcelona": {
      "id": 15,
      "price": 0.9,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 70,
      "mob": 55,
      "lineh": "160%",
      "nosize": ""
    },
    "Bayview": {
      "id": 11,
      "price": 0.83,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s,m",
      "desk": 105,
      "mob": 90,
      "lineh": "90%",
      "nosize": "xxs,xs"
    },
    "Amsterdam": {
      "id": 12,
      "price": 0.81,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 88,
      "mob": 65,
      "lineh": "105%",
      "nosize": ""
    },
    "Greenworld": {
      "id": 13,
      "price": 0.79,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 100,
      "mob": 93,
      "lineh": "84%",
      "nosize": ""
    },
    "NewCursive": {
      "id": 14,
      "price": 0.83,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 100,
      "mob": 91,
      "lineh": "87%",
      "nosize": ""
    },
    "Vintage": {
      "id": 16,
      "price": 0.96,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 75,
      "mob": 72,
      "lineh": "110%",
      "nosize": ""
    },
    "Venetian": {
      "id": 46,
      "price": 1.07,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 88,
      "mob": 80,
      "lineh": "120%",
      "nosize": "xxs"
    },
    "Amanda": {
      "id": 17,
      "price": 0.84,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 82,
      "mob": 75,
      "lineh": "125%",
      "nosize": ""
    },
    "Austin": {
      "id": 21,
      "price": 0.77,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 120,
      "mob": 116,
      "lineh": "83%",
      "nosize": "xxs"
    },
    "Beachfront": {
      "id": 26,
      "price": 0.75,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs",
      "desk": 73,
      "mob": 65,
      "lineh": "120%",
      "nosize": ""
    },
    "Chelsea": {
      "id": 19,
      "price": 0.86,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 110,
      "mob": 98,
      "lineh": "100%",
      "nosize": "xxs"
    },
    "Freehand": {
      "id": 23,
      "price": 1,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 97,
      "mob": 89,
      "lineh": "97%",
      "nosize": ""
    },
    "Freespirit": {
      "id": 18,
      "price": 0.85,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 52,
      "mob": 50,
      "lineh": "180%",
      "nosize": ""
    },
    "LoveNote": {
      "id": 24,
      "price": 0.8,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 80,
      "mob": 80,
      "lineh": "100%",
      "nosize": ""
    },
    "Neonscript": {
      "id": 22,
      "price": 1.01,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 95,
      "mob": 85,
      "lineh": "115%",
      "nosize": ""
    },
    "Northshore": {
      "id": 25,
      "price": 0.83,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 102,
      "mob": 110,
      "lineh": "125%",
      "nosize": ""
    },
    "Photogenic": {
      "id": 47,
      "price": 0.84,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 93,
      "mob": 78,
      "lineh": "120%",
      "nosize": "xxs"
    },
    "Royalty": {
      "id": 27,
      "price": 0.75,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 68,
      "mob": 56,
      "lineh": "130%",
      "nosize": ""
    },
    "Rocket": {
      "id": 28,
      "price": 0.78,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 50,
      "mob": 45,
      "lineh": "160%",
      "nosize": ""
    },
    "Signature": {
      "id": 49,
      "price": 0.74,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 100,
      "mob": 85,
      "lineh": "95%",
      "nosize": ""
    },
    "Sorrento": {
      "id": 20,
      "price": 0.84,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 68,
      "mob": 59,
      "lineh": "150%",
      "nosize": ""
    },
    "WildScript": {
      "id": 29,
      "price": 0.99,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 115,
      "mob": 110,
      "lineh": "105%",
      "nosize": ""
    },
    "Avante": {
      "id": 30,
      "price": 0.73,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs",
      "desk": 68,
      "mob": 58,
      "lineh": "100%",
      "nosize": ""
    },
    "Buttercup": {
      "id": 35,
      "price": 0.81,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs",
      "desk": 125,
      "mob": 96,
      "lineh": "90%",
      "nosize": ""
    },
    "ClassicType": {
      "id": 33,
      "price": 0.78,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 62,
      "mob": 55,
      "lineh": "100%",
      "nosize": ""
    },
    "Typewriter": {
      "id": 34,
      "price": 0.71,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 66,
      "mob": 60,
      "lineh": "92%",
      "nosize": ""
    },
    "Melbourne": {
      "id": 36,
      "price": 0.73,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs",
      "desk": 70,
      "mob": 62,
      "lineh": "100%",
      "nosize": ""
    },
    "NeoTokyo": {
      "id": 37,
      "price": 0.65,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs",
      "desk": 73,
      "mob": 61,
      "lineh": "105%",
      "nosize": ""
    },
    "Monaco": {
      "id": 31,
      "price": 0.79,
      "nodynamicsize": "",
      "norgbsize": "xxs",
      "desk": 70,
      "mob": 58,
      "lineh": "92%",
      "nosize": ""
    },
    "Waikiki": {
      "id": 32,
      "price": 0.68,
      "nodynamicsize": "",
      "norgbsize": "xxs",
      "desk": 64,
      "mob": 50,
      "lineh": "87%",
      "nosize": ""
    },
    "Bellview": {
      "id": 50,
      "price": 1.34,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 100,
      "mob": 88,
      "lineh": "88%",
      "nosize": "xxs,xs,s"
    },
    "Loveneon": {
      "id": 38,
      "price": 1,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 60,
      "mob": 54,
      "lineh": "95%",
      "nosize": "xxs,xs,s"
    },
    "Marquee": {
      "id": 39,
      "price": 1.7,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs,s,m",
      "desk": 90,
      "mob": 72,
      "lineh": "110%",
      "nosize": "xxs,xs,s"
    },
    "Mayfair": {
      "id": 40,
      "price": 1.24,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 76,
      "mob": 66,
      "lineh": "95%",
      "nosize": "xxs,xs,s"
    },
    "NeonGlow": {
      "id": 41,
      "price": 1.09,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 75,
      "mob": 60,
      "lineh": "100%",
      "nosize": "xxs,xs,s"
    },
    "NeonLite": {
      "id": 42,
      "price": 0.68,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 66,
      "mob": 60,
      "lineh": "98%",
      "nosize": ""
    },
    "Neontrace": {
      "id": 43,
      "price": 0.77,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 62,
      "mob": 50,
      "lineh": "105%",
      "nosize": "xxs,xs"
    },
    "Nevada": {
      "id": 44,
      "price": 1.31,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 95,
      "mob": 84,
      "lineh": "93%",
      "nosize": "xxs,xs,s"
    },
    "SciFi": {
      "id": 45,
      "price": 1.21,
      "nodynamicsize": "xxs,xs,s",
      "norgbsize": "xxs,xs,s,m",
      "desk": 53,
      "mob": 52,
      "lineh": "116%",
      "nosize": "xxs,xs,s"
    },
    "LosAngeles": {
      "id": 51,
      "price": 0.79,
      "nodynamicsize": "",
      "norgbsize": "xxs",
      "desk": 90,
      "mob": 75,
      "lineh": "100%",
      "nosize": ""
    },
    "Florence": {
      "id": 52,
      "price": 0.82,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs",
      "desk": 83,
      "mob": 76,
      "lineh": "110%",
      "nosize": "xxs"
    },
    "LazySunday": {
      "id": 53,
      "price": 0.86,
      "nodynamicsize": "",
      "norgbsize": "xxs,xs,s",
      "desk": 64,
      "mob": 54,
      "lineh": "165%",
      "nosize": "xxs"
    },
    "Majorca": {
      "id": 54,
      "price": 1.31,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 62,
      "mob": 57,
      "lineh": "113%",
      "nosize": "xxs,xs"
    },
    "Manchester": {
      "id": 55,
      "price": 0.79,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 101,
      "mob": 98,
      "lineh": "92%",
      "nosize": "xxs,xs"
    },
    "Manhattan": {
      "id": 56,
      "price": 1,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s,m",
      "desk": 80,
      "mob": 79,
      "lineh": "105%",
      "nosize": "xxs,xs"
    },
    "Milan": {
      "id": 57,
      "price": 0.84,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 70,
      "mob": 65,
      "lineh": "105%",
      "nosize": "xxs,xs"
    },
    "NottingHill": {
      "id": 58,
      "price": 0.84,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 75,
      "mob": 71,
      "lineh": "115%",
      "nosize": "xxs"
    },
    "Olivia": {
      "id": 59,
      "price": 0.84,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs,s",
      "desk": 80,
      "mob": 65,
      "lineh": "127%",
      "nosize": "xxs"
    },
    "Rockstar": {
      "id": 60,
      "price": 1.18,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 58,
      "mob": 52,
      "lineh": "116%",
      "nosize": "xxs,xs"
    },
    "SanDiego": {
      "id": 61,
      "price": 0.65,
      "nodynamicsize": "",
      "norgbsize": "xxs",
      "desk": 70,
      "mob": 61,
      "lineh": "105%",
      "nosize": ""
    },
    "Simplicity": {
      "id": 62,
      "price": 0.8,
      "nodynamicsize": "",
      "norgbsize": "xxs",
      "desk": 115,
      "mob": 110,
      "lineh": "100%",
      "nosize": ""
    },
    "Submarine": {
      "id": 63,
      "price": 1.27,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 95,
      "mob": 88,
      "lineh": "103%",
      "nosize": "xxs,xs"
    },
    "Vancouver": {
      "id": 64,
      "price": 1.32,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 80,
      "mob": 73,
      "lineh": "100%",
      "nosize": "xxs,xs"
    },
    "Weekender": {
      "id": 65,
      "price": 0.84,
      "nodynamicsize": "xxs",
      "norgbsize": "xxs,xs",
      "desk": 60,
      "mob": 56,
      "lineh": "156%",
      "nosize": "xxs"
    },
    "Westcoast": {
      "id": 66,
      "price": 1.27,
      "nodynamicsize": "xxs,xs",
      "norgbsize": "xxs,xs,s",
      "desk": 80,
      "mob": 71,
      "lineh": "127%",
      "nosize": "xxs,xs"
    }
  };

  // src/neon-text-designer-reference/pricing.js?v=20261018-launch1
  var sizeKeys = ["xxs", "xs", "s", "m", "l", "xl", "xxl", "su"];
  var ranges = [
    [5, 5.5],
    [6, 6.6],
    [7, 8.5],
    [8.5, 10.5],
    [10.5, 13.5],
    [13.5, 16.5],
    [16.5, 24],
    [24, 30]
  ];
  function textMetrics(text = "") {
    const lines = (text.match(/[^\r\n]+/g) || []).map(
      (s) => s.trim().replace(/\s\s+/g, " ")
    );
    return {
      lines,
      counts: lines.map((s) => s.length),
      letterCount: lines.reduce((n, s) => n + s.length, 0),
      extraLines: Math.max(0, lines.filter(Boolean).length - 1),
      longest: Math.max(0, ...lines.map((s) => s.length))
    };
  }
  function computeQuote(state2 = {}, catalog2 = {}) {
    const props = catalog2.props || {}, font = catalog2.fonts?.[state2.font] || fontMetadata[state2.font] || fontMetadata.Barcelona, m = textMetrics(state2.text), effect = state2.effect || state2.specialEffect || "single-color";
    const unavailable = new Set((font.nosize || "").split(",").filter(Boolean));
    const effectBlocked = effect === "rgb-color-changing" ? font.norgbsize : effect === "dynamic-effects-pack" ? font.nodynamicsize : "";
    (effectBlocked || "").split(",").filter(Boolean).forEach((x) => unavailable.add(x));
    const outdoor = ["outdoor", "Waterproof", "waterproof"].includes(state2.usage);
    if (outdoor) ["xxs", "xs", "s"].forEach((x) => unavailable.add(x));
    const warnings = [], constraints = [];
    if (!m.letterCount) constraints.push("Enter text to configure a sign.");
    if (m.letterCount > 50)
      constraints.push("Signs over 50 letters require a custom quote.");
    if (outdoor && ["rgb-color-changing", "dynamic-effects-pack"].includes(effect))
      constraints.push(
        "Waterproof signs are not available with RGB or Dynamic Neon."
      );
    const selected2 = state2.size || "m";
    if (unavailable.has(selected2) && !state2.exactSize)
      constraints.push(
        "This size is unavailable for the selected font, effect, or waterproof option."
      );
    const sizes = sizeKeys.map((key, i) => {
      const lo = ranges[i][0] * m.longest, hi = ranges[i][1] * m.longest;
      const width2 = Math.round((Math.trunc(lo) + Math.trunc(hi)) / 2);
      const widthIn2 = i < 2 ? Math.round((lo * 0.3937 + hi * 0.3937) / 2 * 2) / 2 : Math.round(
        (Math.round(Math.trunc(lo) * 0.3937) + Math.round(Math.trunc(hi) * 0.3937)) / 2
      );
      return {
        key,
        widthCm: width2,
        widthIn: widthIn2,
        price: null,
        available: !unavailable.has(key) && width2 >= minimumSupportedWidthCm(state2.text, state2) && width2 <= MAX_WIDTH_CM
      };
    });
    const selectedSize = sizes.find((s) => s.key === selected2) || sizes[3];
    const width = Number(state2.widthCm) > 0 ? Number(state2.widthCm) : selectedSize.widthCm;
    const min = minimumSupportedWidthCm(state2.text, state2), max = MAX_WIDTH_CM;
    if (min > minimumWidthCm(state2.text, state2) && width + 1e-6 < min)
      constraints.push(min > max ? "This font and wording need more than 120 inches to meet the minimum production height. Choose another font, split the wording into lines, or request a custom quote." : `This font and wording need at least ${minimumSupportedWidthIn(state2.text, state2)} inches wide to meet the minimum production height. Increase the width or choose another font.`);
    else if (min > max)
      constraints.push(`This wording needs more than 120 inches under our ${characterWidthIn(state2)}-inch-per-character sizing rule. Shorten the lines or request a custom quote.`);
    else if (width + 1e-6 < min)
      constraints.push(`This wording needs at least ${minimumWidthIn(state2.text, state2)} inches wide (${characterWidthIn(state2)} inches per character, including spaces, on the longest line). Increase the width or request a custom quote.`);
    else if (width > max)
      constraints.push(`Exact width must be between ${min} and ${max} cm.`);
    const ratio = Number(state2.aspectRatio);
    const height = ratio > 0 ? Math.round(width / ratio) : null;
    if (width >= 240 || height && height >= 240 || width >= 120 && height >= 120)
      warnings.push("This sign requires two backboards.");
    if (height === null) warnings.push("Height is pending preview measurement.");
    const widthIn = width / 2.54;
    const dimensions = {
      widthCm: width,
      heightCm: height,
      widthIn,
      heightIn: ratio > 0 ? Math.round(widthIn / ratio * 2) / 2 : null,
      estimated: true,
      widthRecovered: true,
      heightEstimated: true
    };
    const board = String(state2.backboardStyle || state2.backboardShape || "1");
    if (state2.hangingKit && [
      "3",
      "9",
      "cut-to-letter",
      "cut-to-letters",
      "naked",
      "naked-neon"
    ].includes(board))
      constraints.push(
        "This backboard style is incompatible with a hanging kit."
      );
    if (["9", "naked", "naked-neon"].includes(board) && state2.backboardColor && state2.backboardColor !== "clear")
      constraints.push("Naked Neon does not use a colored backboard.");
    if (state2.rush)
      warnings.push(
        "Rush fulfilment requires merchant confirmation; no rush surcharge was recovered."
      );
    return {
      total: null,
      subtotal: null,
      discount: 0,
      currency: state2.currency || "CAD",
      dimensions,
      sizes,
      constraints,
      warnings,
      lineItems: [],
      status: constraints.length ? "invalid" : "api-pending",
      priceLabel: "Live backend quote required",
      minWidthCm: min,
      maxWidthCm: max,
      metrics: m
    };
  }

  // src/neon-text-designer-reference/commerce.js
  var API2 = "https://apiv2.easyneonsigns.ca";
  var scopes = ["quote:create", "discount:validate", "draft:create"];
  var session = { token: "", expiresAt: 0, pending: null };
  var contract = () => window.EasyNeonDesignerPricingContractV2;
  var nonce = () => crypto.randomUUID();
  var checkoutColorNames = Object.freeze({
    ...Object.fromEntries(catalog.colors.map((color) => [color.hex.toUpperCase(), color.name])),
    "#FFFFFF": "White",
    "#FFF8DC": "Warm White",
    "#FFD700": "Golden Yellow",
    "#00FF00": "Green",
    "#FFF44F": "Lemon Yellow",
    "#4169E1": "Royal Blue",
    "#9B30FF": "Purple"
  });
  function checkoutColorName(design) {
    if (design.colorMode === "rgb" || design.colorValue === "rgb") return "RGB Color Changing";
    return checkoutColorNames[String(design.colorValue).toUpperCase()] || "Custom";
  }
  function serviceErrorMessage(data, status2, language = "en") {
    const french2 = language.startsWith("fr");
    const message = typeof data?.detail?.message === "string" ? data.detail.message : status2 === 422 && typeof data?.error === "string" ? data.error : "";
    if (message === "The selected width makes this design too short or tall; request a manual quote")
      return french2 ? "Cette largeur rend le lettrage trop court ou trop haut pour une commande en ligne. Choisissez une autre largeur ou demandez un devis personnalis\xE9." : "This width makes the lettering too short or tall for online checkout. Choose another width or request a custom quote.";
    if (message.trim() && message.length <= 320) return message;
    return french2 ? "Cette cr\xE9ation n\xE9cessite un devis confirm\xE9. R\xE9essayez ou contactez-nous." : "This design needs a confirmed quote. Please retry or contact us.";
  }
  async function readJSON(response) {
    if (Number(response.headers.get("content-length")) > 32768)
      throw Error("Response too large.");
    const body = await response.text();
    if (new TextEncoder().encode(body).length > 32768)
      throw Error("Response too large.");
    try {
      return body ? JSON.parse(body) : {};
    } catch {
      throw Error("Invalid service response.");
    }
  }
  async function request(path, options = {}, timeout = 2e4) {
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (options.signal?.aborted) controller.abort();
    else options.signal?.addEventListener("abort", abort, { once: true });
    const timer = setTimeout(abort, timeout);
    try {
      const response = await fetch(API2 + path, {
        ...options,
        signal: controller.signal,
        cache: "no-store"
      });
      const data = await readJSON(response);
      return { response, data };
    } finally {
      clearTimeout(timer);
      options.signal?.removeEventListener("abort", abort);
    }
  }
  async function getSession(force = false) {
    if (!force && session.token && session.expiresAt > Date.now() + 15e3)
      return session.token;
    if (!force && session.pending) return session.pending;
    session.pending = (async () => {
      const { response, data } = await request(
        "/designer/session",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ client_nonce: nonce() })
        },
        1e4
      );
      const lifetime = Number(data.expires_in);
      if (!response.ok || data.token_type !== "Bearer" || !/^[A-Za-z0-9._~-]{32,4096}$/.test(data.access_token || "") || !Number.isFinite(lifetime) || lifetime <= 0 || lifetime > 300 || !Array.isArray(data.scopes) || !scopes.every((scope) => data.scopes.includes(scope))) {
        throw Error("Pricing connection unavailable. Please retry.");
      }
      session.token = data.access_token;
      session.expiresAt = Date.now() + lifetime * 1e3;
      return session.token;
    })();
    try {
      return await session.pending;
    } finally {
      session.pending = null;
    }
  }
  async function authenticated(path, options = {}, retries = { auth: true, consumed: true }) {
    const headers = new Headers(options.headers || {});
    headers.set("Content-Type", "application/json");
    headers.set("Authorization", `Bearer ${await getSession()}`);
    const { response, data } = await request(path, { ...options, headers });
    if (retries.auth && [401, 403].includes(response.status) || retries.consumed && response.status === 409 && data?.detail?.code === "session_scope_consumed") {
      session.token = "";
      session.expiresAt = 0;
      await getSession(true);
      return authenticated(path, options, {
        auth: retries.auth && ![401, 403].includes(response.status),
        consumed: retries.consumed && data?.detail?.code !== "session_scope_consumed"
      });
    }
    if (!response.ok) {
      const code = data?.detail?.code || "designer_request_failed";
      throw Object.assign(
        new Error(serviceErrorMessage(data, response.status, globalThis.document?.documentElement?.lang || "en")),
        { code, status: response.status }
      );
    }
    return data;
  }
  var fonts = new Set(
    catalog.fonts.map((font) => font.name === "Loveneon" ? "LoveNeon" : font.name)
  );
  function supportsOnlineFont(name) {
    return fonts.has(name === "Loveneon" ? "LoveNeon" : name);
  }
  var cuts = { 1: "cut-to-shape", 2: "cut-rectangle", 3: "cut-to-letter" };
  var backings = {
    clear: "clear",
    white: "glossy-white",
    black: "glossy-black",
    silver: "silver",
    gold: "gold"
  };
  function compatibility(state2) {
    const problems = [];
    if (!supportsOnlineFont(state2.font))
      problems.push(
        "This font needs a custom quote. You can still preview, save and share it."
      );
    if (state2.effectMode === "dynamic")
      problems.push(
        "Dynamic Neon needs a custom quote. Animation is a preview of the effect."
      );
    if (state2.usage === "outdoor" && ["rgb", "dynamic"].includes(state2.effectMode))
      problems.push(
        "RGB and Dynamic Neon are indoor-only. Choose indoor use or a single/multicolour light."
      );
    if (!cuts[state2.backboardShape])
      problems.push("This backing style needs a custom quote.");
    if (state2.adapter !== "1")
      problems.push("This power adapter needs a custom quote.");
    if (state2.wallMounting && state2.hangingKit)
      problems.push(
        "Select one mounting method for online checkout, or request a quote for both kits."
      );
    if (state2.wallMounting && state2.wallFinish !== "silver")
      problems.push("This mounting finish needs a custom quote.");
    if (state2.dimmer === false)
      problems.push(
        "The remote and dimmer are included. Contact us for a build without them."
      );
    if (state2.rush)
      problems.push(
        "Rush production must be confirmed by our team. Request a quote with your required date."
      );
    if (Number(state2.widthCm) / 2.54 < 18 || Number(state2.widthCm) / 2.54 > 120)
      problems.push(
        "Online checkout covers widths from 18 to 120 inches. Request a quote for this size."
      );
    return problems;
  }
  function selection(state2) {
    const text = String(state2.text || "").trim();
    const offset = String(state2.text || "").indexOf(text);
    const chars = [...text];
    let word = -1, inWord = false;
    const entries = [];
    chars.forEach((char, index) => {
      if (/\s/.test(char)) {
        inWord = false;
        return;
      }
      if (!inWord) {
        word++;
        inWord = true;
      }
      const color = state2.letterColors?.[index + offset] || state2.wordColors?.[word] || state2.color;
      entries.push({
        characterIndex: String(index),
        color: String(color).toUpperCase()
      });
    });
    return contract().buildQuoteRequest({
      text,
      fontFamily: state2.font === "Loveneon" ? "LoveNeon" : state2.font,
      colorMode: state2.effectMode,
      colorValue: state2.effectMode === "rgb" ? "rgb" : {
        "#E1E3E6": "#FFFFFF",
        "#FFFDCF": "#FFF8DC",
        "#FFCA1C": "#FFD700",
        "#85FFAA": "#00FF00"
      }[String(state2.color).toUpperCase()] || String(state2.color).toUpperCase(),
      multicolorSelection: state2.effectMode === "multicolor" ? entries : [],
      signUse: state2.usage,
      widthInches: Math.round(Number(state2.widthCm) / 2.54 * 1e4) / 1e4,
      // Server derives canonical font geometry; this field is compatibility-only.
      heightInches: Math.max(
        4,
        Math.min(100, Number(state2.heightCm) / 2.54 || 12)
      ),
      outline: Boolean(state2.specialOutline),
      backing: backings[state2.backboardColor],
      cut: cuts[state2.backboardShape],
      mounting: state2.wallMounting ? "wall" : state2.hangingKit ? "sign" : "none",
      powerAdapter: "canada",
      remoteAndDimmer: true,
      discountCode: state2.discountCode
    });
  }
  function selectionKey(design) {
    const { heightInches, ...priced } = design;
    return JSON.stringify(priced);
  }
  function funnel(root2, event, extra = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      designer_version: "reference",
      viewport_class: innerWidth < 768 ? "mobile" : innerWidth < 1200 ? "tablet" : "desktop",
      ...extra
    });
  }
  function fitCheckoutPreview(sign, canvas) {
    const cx = Number(canvas.width) / 2 || 500, cy = Number(canvas.height) / 2 || 310;
    const objects = sign.getObjects?.() || [];
    if (!objects.length || objects.some((layer) => typeof layer.getBoundingRect !== "function")) {
      const scale2 = Math.min(840 / Math.max(1, sign.width), 440 / Math.max(1, sign.height), 4);
      sign.set({ objectCaching: false, left: cx, top: cy, originX: "center", originY: "center", scaleX: scale2, scaleY: scale2, angle: 0 });
      canvas.add(sign);
      canvas.renderAll();
      return;
    }
    const bounds = () => {
      const boxes = objects.map((layer) => layer.getBoundingRect());
      const left = Math.min(...boxes.map((b) => b.left)), top = Math.min(...boxes.map((b) => b.top));
      const right = Math.max(...boxes.map((b) => b.left + b.width)), bottom = Math.max(...boxes.map((b) => b.top + b.height));
      if (![left, top, right, bottom].every(Number.isFinite) || right <= left || bottom <= top)
        throw Error("Preview could not be prepared.");
      return { left, top, width: right - left, height: bottom - top };
    };
    sign.set({ objectCaching: false, left: cx, top: cy, originX: "center", originY: "center", scaleX: 1, scaleY: 1, angle: 0 });
    canvas.add(sign);
    canvas.renderAll();
    const first = bounds(), scale = Math.min(840 / first.width, 440 / first.height, 4);
    sign.set({ scaleX: scale, scaleY: scale });
    canvas.renderAll();
    const fitted = bounds();
    sign.set({ left: sign.left + cx - (fitted.left + fitted.width / 2), top: sign.top + cy - (fitted.top + fitted.height / 2) });
    sign.setCoords?.();
    canvas.renderAll();
  }
  function checkoutBitmap(canvas) {
    const element = canvas.lowerCanvasEl || canvas.getElement?.();
    const context = element?.getContext?.("2d", { willReadFrequently: true });
    if (!context) return null;
    const width = element.width, height = element.height, pixels = context.getImageData(0, 0, width, height).data;
    let left = width, top = height, right = -1, bottom = -1;
    for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
      if (pixels[(y * width + x) * 4 + 3]) {
        left = Math.min(left, x);
        top = Math.min(top, y);
        right = Math.max(right, x);
        bottom = Math.max(bottom, y);
      }
    }
    if (right < left || left < 8 || top < 8 || right >= width - 8 || bottom >= height - 8)
      throw Error("Preview could not be prepared.");
    const output = document.createElement("canvas");
    output.width = 1e3;
    output.height = 620;
    const out = output.getContext("2d"), w = right - left + 1, h = bottom - top + 1, scale = Math.min(880 / w, 480 / h);
    out.fillStyle = "#000000";
    out.fillRect(0, 0, 1e3, 620);
    out.imageSmoothingQuality = "high";
    out.drawImage(element, left, top, w, h, (1e3 - w * scale) / 2, (620 - h * scale) / 2, w * scale, h * scale);
    return output;
  }
  async function signSVG(editor2) {
    const f = window.fabric;
    const canvas = new f.StaticCanvas(document.createElement("canvas"), {
      width: 2400,
      height: 1600,
      backgroundColor: null,
      renderOnAddRemove: false,
      enableRetinaScaling: false
    });
    try {
      const sign = await editor2.sign.clone();
      if (editor2.sign.getObjects && sign.getObjects) {
        const original = editor2.sign.getObjects();
        sign.getObjects().forEach((layer, i) => {
          const item = original[i];
          if (!item?.neonChar) return;
          const core = item.neonCore, color = item.neonChar.glowColor || item.neonChar.color;
          layer.set({
            fill: core ? item.neonChar.coreColor : color,
            opacity: core ? 0.87 : item.neonBlur === 40 ? 0.4 : item.neonBlur === 20 ? 0.55 : 0.9,
            shadow: core ? null : new f.Shadow({
              color,
              blur: item.neonBlur,
              offsetX: 0,
              offsetY: 0
            })
          });
        });
      }
      sign.getObjects?.().forEach((layer) => layer.set({ objectCaching: false }));
      fitCheckoutPreview(sign, canvas);
      const bitmap = checkoutBitmap(canvas);
      let png;
      for (const multiplier of [1, 0.8, 0.6, 0.45, 0.3]) {
        if (bitmap) {
          if (multiplier === 1) png = bitmap.toDataURL("image/png");
          else {
            const reduced = document.createElement("canvas");
            reduced.width = Math.round(1e3 * multiplier);
            reduced.height = Math.round(620 * multiplier);
            reduced.getContext("2d").drawImage(bitmap, 0, 0, reduced.width, reduced.height);
            png = reduced.toDataURL("image/png");
          }
        } else png = canvas.toDataURL({ format: "png", multiplier, enableRetinaScaling: false });
        if (!/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(png))
          throw Error("Preview could not be prepared.");
        if (png.length <= 7e5) break;
      }
      if (png.length > 7e5) throw Error("Preview could not be prepared.");
      return `<svg xmlns="http://www.w3.org/2000/svg" width="1000" height="620" viewBox="0 0 1000 620"><rect width="1000" height="620" fill="#000000"/><image width="1000" height="620" href="${png}"/></svg>`;
    } finally {
      canvas.dispose();
    }
  }
  async function checkoutPayload(root2, state2, priced, editor2) {
    if (!String(state2.text || "").trim())
      throw Error("Enter your own text before continuing.");
    if (root2.dataset.previewExample === "true")
      throw Error(root2.dataset.locale?.startsWith("fr") ? "Votre aper\xE7u se met \xE0 jour. R\xE9essayez dans un instant." : "Your preview is updating. Try again in a moment.");
    if (!priced || priced.expiresAt <= Date.now())
      throw Object.assign(
        Error("Your quote has expired. Refresh the price before continuing."),
        { code: "quote_expired" }
      );
    if (compatibility(state2).length)
      throw Error("This design needs a custom quote.");
    const design = selection(state2);
    const variant = root2.dataset.variantId || "";
    if (!/^(?:gid:\/\/shopify\/ProductVariant\/)?\d+$/.test(variant))
      throw Error("Product variant is unavailable.");
    const variantId = variant.startsWith("gid:") ? variant : `gid://shopify/ProductVariant/${variant}`;
    const mountingLabel = {
      none: "None",
      wall: "Wall mounting",
      sign: "Sign hanging"
    }[design.mounting];
    const backboardLabel = {
      clear: "Standard Clear Acrylic",
      "glossy-white": "Glossy White Acrylic",
      "glossy-black": "Glossy Black Acrylic",
      silver: "Silver Acrylic",
      gold: "Gold Acrylic"
    }[design.backing];
    const cutLabel = {
      "cut-to-shape": "Cut to Shape",
      "cut-to-letter": "Cut to Letter",
      "cut-rectangle": "Rectangle"
    }[design.cut];
    const color = checkoutColorName(design);
    const width = String(priced.widthInches), height = String(priced.heightInches), sizeName = `${width}\u2033 custom`;
    const extras = [
      { id: "remote", description: "Remote and Dimmer", price: "0" },
      ...design.mounting !== "none" ? [{ id: "hanging", description: mountingLabel, price: "0" }] : [],
      ...design.signUse === "outdoor" ? [{ id: "waterproof", description: "Outdoor construction", price: "0" }] : []
    ];
    const selectableOptions = {
      text: design.text,
      font: design.fontFamily,
      fontFamily: design.fontFamily,
      color,
      colorValue: design.colorValue,
      multicolor: design.colorMode === "multicolor",
      multicolorSelection: design.multicolorSelection,
      sizeName,
      widthInches: width,
      heightInches: height,
      indoorOrOutdoor: design.signUse,
      cutConfiguration: cutLabel,
      cutConfigurationId: design.cut,
      backboardColor: backboardLabel,
      backboardColorId: design.backing,
      powerAdapter: "Canada (110V)",
      powerAdapterId: "canada",
      hangingOption: mountingLabel,
      remoteAndDimmer: true,
      extras
    };
    return {
      schemaVersion: 2,
      quoteId: priced.quoteId,
      variantId,
      text: design.text,
      font: design.fontFamily,
      fontFamily: design.fontFamily,
      color,
      colorValue: design.colorValue,
      lineHeight: 20,
      widthInches: width,
      heightInches: height,
      width,
      height,
      sizeName,
      plan: {
        id: "custom",
        name: sizeName,
        widthIn: width,
        heightIn: height,
        basePrice: String(priced.originalTotal),
        price: String(priced.total),
        finalPrice: String(priced.total)
      },
      type: design.signUse,
      indoorOrOutdoor: design.signUse,
      backboard: design.backing,
      backboardColor: backboardLabel,
      cutTo: design.cut,
      cutConfiguration: cutLabel,
      cutToPrice: 0,
      powerAdapter: "canada",
      powerAdapterLabel: "Canada (110V)",
      hangingOption: mountingLabel,
      remoteAndDimmer: true,
      outdoorSurcharge: 0,
      rgbSurcharge: 0,
      multicolor: design.colorMode === "multicolor",
      multicolorSelection: design.multicolorSelection,
      outline: design.outline,
      colorMode: design.colorMode,
      selectableOptions,
      extras,
      ...contract().priceMirrors(priced),
      discountCode: design.discountCode || "",
      discountApplied: priced.couponDiscountCents > 0,
      userHasEnteredText: true,
      svgMarkup: await signSVG(editor2),
      svgWidthPx: 1e3,
      svgHeightPx: 620
    };
  }
  function allowedCheckout(root2, value) {
    const url = new URL(value), expected = String(root2.dataset.checkoutHost || "").toLowerCase();
    if (url.protocol !== "https:" || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(expected) || url.hostname.toLowerCase() !== expected || url.username || url.password || url.port && url.port !== "443")
      throw Error("Checkout URL is not allowed.");
    return url.href;
  }

  // src/neon-text-designer-reference/live-pricing.js?v=20261018-launch1
  var LivePricing = class {
    constructor(onChange) {
      Object.assign(this, {
        onChange,
        status: "idle",
        signature: "",
        result: null,
        error: "",
        errorStatus: null,
        serial: 0,
        timer: null,
        controller: null
      });
    }
    clear() {
      this.serial++;
      clearTimeout(this.timer);
      this.controller?.abort();
      this.signature = "";
      this.result = null;
      this.status = "idle";
      this.error = "";
      this.errorStatus = null;
      clearTimeout(this.expiry);
    }
    quote(payload) {
      const signature = selectionKey(payload);
      if (signature === this.signature && (this.status === "loading" || this.status === "error" || this.result?.expiresAt > Date.now()))
        return;
      this.clear();
      this.signature = signature;
      this.payload = payload;
      this.status = "loading";
      const serial = ++this.serial;
      this.timer = setTimeout(() => this.fetch(payload, serial), 450);
    }
    async fetch(payload, serial) {
      this.controller = new AbortController();
      try {
        const data = await authenticated("/designer/quote", {
          method: "POST",
          body: JSON.stringify(payload),
          signal: this.controller.signal
        });
        if (serial !== this.serial) return;
        this.result = contract().normalizeQuoteResponse(data);
        this.status = "ready";
        this.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
        this.expiry = setTimeout(
          () => {
            this.clear();
            this.onChange();
          },
          Math.max(1, this.result.expiresAt - Date.now())
        );
      } catch (error) {
        if (serial !== this.serial) return;
        this.status = "error";
        this.errorStatus = error.status || null;
        this.error = error.name === "AbortError" ? "Pricing timed out. Please retry." : error.message;
      } finally {
        if (serial === this.serial) this.onChange();
      }
    }
    retry() {
      const payload = this.payload;
      this.clear();
      if (payload) this.quote(payload);
      this.onChange();
    }
  };
  var apiPayload = (state2) => selection(state2);
  function applyLiveQuote(q, state2, live) {
    q.currency = "CAD";
    q.total = null;
    q.subtotal = null;
    q.discount = 0;
    q.lineItems = [];
    q.sizes.forEach((size) => {
      size.price = null;
      size.widthIn = size.widthCm / 2.54;
    });
    q.pricingProvider = "EasyNeonSigns \xB7 OracleOne";
    if (q.constraints.length) {
      q.status = "quote-required";
      return q;
    }
    if (live.status === "ready" && live.result) {
      const priced = live.result;
      q.total = priced.total;
      q.subtotal = priced.originalTotal;
      q.discount = priced.originalTotal - priced.total;
      q.status = "live-api";
      q.apiQuote = priced;
      q.apiUpdatedAt = live.updatedAt;
      q.dimensions = {
        widthIn: priced.widthInches,
        heightIn: priced.heightInches,
        widthCm: priced.widthInches * 2.54,
        heightCm: priced.heightInches * 2.54,
        estimated: false
      };
      q.lineItems = [
        {
          label: "Sign and selected construction \xB7 CAD",
          amount: priced.saleTotal
        },
        ...priced.couponDiscount > 0 ? [{ label: "Discount code", amount: -priced.couponDiscount }] : []
      ];
      const tier = q.sizes.find(
        (size) => Math.abs(size.widthCm - state2.widthCm) < 0.05
      );
      if (tier) tier.price = priced.total;
    } else {
      if (live.status === "error" && live.errorStatus === 422) {
        q.status = "quote-required";
        q.constraints.push(live.error || "This design needs a custom quote.");
      } else q.status = live.status === "error" ? "api-error" : "api-loading";
      if (live.status === "error" && live.errorStatus !== 422)
        q.warnings.push(live.error || "Pricing unavailable. Please retry.");
    }
    return q;
  }

  // src/neon-text-designer-reference/app.js
  var root = document.getElementById("ens-reference-designer");
  var $ = (id) => root.querySelector("#" + id);
  var all = (selector) => [...root.querySelectorAll(selector)];
  var clone2 = (x) => JSON.parse(JSON.stringify(x));
  var assets = JSON.parse(
    root.querySelector("[data-reference-assets]").textContent
  );
  var asset = (path) => assets[path] || path;
  var trustedBackgrounds = new Set(
    Object.entries(assets).filter(([path]) => path.startsWith("assets/backgrounds/")).map(([, url]) => url)
  );
  for (const list of [
    catalog.fonts,
    catalog.backgrounds,
    catalog.backboards,
    catalog.colorPhotos
  ])
    for (const item of list) {
      if (item.file) item.file = asset(item.file);
      if (item.image) item.image = asset(item.image);
      if (item.thumbnail) item.thumbnail = asset(item.thumbnail);
    }
  var french = root.dataset.locale?.startsWith("fr");
  var copy = JSON.parse(root.querySelector("[data-reference-copy]").textContent)[french ? "fr" : "en"];
  localizeCatalog(catalog, french);
  var ui = (value) => translate(value, french);
  var safe = (s) => String(s ?? "").replace(
    /[&<>"']/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]
  );
  var money = (n, currency = state?.currency || "CAD") => n === null || !Number.isFinite(n) ? french ? "Devis requis" : "Quote needed" : new Intl.NumberFormat(french ? "fr-CA" : "en-CA", {
    style: "currency",
    currency,
    maximumFractionDigits: 2
  }).format(n);
  var modeMap = {
    "single-color": "single",
    "multi-color": "multicolor",
    "rgb-color-changing": "rgb",
    "dynamic-effects-pack": "dynamic"
  };
  var effectMap = {
    single: "single-color",
    multicolor: "multi-color",
    rgb: "rgb-color-changing",
    dynamic: "dynamic-effects-pack"
  };
  var priceCatalog = {};
  var state = {
    text: "",
    font: "Barcelona",
    fontSize: DEFAULT_PREVIEW_FONT_SIZE,
    lineHeight: 1.6,
    align: "center",
    color: "#e1e3e6",
    colorName: "White",
    letterColors: {},
    wordColors: {},
    widthCm: 91.44,
    size: "m",
    exactSize: true,
    on: true,
    brightness: 1,
    effectMode: "single",
    effectPreset: "62",
    effectSpeed: 5,
    effectPaused: false,
    background: catalog.backgrounds[0].file,
    backboardShape: "1",
    backboardColor: "clear",
    showDimensions: true,
    position: { x: 0.5, y: 0.5, scale: 1, angle: 0 },
    usage: "indoor",
    wallMounting: false,
    wallFinish: "silver",
    hangingKit: false,
    dimmer: true,
    adapter: "1",
    proofRequest: true,
    rush: false,
    discount: false,
    discountCode: "",
    unit: "in",
    currency: "CAD",
    localShipping: 40,
    exchangeRate: 1.47,
    specialOutline: false,
    prioritizeStrip: true,
    stripLengthM: null,
    stripRateUsdPerM: null,
    stripReferenceWidthCm: null
  };
  var livePricing = new LivePricing(() => {
    renderQuote();
    renderLiveStatus();
  });
  var step = "design";
  var category = "all";
  var colorTarget = "letter";
  var selected = null;
  var quote = null;
  var editor = null;
  var ready = false;
  var attachment = null;
  var editingCartId = null;
  var checkoutKey = null;
  var checkoutBusy = false;
  var started = false;
  var lastPriceKey = "";
  var confirmedTotal = null;
  var previewControl = "size";
  var widthEntryInvalid = false;
  function clearWidthEntryError() {
    if (widthEntryInvalid && $("formStatus").textContent === $("widthEntryError").textContent)
      $("formStatus").textContent = "";
    widthEntryInvalid = false;
    $("widthInput").setCustomValidity("");
    $("widthInput").removeAttribute("aria-invalid");
    $("widthEntryError").hidden = true;
    $("widthEntryError").textContent = "";
  }
  function commitWidthEntry() {
    const entry = requestedWidth($("widthInput").value, state.unit, state.text, state);
    if (!entry.valid) {
      widthEntryInvalid = true;
      const limits = widthControls(state.unit, state.text, state), unit = state.unit === "in" && french ? "po" : state.unit;
      const message = french ? `Entrez une largeur de ${limits.min} \xE0 ${limits.max} ${unit}. Votre largeur actuelle est conserv\xE9e jusqu\u2019\xE0 une saisie valide.` : `Enter a width from ${limits.min} to ${limits.max} ${unit}. Your current sign width is kept until you enter a valid size.`;
      $("widthInput").setCustomValidity(message);
      $("widthInput").setAttribute("aria-invalid", "true");
      $("widthEntryError").textContent = message;
      $("widthEntryError").hidden = false;
      $("proofApproved").checked = false;
      renderQuote();
      return;
    }
    clearWidthEntryError();
    change({ widthCm: entry.widthCm, exactSize: true, position: { ...state.position, scale: 1 } });
  }
  var storage = {
    get(key, fallback) {
      try {
        return JSON.parse(localStorage.getItem(key)) ?? fallback;
      } catch {
        return fallback;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch {
        return false;
      }
    }
  };
  var status = (text) => {
    $("formStatus").textContent = ui(text);
    if (text) root.querySelector(".quote-footer").scrollTop = 0;
  };
  function download(name, data, type = "application/json") {
    const a = document.createElement("a");
    a.download = name;
    a.href = typeof data === "string" && data.startsWith("data:") ? data : URL.createObjectURL(
      new Blob(
        [typeof data === "string" ? data : JSON.stringify(data, null, 2)],
        { type }
      )
    );
    a.click();
    if (a.href.startsWith("blob:"))
      setTimeout(() => URL.revokeObjectURL(a.href), 2e3);
  }
  function openDialog(id) {
    $(id).showModal();
  }
  all("dialog").forEach((d) => {
    const title = d.querySelector("h2");
    if (title) {
      title.id = title.id || d.id + "Title";
      d.setAttribute("aria-labelledby", title.id);
    }
  });
  all(".close-dialog").forEach(
    (b) => b.onclick = () => b.closest("dialog").close()
  );
  all("dialog").forEach(
    (d) => d.addEventListener("click", (e) => {
      if (e.target === d) {
        const r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
          d.close();
      }
    })
  );
  var fontStyle = document.createElement("style");
  fontStyle.textContent = catalog.fonts.map(
    (f) => `@font-face{font-family:"${f.name}";src:url("${f.file}") format("truetype");font-display:swap}`
  ).join("\n");
  document.head.append(fontStyle);
  var fontObserver;
  function renderFonts() {
    fontObserver?.disconnect();
    const query = $("fontSearch").value.trim().toLowerCase();
    $("fontGrid").innerHTML = catalog.fonts.filter(
      (f) => (category === "all" || String(f.category) === category) && f.name.toLowerCase().includes(query)
    ).map(
      (f) => `<button data-font="${safe(f.name)}" class="${state.font === f.name ? "active" : ""}" aria-pressed="${state.font === f.name}" title="${safe(f.name)}">${safe(f.name)}<small>${safe(f.name)}${supportsOnlineFont(f.name) ? "" : `<span class="font-quote-label"> \xB7 ${french ? "Sur devis" : "Quote only"}</span>`}</small></button>`
    ).join("");
    if (typeof IntersectionObserver === "function") {
      fontObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries)
            if (entry.isIntersecting) {
              entry.target.style.fontFamily = `"${entry.target.dataset.font}"`;
              fontObserver.unobserve(entry.target);
            }
        },
        { root: $("fontGrid"), rootMargin: "64px" }
      );
      all("[data-font]").forEach((button) => fontObserver.observe(button));
    } else
      all("[data-font]").forEach(
        (button) => button.style.fontFamily = `"${button.dataset.font}"`
      );
    all("[data-font]").forEach(
      (b) => b.onclick = () => {
        const f = catalog.fonts.find((f2) => f2.name === b.dataset.font);
        change({
          font: f.name,
          lineHeight: f.lineHeight,
          ...fontSelectionWidth(state, f.name),
          position: { ...state.position, scale: 1 }
        });
      }
    );
  }
  function selectedPalette() {
    const c = selected && (colorTarget === "word" ? state.wordColors[selected.wordIndex] : state.letterColors[selected.index]);
    return c || state.color;
  }
  function renderLetterPicker() {
    if (state.effectMode !== "multicolor") return;
    const words = [...state.text.matchAll(/\S+/g)].map((m, i) => ({
      index: m.index,
      wordIndex: i,
      text: m[0]
    }));
    const entries = colorTarget === "word" ? words : [...state.text].map((text, index) => ({ text, index })).filter((x) => !/^\s$/.test(x.text));
    $("letterPicker").innerHTML = entries.map(
      (e) => `<button data-index="${e.index}" data-word="${e.wordIndex ?? ""}" class="${selected && (colorTarget === "word" ? selected.wordIndex === e.wordIndex : selected.index === e.index) ? "active" : ""}" style="border-bottom-color:${safe(colorTarget === "word" ? state.wordColors[e.wordIndex] || state.color : state.letterColors[e.index] || state.color)}">${safe(e.text)}</button>`
    ).join("");
    all("#letterPicker button").forEach(
      (b) => b.onclick = () => {
        const index = +b.dataset.index;
        const w = words.find(
          (w2) => index >= w2.index && index < w2.index + w2.text.length
        );
        selected = {
          index,
          char: state.text[index],
          wordIndex: w?.wordIndex ?? -1,
          word: w?.text,
          start: w?.index,
          end: (w?.index ?? 0) + (w?.text.length ?? 0)
        };
        renderLetterPicker();
        renderColors();
        $("selectionHint").textContent = colorTarget === "word" ? `Selected word: ${selected.word}` : `Selected letter: ${selected.char}`;
      }
    );
  }
  function renderColors() {
    const current = state.effectMode === "multicolor" ? selectedPalette() : state.color;
    all("#colors button").forEach((b) => {
      const active = b.dataset.hex === current;
      b.classList.toggle("active", active);
      b.setAttribute("aria-pressed", String(active));
    });
    const c = catalog.colors.find((c2) => c2.hex === current);
    $("colorName").textContent = c?.name || state.colorName;
  }
  function colorChange(color) {
    if (state.effectMode === "multicolor") {
      if (!selected) {
        status("Select a letter or word first.");
        return;
      }
      change(colorSelection(state, selected, colorTarget, color.hex));
    } else change({ color: color.hex, colorName: color.name });
  }
  var stripKey = "";
  var stripError = "";
  async function measureTextStrip() {
    const result = livePricing.result;
    state.stripLengthM = result?.stripLengthM ?? null;
    state.stripReferenceWidthCm = result ? state.widthCm : null;
    syncInputs();
  }
  function getQuote() {
    const q = computeQuote(
      {
        ...state,
        effect: effectMap[state.effectMode],
        backboardStyle: state.backboardShape,
        wallMounting: state.wallMounting ? state.wallFinish : false
      },
      priceCatalog
    );
    q.constraints.push(...compatibility(state));
    if (/[^\u0000-\u024f\u2000-\u206f\r\n]/u.test(state.text) && !q.constraints.length)
      q.constraints.push("This script needs a custom font and production quote.");
    if (ready && !q.constraints.length && state.text.trim()) {
      try {
        livePricing.quote(apiPayload(state));
      } catch (error) {
        q.constraints.push(error.message);
        livePricing.clear();
      }
    } else if (livePricing.signature) livePricing.clear();
    return applyLiveQuote(q, state, livePricing);
  }
  function renderQuote() {
    const empty = !state.text.trim(), wasEmpty = root.classList.contains("is-empty-design");
    root.classList.toggle("is-empty-design", empty);
    $("dimensions").disabled = empty;
    $("resetPosition").disabled = empty;
    if (empty || wasEmpty || !selected) $("selectionHint").textContent = empty ? french ? "Exemple seulement" : "Example only" : "";
    const backing = catalog.backboards.find((b) => b.id === state.backboardShape)?.name;
    const backingColor = catalog.backboardColors.find((b) => b.id === state.backboardColor)?.name;
    $("previewConstruction").textContent = empty ? "" : `${backing} \xB7 ${backingColor}. ${state.specialOutline ? french ? "Double ligne s\xE9lectionn\xE9e; support et double ligne non illustr\xE9s." : "Double-line selected; backing and double-line build not shown." : french ? "Support non illustr\xE9." : "Backing not shown."}`;
    const toolsLabel = root.querySelector(".reference-preview-tools > summary");
    if (toolsLabel) toolsLabel.textContent = empty ? french ? "Exemple \xB7 outils et aide" : "Example \xB7 save, share & help" : french ? "Enregistrer, partager et aide" : "Save, share & help";
    quote = getQuote();
    root.dataset.pricingState = quote.status;
    if ($("proofApproved").checked && quote.apiQuote && confirmedTotal !== quote.apiQuote.totalCents) {
      $("proofApproved").checked = false;
      status(
        french ? "V\xE9rifiez le prix actualis\xE9 avant de confirmer." : "Review the updated price before confirming."
      );
    }
    state.displayWidthIn = quote.dimensions.widthIn;
    state.displayHeightIn = quote.dimensions.heightIn;
    if (editor?.sign) {
      editor.state.displayWidthIn = quote.dimensions.widthIn;
      editor.state.displayHeightIn = quote.dimensions.heightIn;
      editor.drawDimensions();
      editor.canvas.requestRenderAll();
    }
    const m = textMetrics(state.text);
    $("letterCount").textContent = m.letterCount + " / 50";
    let textIssue = "";
    if (m.letterCount > 50)
      textIssue = "For signs over 50 letters, request a custom quote.";
    else if (/[^\u0000-\u024f\u2000-\u206f\r\n]/u.test(state.text))
      textIssue = "This script needs a custom font and production quote. You can still save your design.";
    $("textWarning").textContent = ui(textIssue);
    $("textWarning").hidden = !textIssue;
    $("totalPrice").textContent = !state.text.trim() ? copy.pricing : quote.status === "api-loading" ? french ? "Mise \xE0 jour\u2026" : "Updating\u2026" : quote.status === "api-error" ? french ? "Prix indisponible" : "Price unavailable" : money(quote.total);
    renderLiveStatus();
    $("beforePrice").textContent = quote.discount ? money(quote.subtotal) : "";
    $("discountMessage").textContent = quote.discount ? french ? "Prix r\xE9duit \xB7 CAD" : "Sale price \xB7 CAD" : "";
    $("pricingWarnings").textContent = empty ? "" : [...quote.constraints, ...quote.warnings].filter(Boolean).map(ui).join(" ");
    $("sizes").innerHTML = catalog.sizes.map((tier) => {
      const q = quote.sizes.find((x) => x.key === tier.id);
      return `<button data-size="${tier.id}" ${!q.available ? "disabled" : ""} aria-pressed="${state.size === tier.id && !state.exactSize}" class="${state.size === tier.id && !state.exactSize ? "active" : ""}"><strong>${safe(tier.name)}<span class="tier-price">${q.price === null ? french ? "Choisir pour le prix" : "Select for price" : money(q.price)}</span></strong><small>${dim(q.widthCm, q.widthIn)} ${french ? "de largeur" : "wide"}${!q.available ? french ? " \xB7 indisponible" : " \xB7 unavailable" : ""}</small></button>`;
    }).join("");
    all("[data-size]").forEach(
      (b) => b.onclick = () => change({
        size: b.dataset.size,
        exactSize: false,
        widthCm: quote.sizes.find((x) => x.key === b.dataset.size).widthCm,
        position: { ...state.position, scale: 1 }
      })
    );
    const min = quote.minWidthCm, max = quote.maxWidthCm;
    const limits = widthControls(state.unit, state.text, state);
    for (const range of [$("widthSlider"), $("previewWidth")]) {
      range.min = limits.min;
      range.max = limits.max;
      range.step = limits.step;
      range.disabled = limits.min > limits.max;
      range.value = displayWidth(state.widthCm, state.unit);
      range.setAttribute("aria-valuetext", `${displayWidth(state.widthCm, state.unit)} ${state.unit}`);
    }
    $("widthInput").min = limits.min;
    $("widthInput").max = limits.max;
    $("widthInput").step = "any";
    if (!widthEntryInvalid && document.activeElement !== $("widthInput"))
      $("widthInput").value = displayWidth(state.widthCm, state.unit);
    $("widthUnit").textContent = french && state.unit === "in" ? "po" : state.unit;
    $("sizeRange").textContent = `${ui("Available width: ")}${widthBoundaryLabel(min, state.unit, french)} \u2013 ${widthBoundaryLabel(max, state.unit, french)}. ${ui("Height follows your text proportions.")}`;
    $("previewSize").textContent = empty ? `${french ? "Exemple" : "Example"} \xB7 ${state.font}` : `${dim(quote.dimensions.widthCm, quote.dimensions.widthIn)} \xD7 ${dim(quote.dimensions.heightCm || state.heightCm || 0, quote.dimensions.heightIn)} \xB7 ${state.font}`;
    $("addCart").disabled = widthEntryInvalid || !!textIssue || quote.constraints.length > 0 || !["live-api"].includes(quote.status) || !$("proofApproved").checked;
    const checkoutReady = !widthEntryInvalid && !textIssue && root.dataset.previewExample !== "true" && quote.status === "live-api" && $("proofApproved").checked && !checkoutBusy;
    $("ensCheckout").disabled = !checkoutReady;
    $("ensCheckout").textContent = checkoutBusy ? french ? "Connexion\u2026" : "Connecting\u2026" : copy.checkout + (quote.total !== null ? " \xB7 " + money(quote.total) : "") + " \u2192";
    $("nextStep").disabled = checkoutBusy || step === "build" && widthEntryInvalid;
    $("nextStep").textContent = step === "review" ? quote.constraints.length ? copy.quote + " \u2192" : copy.checkout + " \u2192" : step === "design" ? innerWidth < 768 ? french ? "Continuer \u2192" : "Continue \u2192" : french ? "Choisir la fabrication \u2192" : "Choose your build \u2192" : innerWidth < 768 ? french ? "Continuer \u2192" : "Continue \u2192" : french ? "V\xE9rifier le design \u2192" : "Review design \u2192";
    if (step === "review" && innerWidth < 370 && !quote.constraints.length)
      $("nextStep").textContent = french ? "Paiement \u2192" : "Checkout \u2192";
    if (quote.status === "api-error")
      $("nextStep").textContent = french ? "Recalculer \u2192" : "Retry price \u2192";
    $("manufacturingNote").textContent = innerWidth <= 900 && innerHeight <= 740 ? french ? "Maquette apr\xE8s paiement. Production apr\xE8s votre approbation." : "Final proof after checkout. Production only after approval." : copy.proof;
    $("usageNote").textContent = state.usage === "outdoor" ? copy.outdoorTiming : copy.indoorTiming;
    if (quote.apiQuote) {
      root.dataset.quoteId = quote.apiQuote.quoteId;
      root.dataset.totalCents = quote.apiQuote.totalCents;
      state.stripLengthM = quote.apiQuote.stripLengthM;
      $("stripLengthM").value = state.stripLengthM;
    } else {
      delete root.dataset.quoteId;
      delete root.dataset.totalCents;
      $("stripLengthM").value = "";
    }
    renderReview();
    renderPreviewController();
  }
  function dim(cm, inches) {
    return `${state.unit === "in" ? Number(inches ?? cm / 2.54).toFixed(1) : Number(cm).toFixed(0)} ${state.unit === "in" ? french ? "po" : "in" : "cm"}`;
  }
  function summaryRows() {
    return [
      [french ? "Texte" : "Text", state.text],
      [french ? "Police" : "Font", state.font],
      [
        "Light",
        catalog.modes.find((m) => m.id === effectMap[state.effectMode])?.name
      ],
      [french ? "Fabrication" : "Construction", state.specialOutline ? french ? "Contour sp\xE9cial / double ligne" : "Special outline / double-line build" : french ? "N\xE9on standard" : "Standard neon"],
      [
        "Color",
        state.effectMode === "multicolor" ? "Custom per-letter / word colors" : state.effectMode === "rgb" ? ui("RGB Color Changing") : state.colorName
      ],
      [
        "Size",
        `${dim(quote?.dimensions.widthCm || state.widthCm, quote?.dimensions.widthIn)} \xD7 ${dim(quote?.dimensions.heightCm || state.heightCm || 0, quote?.dimensions.heightIn)}`
      ],
      ["Location", state.usage === "outdoor" ? "Outdoor" : "Indoor"],
      [
        "Backing",
        catalog.backboards.find((b) => b.id === state.backboardShape)?.name
      ],
      [
        "Backing color",
        catalog.backboardColors.find((b) => b.id === state.backboardColor)?.name
      ],
      [
        "Mounting",
        state.wallMounting ? state.wallFinish + " wall kit" : "No wall kit"
      ],
      ["Hanging kit", state.hangingKit ? "Yes" : "No"],
      ["Adapter", catalog.adapters.find((a) => a.id === state.adapter)?.name],
      [
        french ? "Maquette" : "Final proof",
        french ? "Approbation requise avant production" : "Approval required before production"
      ],
      [
        french ? "Production et livraison" : "Production and delivery",
        state.usage === "outdoor" ? copy.outdoorTiming : copy.indoorTiming
      ]
    ];
  }
  function renderLiveStatus() {
    const rejected = livePricing.status === "error" && livePricing.errorStatus === 422;
    $("stripRateUsdPerM").value = "";
    state.stripRateUsdPerM = null;
    $("livePricingStatus").textContent = livePricing.status === "ready" ? french ? "Prix confirm\xE9 \xB7 CAD" : "Price confirmed \xB7 CAD" : livePricing.status === "error" && !rejected ? french ? "Prix indisponible \u2014 r\xE9essayez" : "Pricing unavailable \u2014 retry" : livePricing.status === "loading" ? french ? "Calcul du prix\u2026" : "Fetching current price\u2026" : !state.text.trim() ? "" : french ? "Devis personnalis\xE9 requis" : "Custom quote required";
    $("retryPricing").hidden = livePricing.status !== "error" || rejected;
    $("retryStrip").hidden = true;
    $("priceHeading").textContent = french ? "VOTRE ENSEIGNE \xB7 CAD" : "YOUR SIGN \xB7 CAD";
    $("stripMeasurementStatus").textContent = livePricing.result?.stripLengthM > 0 ? (french ? "Longueur calcul\xE9e : " : "Calculated strip length: ") + livePricing.result.stripLengthM.toFixed(4) + " m" : french ? "La mesure sera confirm\xE9e avec le devis." : "Measurement is confirmed with your quote.";
  }
  function renderReview() {
    $("reviewSummary").innerHTML = summaryRows().map(
      ([k, v]) => `<div class="summary-line"><span>${safe(ui(k))}</span><span>${safe(["Text", "Texte", "Font", "Police"].includes(k) ? v : ui(v))}</span></div>`
    ).join("") + `<h3>${ui("Price breakdown")}</h3>` + quote.lineItems.map(
      (i) => `<div class="quote-line"><span>${safe(ui(i.label))}</span><span>${money(i.amount)}</span></div>`
    ).join("");
  }
  function renderPreviewController() {
    const effects = ["rgb", "dynamic"].includes(state.effectMode);
    root.dataset.hasEffects = String(effects);
    if (!effects) previewControl = "size";
    const size = previewControl === "size";
    for (const [id, active] of [
      ["previewSizeTab", size],
      ["previewEffectsTab", !size]
    ]) {
      $(id).classList.toggle("active", active);
      $(id).setAttribute("aria-selected", String(active));
    }
    $("previewEffectsTab").hidden = !effects;
    $("previewTabDivider").hidden = !effects;
    $("previewSizeControls").hidden = !size;
    $("previewEffectControls").hidden = size;
    const range = $("previewWidth");
    range.min = $("widthSlider").min;
    range.max = $("widthSlider").max;
    range.step = $("widthSlider").step;
    range.disabled = $("widthSlider").disabled;
    range.value = $("widthSlider").value;
    $("previewWidthValue").textContent = dim(
      quote.dimensions.widthCm,
      quote.dimensions.widthIn
    );
    $("previewHeightValue").textContent = !state.text.trim() ? "\u2014" : dim(
      quote.dimensions.heightCm || state.heightCm,
      quote.dimensions.heightIn
    );
    $("previewWidthRange").textContent = `${widthBoundaryLabel(quote.minWidthCm, state.unit, french)} \u2013 ${widthBoundaryLabel(quote.maxWidthCm, state.unit, french)}`;
    $("previewTotal").textContent = !state.text.trim() ? copy.pricing : quote.status === "api-loading" ? french ? "Calcul du prix\u2026" : "Updating price\u2026" : quote.total === null ? quote.status === "api-error" ? french ? "Prix indisponible" : "Price unavailable" : copy.quote : `Total ${money(quote.total)} CAD`;
    const presets = state.effectMode === "rgb" ? catalog.rgbEffects : catalog.dynamicEffects, select = $("previewEffectPreset");
    if (select.dataset.mode !== state.effectMode) {
      select.innerHTML = presets.map(
        (e) => `<option value="${safe(e.id)}">${safe(e.category ? e.category + " \xB7 " + e.name : e.name)}</option>`
      ).join("");
      select.dataset.mode = state.effectMode;
    }
    select.value = state.effectPreset;
    const preset = presets.find(
      (e) => String(e.id) === String(state.effectPreset)
    );
    $("previewEffectLabel").textContent = ui(
      state.effectMode === "rgb" ? "RGB color changing" : "Dynamic Neon"
    );
    $("previewEffectDescription").textContent = preset?.desc || "";
    $("previewSpeedField").hidden = preset?.type === "static";
    $("previewEffectSpeed").value = state.effectSpeed;
    $("previewSpeedValue").value = state.effectSpeed;
    $("previewPause").textContent = ui(state.effectPaused ? "Resume" : "Pause");
    $("previewPause").hidden = preset?.type === "static";
  }
  $("previewWidth").oninput = () => change({
    exactSize: true,
    widthCm: Number($("previewWidth").value) * (state.unit === "in" ? 2.54 : 1)
  });
  $("previewEffectPreset").onchange = () => change({ effectPreset: $("previewEffectPreset").value, effectPaused: false });
  $("previewEffectSpeed").oninput = () => change({ effectSpeed: Number($("previewEffectSpeed").value) });
  $("previewPause").onclick = () => change({ effectPaused: !state.effectPaused });
  $("previewPhotos").onclick = () => $("realPhotos").click();
  function renderEffects() {
    const enabled = ["rgb", "dynamic"].includes(state.effectMode);
    $("effectsControls").hidden = !enabled;
    $("multicolorControls").hidden = state.effectMode !== "multicolor";
    $("colorSection").hidden = enabled;
    const presets = state.effectMode === "rgb" ? catalog.rgbEffects : catalog.dynamicEffects;
    const existing = $("effectPreset").dataset.mode;
    if (existing !== state.effectMode) {
      $("effectPreset").innerHTML = presets.map(
        (e) => `<option value="${e.id}">${e.category ? e.category + " \xB7 " : ""}${safe(e.name)}</option>`
      ).join("");
      $("effectPreset").dataset.mode = state.effectMode;
    }
    $("effectPreset").value = state.effectPreset;
    $("effectDescription").textContent = presets.find((e) => e.id === state.effectPreset)?.desc || "Use the speed control to try this effect.";
    $("effectSpeed").value = state.effectSpeed;
    $("pauseEffect").textContent = state.effectPaused ? "Resume animation" : "Pause animation";
    all("[data-mode]").forEach((b) => {
      b.classList.toggle("active", b.dataset.mode === state.effectMode);
      b.setAttribute("aria-pressed", String(b.dataset.mode === state.effectMode));
      b.disabled = false;
      b.title = state.usage === "outdoor" && ["rgb", "dynamic"].includes(b.dataset.mode) ? "Choose this effect to switch the sign to Indoor" : "";
    });
    renderLetterPicker();
  }
  function renderUI() {
    syncInputs();
    renderFonts();
    renderColors();
    renderEffects();
    renderQuote();
    all("[data-align]").forEach((b) => {
      const active = b.dataset.align === state.align;
      b.classList.toggle("active", active);
      b.setAttribute("aria-pressed", String(active));
    });
    const multiline = textMetrics(state.text).extraLines > 0;
    all(".align_wrap").forEach((el) => el.hidden = !multiline);
    all(".text-alignment-actions [data-align]").forEach(
      (el) => el.hidden = !multiline
    );
    all("[data-usage]").forEach(
      (b) => b.classList.toggle("active", b.dataset.usage === state.usage)
    );
    all("[data-unit]").forEach(
      (b) => b.classList.toggle("active", b.dataset.unit === state.unit)
    );
    all("[data-board]").forEach(
      (b) => b.classList.toggle("active", b.dataset.board === state.backboardShape)
    );
    all("[data-boardcolor]").forEach((b) => {
      b.classList.toggle("active", b.dataset.boardcolor === state.backboardColor);
      b.disabled = state.backboardShape === "9" && b.dataset.boardcolor !== "clear";
    });
    all("[data-scene]").forEach(
      (b) => b.classList.toggle("active", b.dataset.scene === state.background)
    );
    $("toggleLight").textContent = state.on ? "Light on" : "Light off";
    $("toggleLight").setAttribute("aria-pressed", state.on);
    $("dimensions").setAttribute("aria-pressed", state.showDimensions);
    $("dimensions").classList.toggle("active", state.showDimensions);
    $("exactSize").checked = state.exactSize;
    $("exactControls").hidden = !state.exactSize;
    $("hangingKit").checked = state.hangingKit;
    $("hangingKit").disabled = ["3", "9"].includes(state.backboardShape);
    $("wallKit").checked = !!state.wallMounting;
    $("wallFinish").disabled = !state.wallMounting;
    $("boardNote").textContent = ["3", "9"].includes(state.backboardShape) ? "Hanging kits are unavailable for this backing." : "";
    $("usagePhoto").hidden = state.usage !== "outdoor";
    $("adapterDetails").hidden = state.adapter !== "6";
    $("adapterDetails").value = state.adapterDetails || "";
    $("reviewWallKit").textContent = state.wallMounting ? "Remove wall mounting kit" : "Add " + state.wallFinish + " wall mounting kit";
    $("previewEffectsTab").hidden = !["rgb", "dynamic"].includes(
      state.effectMode
    );
    $("previewModeName").textContent = catalog.modes.find(
      (m) => m.id === effectMap[state.effectMode]
    )?.name;
    $("usageNote").textContent = state.usage === "outdoor" ? "IP67 adds a waterproof upgrade. RGB and Dynamic Neon are available for indoor signs only." : "Indoor signs should stay dry.";
    $("brightnessValue").textContent = Math.round(state.brightness * 100) + "%";
    all(
      "[data-usage],[data-unit],[data-board],[data-boardcolor],[data-scene]"
    ).forEach(
      (b) => b.setAttribute("aria-pressed", String(b.classList.contains("active")))
    );
  }
  async function change(partial, { history = true } = {}) {
    const patch = sanitizeDesign(partial);
    const sizeEdit = ["widthCm", "size", "exactSize", "unit"].some((key2) => Object.hasOwn(patch, key2));
    if (sizeEdit) clearWidthEntryError();
    state = {
      ...state,
      ...patch,
      proofRequest: true,
      currency: "CAD",
      prioritizeStrip: true
    };
    if (state.backboardShape === "9") {
      state.backboardColor = "clear";
      state.hangingKit = false;
    }
    if (state.backboardShape === "3") state.hangingKit = false;
    const q = computeQuote(
      { ...state, effect: effectMap[state.effectMode] },
      priceCatalog
    );
    Object.assign(state, preserveWidthSelection(state, patch, q.sizes));
    if (sizeEdit) $("widthInput").value = displayWidth(state.widthCm, state.unit);
    const key = JSON.stringify([
      state.text,
      state.font,
      state.color,
      state.letterColors,
      state.wordColors,
      state.widthCm,
      state.effectMode,
      state.usage,
      state.backboardShape,
      state.backboardColor,
      state.wallMounting,
      state.wallFinish,
      state.hangingKit,
      state.adapter,
      state.dimmer,
      state.rush,
      state.specialOutline,
      state.discountCode,
      state.align,
      state.lineHeight
    ]);
    if (key !== lastPriceKey) {
      lastPriceKey = key;
      $("proofApproved").checked = false;
      checkoutKey = null;
      status("");
    }
    if (!started && state.text.trim()) {
      started = true;
      funnel(root, "ens_designer_start");
    }
    renderUI();
    if (editor) await editor.update(state, { history });
  }
  function showStep(next, { userInitiated = false } = {}) {
    if (!["design", "build", "review"].includes(next)) return;
    if (next === "review" && widthEntryInvalid) {
      status($("widthEntryError").textContent);
      $("widthInput").focus();
      return;
    }
    if (next === "design" && widthEntryInvalid) clearWidthEntryError();
    if (next !== "design" && !state.text.trim()) {
      status(french ? "Saisissez votre texte." : "Enter your text first.");
      $("signText").focus();
      funnel(root, "ens_designer_validation_error", { decision_key: "text" });
      return;
    }
    const previous = step;
    step = next;
    all("[data-step]").forEach((b) => {
      b.classList.toggle("active", b.dataset.step === step);
      if (b.dataset.step === step) b.setAttribute("aria-current", "step");
      else b.removeAttribute("aria-current");
    });
    $("designPanel").hidden = step !== "design";
    $("buildPanel").hidden = step !== "build";
    $("reviewPanel").hidden = step !== "review";
    root.querySelector(".config-column").scrollTop = 0;
    renderQuote();
    funnel(root, "ens_designer_step_view", {
      decision_key: step,
      decision_number: step === "design" ? 1 : step === "build" ? 2 : 3
    });
    if (step === "review")
      funnel(root, "ens_designer_summary_view", { sign_use: state.usage });
    if (userInitiated && step !== previous)
      root.dispatchEvent(new CustomEvent("ens:designer-step-change"));
  }
  function syncInputs() {
    $("prioritizeStrip").checked = true;
    $("stripPricingControls").hidden = false;
    $("stripLengthM").value = livePricing.result?.stripLengthM ?? "";
    $("stripRateUsdPerM").value = "";
    $("pricingCurrency").value = "CAD";
    $("localShipping").value = 40;
    $("exchangeRate").value = 1.47;
    for (const [id, key] of [
      ["signText", "text"],
      ["fontSize", "fontSize"],
      ["effectSpeed", "effectSpeed"],
      ["wallFinish", "wallFinish"],
      ["adapter", "adapter"],
      ["discountCode", "discountCode"]
    ])
      if (document.activeElement !== $(id)) $(id).value = state[key];
    $("brightness").value = state.brightness * 100;
    for (const [id, key] of [
      ["dimmer", "dimmer"],
      ["proofRequest", "proofRequest"],
      ["rush", "rush"],
      ["specialOutline", "specialOutline"]
    ])
      $(id).checked = state[key];
  }
  $("modes").innerHTML = catalog.modes.map(
    (m) => `<button data-mode="${modeMap[m.id]}"><strong>${safe(m.name)}</strong><small>${{ "single-color": "One color \xB7 dimmer included", "multi-color": "Color each letter or word", "rgb-color-changing": "Change the whole sign\u2019s color", "dynamic-effects-pack": "Flows, chases and moving light" }[m.id]}</small></button>`
  ).join("");
  all("[data-mode]").forEach(
    (b) => b.onclick = async () => {
      selected = null;
      const requiresIndoor = ["rgb", "dynamic"].includes(b.dataset.mode) && state.usage === "outdoor";
      await change({
        effectMode: b.dataset.mode,
        effectPreset: b.dataset.mode === "rgb" ? "color-change-mode" : "62",
        effectPaused: false,
        ...requiresIndoor ? { usage: "indoor" } : {}
      });
      if (requiresIndoor)
        status(
          "Switched to Indoor: RGB and Dynamic Neon are not available with IP67 outdoor signs."
        );
    }
  );
  $("colors").innerHTML = catalog.colors.map(
    (c) => `<button data-hex="${c.hex}" title="${safe(c.name)}" aria-label="${safe(c.name)}" style="background:${c.hex}"></button>`
  ).join("");
  all("#colors button").forEach(
    (b) => b.onclick = () => colorChange(catalog.colors.find((c) => c.hex === b.dataset.hex))
  );
  $("scenes").innerHTML = catalog.backgrounds.map(
    (b) => `<button type="button" data-scene="${safe(b.file)}" data-scene-thumbnail="${safe(b.thumbnail || b.file)}" title="${safe(b.name)}" aria-label="${safe(b.name)}${french ? " \xB7 d\xE9cor" : " scene"}"></button>`
  ).join("");
  if (typeof IntersectionObserver === "function") {
    const sceneObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries)
          if (entry.isIntersecting) {
            entry.target.style.backgroundImage = `url("${entry.target.dataset.sceneThumbnail}")`;
            sceneObserver.unobserve(entry.target);
          }
      },
      { root: $("scenes"), rootMargin: "80px" }
    );
    all("[data-scene]").forEach((button) => sceneObserver.observe(button));
  } else
    all("[data-scene]").forEach(
      (button) => button.style.backgroundImage = `url("${button.dataset.sceneThumbnail}")`
    );
  all("[data-scene]").forEach(
    (b) => b.onclick = () => change({ background: b.dataset.scene })
  );
  $("backboards").innerHTML = catalog.backboards.map(
    (b) => `<button data-board="${b.id}"><img src="${b.image}" alt="">${safe(b.name)}</button>`
  ).join("");
  all("[data-board]").forEach(
    (b) => b.onclick = () => change({ backboardShape: b.dataset.board })
  );
  $("boardColors").innerHTML = catalog.backboardColors.map(
    (b) => `<button data-boardcolor="${b.id}"><i style="background:${b.hex}"></i>${safe(b.name)}</button>`
  ).join("");
  all("[data-boardcolor]").forEach(
    (b) => b.onclick = () => change({ backboardColor: b.dataset.boardcolor })
  );
  $("wallFinish").innerHTML = catalog.mounting.filter((x) => x.finish).map(
    (m) => `<option value="${m.id}">${safe(m.name)}${m.id === "silver" ? "" : " \xB7 " + ui("separate quote")}</option>`
  ).join("");
  $("adapter").innerHTML = catalog.adapters.map((a) => `<option value="${a.id}">${safe(a.name)}</option>`).join("");
  all("[data-step]").forEach((b) => b.onclick = () => showStep(b.dataset.step, { userInitiated: true }));
  all("[data-align]").forEach(
    (b) => b.onclick = () => change({ align: b.dataset.align })
  );
  all("[data-category]").forEach(
    (b) => b.onclick = () => {
      category = b.dataset.category;
      all("[data-category]").forEach(
        (x) => x.classList.toggle("active", x === b)
      );
      renderFonts();
    }
  );
  all("[data-usage]").forEach(
    (b) => b.onclick = () => change({ usage: b.dataset.usage })
  );
  all("[data-unit]").forEach(
    (b) => b.onclick = () => change({ unit: b.dataset.unit }, { history: false })
  );
  all("[data-color-target]").forEach(
    (b) => b.onclick = () => {
      colorTarget = b.dataset.colorTarget;
      all("[data-color-target]").forEach(
        (x) => x.classList.toggle("active", x === b)
      );
      renderLetterPicker();
      renderColors();
    }
  );
  $("signText").oninput = () => {
    selected = null;
    const text = $("signText").value;
    change({
      text,
      ...minimumWidthIncrease(state, { text }),
      letterColors: {},
      wordColors: {},
      position: { ...state.position, scale: 1 }
    });
  };
  $("fontSearch").oninput = renderFonts;
  $("fontSize").oninput = () => change({ fontSize: +$("fontSize").value });
  $("effectPreset").onchange = () => change({ effectPreset: $("effectPreset").value });
  $("effectSpeed").oninput = () => change({ effectSpeed: +$("effectSpeed").value });
  $("brightness").oninput = () => change({ brightness: +$("brightness").value / 100 });
  $("pauseEffect").onclick = () => change({ effectPaused: !state.effectPaused });
  $("toggleLight").onclick = () => change({ on: !state.on });
  $("dimensions").onclick = () => change({ showDimensions: !state.showDimensions });
  $("resetPosition").onclick = () => change({ position: { x: 0.5, y: 0.5, scale: 1, angle: 0 } });
  $("clearLetterColors").onclick = () => change({ letterColors: {}, wordColors: {} });
  $("exactSize").onchange = () => change({ exactSize: $("exactSize").checked });
  $("widthSlider").oninput = () => change({
    widthCm: +$("widthSlider").value * (state.unit === "in" ? 2.54 : 1),
    exactSize: true,
    position: { ...state.position, scale: 1 }
  });
  $("widthInput").onchange = commitWidthEntry;
  for (const [id, key] of [
    ["wallKit", "wallMounting"],
    ["hangingKit", "hangingKit"],
    ["dimmer", "dimmer"],
    ["proofRequest", "proofRequest"],
    ["rush", "rush"]
  ])
    $(id).onchange = () => change({ [key]: $(id).checked });
  $("wallFinish").onchange = () => change({ wallFinish: $("wallFinish").value });
  $("adapter").onchange = () => change({ adapter: $("adapter").value });
  $("proofApproved").onchange = renderQuote;
  $("specialOutline").onchange = () => {
    const specialOutline = $("specialOutline").checked;
    change({ specialOutline, ...minimumWidthIncrease(state, { specialOutline }) });
  };
  $("pricingCurrency").onchange = () => change({ currency: $("pricingCurrency").value }, { history: false });
  $("localShipping").onchange = () => change({ localShipping: Math.max(0, Number($("localShipping").value) || 0) });
  $("exchangeRate").onchange = () => change({
    exchangeRate: Math.max(0.01, Number($("exchangeRate").value) || 1.47)
  });
  $("prioritizeStrip").onchange = () => change({ prioritizeStrip: $("prioritizeStrip").checked });
  $("stripLengthM").onchange = () => change({
    stripLengthM: Number($("stripLengthM").value) || null,
    stripReferenceWidthCm: state.widthCm
  });
  $("stripRateUsdPerM").onchange = () => change({ stripRateUsdPerM: Number($("stripRateUsdPerM").value) || null });
  $("retryStrip").onclick = () => {
    status("");
    stripKey = "";
    stripError = "";
    measureTextStrip();
    renderQuote();
  };
  $("retryPricing").onclick = () => livePricing.retry();
  $("applyDiscount").onclick = () => status("Discounts require a backend quote.");
  $("nextStep").onclick = () => {
    if (step === "review") {
      renderSaved();
      openDialog("saveDialog");
      return;
    }
    if (step === "design" && !$("textWarning").hidden) {
      status($("textWarning").textContent);
      if (textMetrics(state.text).letterCount > 50 || /[^\u0000-\u024f\u2000-\u206f\r\n]/u.test(state.text))
        openDialog("quoteDialog");
      return;
    }
    showStep(step === "design" ? "build" : "review", { userInitiated: true });
  };
  $("undo").onclick = async () => {
    await editor.undo();
    state = { ...state, ...editor.getState() };
    syncInputs();
    renderUI();
  };
  $("redo").onclick = async () => {
    await editor.redo();
    state = { ...state, ...editor.getState() };
    syncInputs();
    renderUI();
  };
  $("pngExport").onclick = () => download("neon-preview.png", editor.exportPNG(), "image/png");
  $("svgExport").onclick = async () => {
    try {
      let svg = editor.exportSVG();
      const f = catalog.fonts.find((f2) => f2.name === state.font);
      const response = await fetch(f.file);
      const fontData = await readFile(
        new File([await response.blob()], state.font + ".ttf", {
          type: "font/ttf"
        })
      );
      svg = svg.replace(
        /(<svg[^>]*>)/,
        "$1<defs><style>@font-face{font-family:" + safe(state.font) + ";src:url(" + fontData + ") format(truetype)}</style></defs>"
      );
      download("neon-preview.svg", svg, "image/svg+xml");
    } catch (e) {
      status("SVG export failed: " + e.message);
    }
  };
  function readFile(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }
  $("roomUpload").onchange = async () => {
    const f = $("roomUpload").files[0];
    if (!f) return;
    if (f.size > 8e6) {
      status("Choose a room image smaller than 8 MB.");
      return;
    }
    await change({ background: await readFile(f) });
  };
  function designPacket() {
    return {
      schema: "easyneonsigns-design",
      version: 1,
      engine: "Fabric.js 7.4.0",
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      design: clone2(state),
      summary: Object.fromEntries(summaryRows()),
      referenceQuote: clone2(quote),
      bindingQuote: false,
      productionApproved: false,
      notes: [
        "Prices confirmed by EasyNeonSigns. Unsupported options require a custom quote.",
        "Preview backing and manufacturing dimensions are estimates."
      ]
    };
  }
  function renderSaved() {
    const designs = storage.get("atelier-designs", []);
    $("savedCount").textContent = String(designs.length);
    $("savedList").innerHTML = designs.length ? designs.map(
      (d, i) => `<div class="saved-row"><span>${safe(d.name)}</span><div><button type="button" data-load="${i}" aria-label="${safe(ui("Load") + ": " + d.name)}">${ui("Load")}</button><button type="button" data-remove="${i}" aria-label="${safe(ui("Remove") + ": " + d.name)}">${ui("Remove")}</button></div></div>`
    ).join("") : `<p class="save-studio__empty">${ui("No saved designs yet.")}<span>${ui("Save your current design above to keep it here.")}</span></p>`;
    all("[data-load]").forEach(
      (b) => b.onclick = async () => {
        await change(designs[+b.dataset.load].design);
        syncInputs();
        $("saveDialog").close();
        status("Saved design loaded.");
      }
    );
    all("[data-remove]").forEach(
      (b) => b.onclick = () => {
        designs.splice(+b.dataset.remove, 1);
        storage.set("atelier-designs", designs);
        renderSaved();
      }
    );
  }
  var designEmail = createDesignEmail({
    element: root,
    getDesign: () => state,
    getPreview: () => editor.exportPNG({ multiplier: 0.7 }),
    getQuote: () => quote.apiQuote,
    getLanguage: () => french ? "fr" : "en",
    ui
  });
  function saveOpen() {
    renderSaved();
    $("saveStatus").textContent = "";
    openDialog("saveDialog");
    designEmail.restore();
    designEmail.prepare().catch(() => {
    });
  }
  $("saveDesign").onclick = saveOpen;
  $("restore").onclick = saveOpen;
  $("saveLocal").onclick = () => {
    const list = storage.get("atelier-designs", []);
    list.push({
      name: $("designName").value.trim() || ui("My neon sign"),
      design: clone2(state)
    });
    $("saveStatus").textContent = ui(storage.set("atelier-designs", list) ? "Saved in this browser." : "Browser storage is full. Download a design file instead.");
    renderSaved();
  };
  $("jsonExport").onclick = () => download("neon-design.json", designPacket());
  $("jsonImport").onchange = async () => {
    try {
      const file = $("jsonImport").files[0];
      if (!file) return;
      if (file.size > 12e6) throw Error("Choose a design file smaller than 12 MB.");
      const data = JSON.parse(await file.text());
      if (!(data.design && typeof data.design.text === "string"))
        throw Error("This file does not contain a sign design.");
      await change(data.design);
      syncInputs();
      $("saveStatus").textContent = ui("Design imported.");
    } catch (e) {
      $("saveStatus").textContent = ui(e instanceof SyntaxError ? "That file could not be read. Choose a saved EasyNeonSigns design file." : e.message);
    } finally {
      $("jsonImport").value = "";
    }
  };
  function shareURL() {
    const data = { ...state };
    for (const key of [
      "stripRoutes",
      "stripLengthM",
      "stripReferenceWidthCm",
      "stripRateUsdPerM",
      "inkWidthEm"
    ])
      delete data[key];
    if (String(data.background).startsWith("data:"))
      data.background = catalog.backgrounds[0].file;
    return location.origin + location.pathname + "#design=" + encodeURIComponent(JSON.stringify(data));
  }
  $("copyLink").onclick = async () => {
    try {
      await navigator.clipboard.writeText(shareURL());
      $("saveStatus").textContent = ui("Share link copied. Uploaded room images are excluded.");
    } catch {
      $("saveStatus").textContent = ui("Clipboard unavailable. Download a design file instead.");
    }
  };
  $("shareEmail").addEventListener("input", () => {
    if ($("shareEmail").hasAttribute("aria-invalid")) {
      $("shareEmail").removeAttribute("aria-invalid");
      $("saveStatus").textContent = "";
    }
  });
  $("emailDesign").onclick = designEmail.send;
  $("quoteOpen").onclick = () => openDialog("quoteDialog");
  $("logoOpen").onclick = () => openDialog("quoteDialog");
  $("logoUpload").onchange = async () => {
    const file = $("logoUpload").files[0];
    if (!file) return;
    if (file.size > 8e6) {
      $("quoteStatus").textContent = "Choose a file smaller than 8 MB.";
      return;
    }
    attachment = { name: file.name, type: file.type, data: await readFile(file) };
    $("logoPreview").replaceChildren();
    if (/^image\/(png|jpeg|webp)$/.test(file.type)) {
      const img = new Image();
      img.src = attachment.data;
      img.alt = "Uploaded artwork";
      $("logoPreview").append(img);
    }
    const label = document.createElement("p");
    label.className = "small-note";
    label.textContent = "Attached: " + file.name;
    $("logoPreview").append(label);
  };
  $("quoteForm").onsubmit = (e) => {
    e.preventDefault();
    const form = Object.fromEntries(new FormData(e.target));
    const packet = {
      ...designPacket(),
      kind: "quote-request",
      contact: form,
      artwork: attachment,
      previewPNG: editor.exportPNG({ multiplier: 1 })
    };
    download("neon-quote-request.json", packet);
    $("quoteStatus").textContent = french ? "D\xE9tails t\xE9l\xE9charg\xE9s comme r\xE9f\xE9rence. Utilisez le lien ci-dessus pour envoyer une demande; rien n\u2019a \xE9t\xE9 envoy\xE9 automatiquement." : "Design details downloaded for reference. Use the link above to send a request; nothing was sent automatically.";
  };
  var photoIndex = 0;
  var photoGallery = [];
  function photo(file, title, gallery = [{ file, title }]) {
    photoGallery = gallery.map((p) => ({ file: asset(p.file), title: p.title || p.name + " in real life" }));
    photoIndex = Math.max(0, photoGallery.findIndex((p) => p.file === asset(file)));
    for (const id of ["photoPrev", "photoNext"]) $(id).hidden = photoGallery.length < 2;
    $("photoImage").src = file;
    $("photoTitle").textContent = title;
    openDialog("photoDialog");
  }
  $("realPhotos").onclick = () => {
    const c = catalog.colors.find((c2) => c2.hex === selectedPalette()) || catalog.colors.find((c2) => c2.hex === state.color) || catalog.colors.find((c2) => c2.name === state.colorName) || catalog.colors[1];
    const p = catalog.colorPhotos.find((p2) => p2.name === c.name) || catalog.colorPhotos[0];
    photo(p.file, c.name + " in real life", catalog.colorPhotos);
  };
  $("boardExamples").onclick = () => photo(
    "assets/examples/" + state.backboardColor + "us.jpg",
    "Backing: " + state.backboardColor,
    catalog.backboardColors.map((b) => ({ file: "assets/examples/" + b.id + "us.jpg", title: ui("Backing") + ": " + b.name }))
  );
  $("coverageOpen").onclick = () => openDialog("coverageDialog");
  $("previewSizeTab").onclick = () => {
    previewControl = "size";
    renderPreviewController();
  };
  $("previewEffectsTab").onclick = () => {
    previewControl = "effects";
    renderPreviewController();
  };
  $("reviewWallKit").onclick = () => change({ wallMounting: !state.wallMounting });
  $("adapterDetails").onchange = () => change({ adapterDetails: $("adapterDetails").value });
  $("copyDiscount").onclick = async () => {
    try {
      await navigator.clipboard.writeText($("discountCode").value);
      status("Offer code copied.");
    } catch {
      status("Select the offer code to copy it.");
    }
  };
  $("wallPhoto").onclick = () => photo(
    "assets/examples/" + state.wallFinish + "kitus.jpg",
    "Wall mounting kit",
    catalog.mounting.filter((m) => m.finish).map((m) => ({ file: "assets/examples/" + m.finish + "kitus.jpg", title: m.name }))
  );
  $("hangingPhoto").onclick = () => photo("assets/examples/hangingkitus.jpg", "Sign hanging kit");
  $("remotePhoto").onclick = () => photo("assets/examples/remotedimmerus.png", "Remote and dimmer");
  $("usagePhoto").onclick = () => photo("assets/examples/ip67us.jpg", "IP67 waterproof technology");
  for (const [id, delta] of [
    ["photoPrev", -1],
    ["photoNext", 1]
  ])
    $(id).onclick = () => {
      if (photoGallery.length < 2) return;
      photoIndex = (photoIndex + delta + photoGallery.length) % photoGallery.length;
      const p = photoGallery[photoIndex];
      $("photoTitle").textContent = p.title;
      $("photoImage").src = p.file;
    };
  function renderCart() {
    const items = storage.get("atelier-cart", []);
    $("cartCount").textContent = items.reduce((a, x) => a + (x.quantity || 1), 0);
    $("cartDesignCount").textContent = french ? `${items.length} cr\xE9ation${items.length === 1 ? "" : "s"}` : `${items.length} design${items.length === 1 ? "" : "s"}`;
    $("cartEmpty").hidden = Boolean(items.length);
    $("cartItems").hidden = !items.length;
    $("cartDownloadHint").hidden = Boolean(items.length);
    $("cartItems").innerHTML = items.length ? items.map(
      (x, i) => `<article class="cart-row"><div class="bag-studio__preview"><img src="${safe(x.preview)}" alt="${ui("Saved sign preview")}"></div><div class="bag-studio__details"><strong>${safe(x.design.text)}</strong><p>${safe(x.design.font)} \xB7 ${safe(x.design.widthCm)} cm</p><p class="bag-studio__price-note">${savedQuoteAmount(x.referenceQuote) !== null ? ui("Saved estimate") + ": " + money(savedQuoteAmount(x.referenceQuote), "CAD") + " " + ui("each") + ". " + ui("Repriced before checkout.") : ui("Needs live repricing")}</p><label class="bag-studio__quantity">${ui("Quantity")}<input data-qty="${i}" type="number" min="1" max="99" value="${x.quantity || 1}" aria-label="${safe(ui("Quantity for ") + x.design.text)}"></label></div><div class="bag-studio__item-actions"><button type="button" data-cartedit="${i}" aria-label="${safe(ui("Edit / reprice") + ": " + x.design.text)}">${ui("Edit / reprice")}<span aria-hidden="true">\u2192</span></button><button type="button" data-cartremove="${i}" aria-label="${safe(ui("Remove") + ": " + x.design.text)}">${ui("Remove")}</button></div></article>`
    ).join("") : "";
    all("[data-cartremove]").forEach(
      (b) => b.onclick = () => {
        items.splice(+b.dataset.cartremove, 1);
        storage.set("atelier-cart", items);
        renderCart();
      }
    );
    all("[data-qty]").forEach(
      (b) => b.onchange = () => {
        items[+b.dataset.qty].quantity = Math.max(
          1,
          Math.min(99, Math.round(+b.value) || 1)
        );
        storage.set("atelier-cart", items);
        renderCart();
      }
    );
    all("[data-cartedit]").forEach(
      (b) => b.onclick = async () => {
        editingCartId = items[+b.dataset.cartedit].createdAt;
        await change(items[+b.dataset.cartedit].design);
        syncInputs();
        $("cartDialog").close();
        showStep("review", { userInitiated: true });
        status(
          "Live quote refreshed. Approve the design before adding the updated item."
        );
      }
    );
    $("checkoutPacket").disabled = !items.length || items.some(
      (x) => x.referenceQuote.pricingProvider !== "basement-2 neon-pricing API"
    );
  }
  $("openCart").onclick = () => {
    renderCart();
    openDialog("cartDialog");
  };
  $("cartResume").onclick = () => {
    $("cartDialog").close();
    showStep("design", { userInitiated: true });
    $("signText").focus({ preventScroll: true });
  };
  $("addCart").onclick = () => {
    if (!$("proofApproved").checked || quote.constraints.length || quote.status !== "live-api" || !$("textWarning").hidden) {
      status("Review the design and correct the highlighted requirements first.");
      return;
    }
    const items = storage.get("atelier-cart", []);
    const packet = {
      ...designPacket(),
      quantity: 1,
      preview: editor.exportPNG({ multiplier: 0.5 })
    };
    const editIndex = editingCartId ? items.findIndex((x) => x.createdAt === editingCartId) : -1;
    if (editIndex >= 0) {
      packet.quantity = items[editIndex].quantity || 1;
      items[editIndex] = packet;
    } else items.push(packet);
    editingCartId = null;
    if (!storage.set("atelier-cart", items)) {
      status("Browser storage is full. Download an order packet instead.");
      return;
    }
    renderCart();
    openDialog("cartDialog");
  };
  $("downloadOrder").onclick = () => {
    if (quote.status !== "live-api" || quote.constraints.length || quote.total === null) {
      status(
        "A current complete backend quote is required before downloading an order request."
      );
      return;
    }
    if (!$("proofApproved").checked) {
      status("Check the design approval box before downloading an order packet.");
      return;
    }
    download("neon-order-request.json", {
      ...designPacket(),
      kind: "order-request",
      approved: true,
      previewPNG: editor.exportPNG({ multiplier: 1 })
    });
  };
  $("checkoutPacket").onclick = () => download("neon-checkout-request.json", {
    kind: "local-checkout-request",
    items: storage.get("atelier-cart", []),
    paymentProcessed: false,
    fulfillmentRequested: false
  });
  function sanitizeDesign(input = {}) {
    const result = {};
    const strings = { text: 200, discountCode: 80, adapterDetails: 300 };
    for (const [key, max] of Object.entries(strings))
      if (Object.hasOwn(input, key))
        result[key] = String(input[key] ?? "").slice(0, max);
    const choices = {
      font: catalog.fonts.map((f) => f.name),
      effectMode: ["single", "multicolor", "rgb", "dynamic"],
      align: ["left", "center", "right"],
      usage: ["indoor", "outdoor"],
      backboardShape: catalog.backboards.map((x) => x.id),
      backboardColor: catalog.backboardColors.map((x) => x.id),
      adapter: catalog.adapters.map((x) => x.id),
      wallFinish: ["silver", "gold", "black"],
      unit: ["cm", "in"],
      size: catalog.sizes.map((x) => x.id),
      effectPreset: [...catalog.dynamicEffects, ...catalog.rgbEffects].map(
        (x) => String(x.id)
      )
    };
    for (const [key, values] of Object.entries(choices))
      if (Object.hasOwn(input, key) && values.includes(String(input[key])))
        result[key] = String(input[key]);
    for (const key of [
      "exactSize",
      "on",
      "effectPaused",
      "showDimensions",
      "wallMounting",
      "hangingKit",
      "dimmer",
      "rush",
      "specialOutline"
    ])
      if (typeof input[key] === "boolean") result[key] = input[key];
    for (const [key, min, max] of [
      ["fontSize", 30, 180],
      ["lineHeight", 0.8, 3],
      ["brightness", 0, 1],
      ["effectSpeed", 1, 10],
      ["widthCm", 1, 500]
    ])
      if (Object.hasOwn(input, key) && Number.isFinite(Number(input[key])))
        result[key] = Math.max(min, Math.min(max, Number(input[key])));
    if (/^#[\da-f]{6}$/i.test(input.color || "")) {
      result.color = String(input.color).toLowerCase();
      result.colorName = catalog.colors.find((c) => c.hex.toLowerCase() === result.color)?.name || "Custom";
    }
    for (const key of ["letterColors", "wordColors"])
      if (input[key] && typeof input[key] === "object")
        result[key] = Object.fromEntries(
          Object.entries(input[key]).filter(
            ([i, color]) => /^\d{1,3}$/.test(i) && Number(i) < 200 && /^#[\da-f]{6}$/i.test(color)
          ).map(([i, color]) => [i, String(color).toLowerCase()])
        );
    if (input.position && typeof input.position === "object") {
      result.position = {};
      for (const [key, min, max] of [
        ["x", 0, 1],
        ["y", 0, 1],
        ["scale", 0.1, 8],
        ["angle", -360, 360]
      ])
        if (Number.isFinite(Number(input.position[key])))
          result.position[key] = Math.max(
            min,
            Math.min(max, Number(input.position[key]))
          );
    }
    if (typeof input.background === "string") {
      const value = asset(input.background);
      if (trustedBackgrounds.has(value) || /^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/.test(value) && value.length < 11e6)
        result.background = value;
    }
    return result;
  }
  var sourceRenderUI = renderUI;
  renderUI = function() {
    sourceRenderUI();
    if (french) $("resetPosition").textContent = "Recentrer";
    $("usageNote").textContent = state.usage === "outdoor" ? copy.outdoorTiming : copy.indoorTiming;
    $("proofRequest").checked = true;
    if (french) {
      for (const id of [
        "toggleLight",
        "pauseEffect",
        "previewPause",
        "previewEffectLabel",
        "reviewWallKit"
      ])
        $(id).textContent = ui($(id).textContent);
    }
  };
  $("applyDiscount").onclick = async () => {
    const code = $("discountCode").value.trim().toUpperCase();
    if (!code) {
      status(
        french ? "Saisissez un code de r\xE9duction." : "Enter a discount code."
      );
      return;
    }
    $("applyDiscount").disabled = true;
    try {
      const response = await authenticated("/apply-discount", {
        method: "POST",
        body: JSON.stringify({ discount_code: code })
      });
      if (response.success !== true)
        throw Error(response.message || "This code is not available.");
      await change({ discountCode: code });
      status(
        french ? "Code v\xE9rifi\xE9. Le prix est recalcul\xE9." : "Code checked. Updating your price."
      );
    } catch (error) {
      $("discountCode").value = state.discountCode;
      status(
        french ? "Ce code est indisponible. Votre prix reste inchang\xE9." : "This code is unavailable. Your current price is unchanged."
      );
    } finally {
      $("applyDiscount").disabled = false;
    }
  };
  async function checkout() {
    if (checkoutBusy) return;
    if (widthEntryInvalid) {
      showStep("build", { userInitiated: true });
      $("widthInput").focus();
      return;
    }
    renderQuote();
    if (quote.constraints.length) {
      status(quote.constraints.join(" "));
      openDialog("quoteDialog");
      return;
    }
    if (quote.status !== "live-api" || !livePricing.result) {
      status(
        french ? "Attendez la confirmation du prix." : "Wait for your confirmed price before continuing."
      );
      return;
    }
    if (!$("proofApproved").checked) {
      status(
        french ? "V\xE9rifiez les d\xE9tails et cochez la case de confirmation." : "Check your design details and select the confirmation box."
      );
      $("proofApproved").focus({ preventScroll: true });
      const reviewBounds = $("reviewPanel").getBoundingClientRect();
      const proofBounds = $("proofApproved").closest("label").getBoundingClientRect();
      if (proofBounds.top < reviewBounds.top || proofBounds.bottom > reviewBounds.bottom)
        $("reviewPanel").scrollTop += proofBounds.top - reviewBounds.top - 12;
      root.dispatchEvent(new CustomEvent("ens:designer-approval-required"));
      return;
    }
    const priced = livePricing.result;
    if (!root.dispatchEvent(
      new CustomEvent("ens:before-checkout", {
        bubbles: true,
        cancelable: true,
        detail: {
          quoteId: priced.quoteId,
          fontFamily: state.font,
          colorMode: state.effectMode,
          signUse: state.usage,
          widthInches: priced.widthInches
        }
      })
    ))
      return;
    checkoutBusy = true;
    renderQuote();
    try {
      const payload = await checkoutPayload(root, state, priced, editor);
      checkoutKey || (checkoutKey = nonce());
      funnel(root, "ens_designer_checkout_start", {
        sign_use: state.usage,
        color_mode: state.effectMode
      });
      const data = await authenticated("/create-draft-order", {
        method: "POST",
        headers: { "X-Idempotency-Key": checkoutKey },
        body: JSON.stringify(payload)
      });
      window.location.assign(allowedCheckout(root, data.checkout_url));
    } catch (error) {
      if (error.code === "designer_price_changed" || error.code === "quote_expired") {
        livePricing.retry();
        $("proofApproved").checked = false;
        status(
          french ? "Le prix a chang\xE9. V\xE9rifiez le nouveau prix avant de continuer." : "The price changed. Review the refreshed price before continuing."
        );
      } else
        status(
          french ? "Le paiement n\u2019a pas pu s\u2019ouvrir. R\xE9essayez ou contactez-nous." : "Checkout could not open. Please retry or contact us."
        );
    } finally {
      checkoutBusy = false;
      renderQuote();
    }
  }
  $("ensCheckout").onclick = checkout;
  $("proofApproved").onchange = () => {
    status("");
    confirmedTotal = $("proofApproved").checked ? livePricing.result?.totalCents : null;
    renderQuote();
  };
  for (const action of ["undo", "redo"])
    $(action).onclick = async () => {
      clearWidthEntryError();
      await editor[action]();
      state = {
        ...state,
        ...sanitizeDesign(editor.getState()),
        proofRequest: true
      };
      $("proofApproved").checked = false;
      confirmedTotal = null;
      checkoutKey = null;
      renderUI();
    };
  $("nextStep").onclick = () => {
    if (quote.status === "api-error") return livePricing.retry();
    if (step === "review") return checkout();
    showStep(step === "design" ? "build" : "review", { userInitiated: true });
  };
  var sourcePhoto = photo;
  photo = function(file, title, gallery) {
    sourcePhoto(asset(file), title, gallery);
  };
  root.querySelector(".reference-quote-live").addEventListener("click", (event) => {
    try {
      const context = quoteContext(state, summaryRows());
      sessionStorage.setItem(QUOTE_CONTEXT_KEY, JSON.stringify(context));
      if (!sessionStorage.getItem(QUOTE_CONTEXT_KEY)) throw Error("Storage unavailable");
      const link = event.currentTarget;
      const url = new URL(link.href);
      url.searchParams.set("designer_quote", context.id);
      link.href = url.href;
    } catch (_) {
      event.preventDefault();
      $("quoteStatus").textContent = french ? "Votre navigateur ne permet pas le transfert. T\xE9l\xE9chargez les d\xE9tails comme r\xE9f\xE9rence et copiez vos choix dans le formulaire de devis." : "Your browser cannot transfer this design. Download the details for reference and copy your choices into the quote form.";
    }
  });
  var sourceDesignPacket = designPacket;
  designPacket = function() {
    const packet = sourceDesignPacket();
    packet.schema = "easyneonsigns-design";
    packet.design = sanitizeDesign(state);
    packet.notes = [
      "Final digital proof and approval required before production.",
      "Production: indoor 13 business days; outdoor 20 business days after approval. Delivery: 1\u20133 business days.",
      "Preview effects and unsupported construction options require team confirmation."
    ];
    return packet;
  };
  var sourceRenderCart = renderCart;
  renderCart = function() {
    sourceRenderCart();
    $("checkoutPacket").disabled = !storage.get("atelier-cart", []).length;
  };
  $("dimmer").disabled = true;
  $("proofRequest").disabled = true;
  root.addEventListener(
    "input",
    (event) => {
      if (!checkoutBusy) return;
      if (event.target.closest(".step-panel")) event.preventDefault();
    },
    true
  );
  window.neonApp = {
    getState: () => clone2(state),
    getQuote: () => clone2(quote),
    catalog,
    change,
    livePricing,
    editor: null,
    showStep,
    designPacket,
    checkoutPayload: () => checkoutPayload(root, state, livePricing.result, editor)
  };
  function setupViewportLayout() {
    const module = root.querySelector(".atelier");
    const visual = window.visualViewport;
    const phone = matchMedia("(max-width: 900px)");
    const shortLandscape = matchMedia("(max-width: 1100px) and (max-height: 650px) and (orientation: landscape)");
    const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
    const desktop = () => !phone.matches && !shortLandscape.matches;
    const headers = [...document.querySelectorAll('header,[role="banner"],#shopify-section-header')].filter((node) => !root.contains(node));
    let entered = false, metricsFrame = 0, reconcileFrame = 0, stepRecoveryFrame = 0, entryMotion = false, focusEntry = null;
    let baselineHeight = Math.max(innerHeight, document.documentElement.clientHeight);
    const editable = (node) => node instanceof HTMLElement && module.contains(node) && node.matches('textarea,select,input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([readonly]):not([disabled])');
    const viewport = () => {
      const height = Math.max(1, Math.min(innerHeight, visual?.height || innerHeight));
      return { top: visual?.offsetTop || 0, height, bottom: (visual?.offsetTop || 0) + height };
    };
    const occlusion = (view) => Math.max(0, ...headers.map((node) => {
      const style = getComputedStyle(node), rect = node.getBoundingClientRect();
      if (node.closest(".shopify-section-header-hidden") || !["fixed", "sticky"].includes(style.position) || style.visibility === "hidden" || Number(style.opacity) === 0) return 0;
      return rect.top <= view.top + 1 && rect.bottom > view.top && rect.height < view.height * 0.5 ? rect.bottom - view.top : 0;
    }));
    const metrics = () => {
      const view = viewport(), inputActive = editable(document.activeElement);
      if (!inputActive) baselineHeight = Math.max(innerHeight, view.height);
      const keyboard = phone.matches && inputActive && baselineHeight - view.height > 120;
      root.classList.toggle("is-keyboard-open", keyboard);
      root.dataset.keyboardField = keyboard ? document.activeElement.id || "input" : "";
      const inset = Math.ceil(occlusion(view));
      root.style.setProperty("--ens-reference-viewport-height", `${Math.floor(view.height)}px`);
      root.style.setProperty("--ens-reference-top-inset", `${inset}px`);
      root.dataset.viewportHeight = String(Math.floor(view.height));
      root.dataset.topOcclusion = String(inset);
      root.dataset.reducedEntry = String(desktop() && reducedMotion.matches);
      root.style.setProperty("--ens-reference-entry-top", `${Math.ceil(Math.max(inset + 12, module.getBoundingClientRect().top - view.top))}px`);
      return { ...view, inset, edge: keyboard ? 4 : shortLandscape.matches ? 5 : phone.matches ? 6 : 12 };
    };
    const align = (force = false) => {
      const view = metrics(), rect = module.getBoundingClientRect();
      const top = view.top + view.inset + view.edge;
      if (!force && rect.top >= top - 3 && rect.bottom <= view.bottom - view.edge + 3) return false;
      const delta = rect.top - top;
      if (Math.abs(delta) < 3) return false;
      window.scrollTo({ top: Math.max(0, window.scrollY + delta), left: window.scrollX, behavior: "instant" });
      return true;
    };
    const cancelFocus = () => {
      focusEntry = null;
      cancelAnimationFrame(reconcileFrame);
      reconcileFrame = 0;
      cancelAnimationFrame(stepRecoveryFrame);
      stepRecoveryFrame = 0;
      if (entryMotion) {
        entryMotion = false;
        window.scrollTo({ top: window.scrollY, left: window.scrollX, behavior: "instant" });
      }
    };
    root.addEventListener("ens:designer-step-change", () => {
      cancelFocus();
      if (!phone.matches && !shortLandscape.matches) return;
      stepRecoveryFrame = requestAnimationFrame(() => {
        stepRecoveryFrame = requestAnimationFrame(() => {
          stepRecoveryFrame = 0;
          const view = metrics();
          if (stepPreviewNeedsRecovery({
            compact: phone.matches || shortLandscape.matches,
            keyboardOpen: root.classList.contains("is-keyboard-open"),
            canvasRect: $("neonCanvas").getBoundingClientRect(),
            canvasSize: editor?.canvas,
            ink: editor?.sign ? editor.getSignBounds() : null,
            viewport: view,
            inset: view.inset
          })) align(false);
        });
      });
    });
    root.addEventListener("ens:designer-approval-required", () => {
      cancelFocus();
      if (desktop()) return;
      stepRecoveryFrame = requestAnimationFrame(() => {
        stepRecoveryFrame = requestAnimationFrame(() => {
          stepRecoveryFrame = 0;
          const view = metrics(), button = $("nextStep").getBoundingClientRect();
          if (root.classList.contains("is-keyboard-open")) return;
          if (button.top < view.top + view.inset || button.bottom > view.bottom)
            align(false);
        });
      });
    });
    const reconcile = () => {
      cancelAnimationFrame(reconcileFrame);
      reconcileFrame = requestAnimationFrame(() => {
        reconcileFrame = requestAnimationFrame(() => {
          reconcileFrame = 0;
          if (!focusEntry || focusEntry.corrected || performance.now() > focusEntry.until || document.activeElement !== focusEntry.target) return;
          if (!desktop() && align(false)) focusEntry.corrected = true;
          const panel = focusEntry.target.closest(".step-panel");
          if (panel) {
            const field = focusEntry.target.getBoundingClientRect(), bounds = panel.getBoundingClientRect();
            if (field.top < bounds.top + 6 || field.bottom > bounds.bottom - 6) panel.scrollTop += field.top - bounds.top - 6;
          }
        });
      });
    };
    const update = () => {
      if (metricsFrame) return;
      metricsFrame = requestAnimationFrame(() => {
        metricsFrame = 0;
        metrics();
        if (focusEntry && !focusEntry.corrected && performance.now() <= focusEntry.until) reconcile();
      });
    };
    const enter = () => {
      if (entered) return;
      entered = true;
      root.dataset.viewportAligned = desktop() && reducedMotion.matches ? "in-place" : "true";
      const view = metrics();
      if (desktop() && reducedMotion.matches) return;
      if (desktop()) {
        entryMotion = true;
        window.scrollTo({ top: Math.max(0, window.scrollY + module.getBoundingClientRect().top - view.top - view.edge), left: window.scrollX, behavior: "smooth" });
        return;
      }
      window.scrollTo({ top: Math.max(0, window.scrollY + module.getBoundingClientRect().top - view.top - view.edge), left: window.scrollX, behavior: "instant" });
      requestAnimationFrame(() => requestAnimationFrame(() => align(true)));
    };
    root.addEventListener("pointerdown", (event) => {
      cancelFocus();
      if (!module.contains(event.target)) return;
      if (!entered && !editable(event.target)) return;
      enter();
      if (!editable(event.target) || event.target === document.activeElement) return;
      const view = viewport(), rect = module.getBoundingClientRect();
      if (rect.top < view.top - 48 || rect.top > view.top + view.height * 0.45) return;
      focusEntry = { target: event.target, until: performance.now() + 900, corrected: false };
      event.target.focus({ preventScroll: true });
    }, true);
    root.addEventListener("focusin", (event) => {
      if (!module.contains(event.target)) return;
      if (!entered && !editable(event.target)) return;
      enter();
      if (!editable(event.target)) return;
      if (!focusEntry || focusEntry.target !== event.target) {
        const view = viewport(), rect = module.getBoundingClientRect();
        if (!module.contains(event.relatedTarget) && (rect.top < view.top - 48 || rect.top > view.top + view.height * 0.45)) return;
        focusEntry = { target: event.target, until: performance.now() + 900, corrected: false };
      }
      update();
      reconcile();
    });
    root.addEventListener("click", (event) => {
      if (module.contains(event.target) || event.composedPath?.().includes(module)) enter();
    });
    root.addEventListener("focusout", update);
    window.addEventListener("wheel", cancelFocus, { passive: true });
    window.addEventListener("touchmove", cancelFocus, { passive: true });
    window.addEventListener("keydown", (event) => {
      if (["PageUp", "PageDown", "Home", "End", "Escape"].includes(event.key)) cancelFocus();
    });
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("scrollend", () => {
      entryMotion = false;
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    visual?.addEventListener("resize", update, { passive: true });
    visual?.addEventListener("scroll", update, { passive: true });
    reducedMotion.addEventListener?.("change", update);
    const headerObserver = new MutationObserver(update);
    for (const header of headers) headerObserver.observe(header, { attributes: true, attributeFilter: ["class", "style"] });
    root.style.removeProperty("--ens-reference-module-height");
    metrics();
    if (phone.matches && canAutoEnterDesigner(location.hash, root.dataset.sharedDesignRestored === "true") && window.scrollY < 4 && performance.getEntriesByType("navigation")[0]?.type !== "back_forward") requestAnimationFrame(enter);
  }
  async function init() {
    for (const id of ["roomUpload", "jsonImport"]) {
      const input = $(id), label = input.closest("label");
      label.tabIndex = 0;
      label.setAttribute("role", "button");
      label.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          input.click();
        }
      });
    }
    const tools = document.createElement("details");
    tools.className = "reference-preview-tools";
    const toolsSummary = document.createElement("summary");
    toolsSummary.textContent = french ? "Enregistrer, partager et aide" : "Save, share & help";
    const toolsPanel = document.createElement("div");
    toolsPanel.className = "reference-preview-tools__panel";
    tools.append(toolsSummary, toolsPanel);
    root.querySelector(".preview-column").append(tools);
    toolsPanel.append(
      root.querySelector(".preview-footer"),
      root.querySelector(".help-line")
    );
    const shortPhone = matchMedia(
      "(max-width: 900px) and (max-height: 740px) and (orientation: portrait)"
    );
    const setTools = () => {
      tools.open = !shortPhone.matches;
      if (shortPhone.matches) tools.before($("previewConstruction"));
      else $("previewSize").after($("previewConstruction"));
    };
    setTools();
    shortPhone.addEventListener?.("change", setTools);
    await new Promise((resolve, reject) => {
      if (window.fabric) resolve();
      else {
        let n = 0;
        const i = setInterval(() => {
          if (window.fabric) {
            clearInterval(i);
            resolve();
          } else if (++n > 100) {
            clearInterval(i);
            reject(Error("The editor library could not load. Reload the page."));
          }
        }, 50);
      }
    });
    editor = new NeonEditor($("neonCanvas"), {
      onChange: (s, meta) => {
        if (!ready) return;
        if (meta.source === "background" && meta.error) {
          status("That background could not load.");
          return;
        }
        state = {
          ...state,
          aspectRatio: s.aspectRatio,
          heightCm: s.heightCm,
          inkWidthEm: s.inkWidthEm,
          position: s.position
        };
        measureTextStrip();
        renderQuote();
      },
      onSelect: (char) => {
        selected = char;
        renderLetterPicker();
        renderColors();
        $("selectionHint").textContent = colorTarget === "word" ? `Selected: ${char.word}` : `Selected: ${char.char}`;
      }
    });
    window.neonApp.editor = editor;
    try {
      if (location.hash.startsWith("#design=")) {
        if (location.hash.length > 24e3) throw Error("Link too large.");
        const d = JSON.parse(decodeURIComponent(location.hash.slice(8)));
        state = { ...state, ...sanitizeDesign(d) };
        root.dataset.sharedDesignRestored = "true";
      }
    } catch {
      status("The shared design link could not be read.");
    }
    ready = true;
    await change(state, { history: false });
    syncInputs();
    const resize = () => {
      const shell = $("canvasShell"), w = shell.clientWidth, h = shell.clientHeight;
      if (w > 0 && h > 0 && (Math.abs(editor.canvas.width - w) > 1 || Math.abs(editor.canvas.height - h) > 1))
        editor.resize(w, h);
    };
    resize();
    new ResizeObserver(resize).observe($("canvasShell"));
    $("loading").hidden = true;
    renderCart();
    renderUI();
    root.dataset.ready = "true";
    setupViewportLayout();
    all("[data-step]")[0].setAttribute("aria-current", "step");
    funnel(root, "ens_designer_view");
    funnel(root, "ens_designer_step_view", {
      decision_key: "design",
      decision_number: 1
    });
  }
  init().catch((e) => {
    $("loading").textContent = "The editor could not start: " + e.message;
    console.error(e);
  });
})();
